var map = {
	"./modules/accounting/banking/Banking": [
		98105,
		9,
		98105
	],
	"./modules/accounting/banking/Banking.tsx": [
		98105,
		9,
		98105
	],
	"./modules/accounting/banking/tables/AccountsTable": [
		30753,
		9,
		30753
	],
	"./modules/accounting/banking/tables/AccountsTable.tsx": [
		30753,
		9,
		30753
	],
	"./modules/accounting/banking/tables/ChequesTable": [
		35997,
		9,
		35997
	],
	"./modules/accounting/banking/tables/ChequesTable.tsx": [
		35997,
		9,
		35997
	],
	"./modules/accounting/banking/tables/RegisterTable": [
		14440,
		9,
		14440
	],
	"./modules/accounting/banking/tables/RegisterTable.tsx": [
		14440,
		9,
		14440
	],
	"./modules/accounting/chart-of-accounts/AddChartAccount": [
		71118,
		9,
		71118
	],
	"./modules/accounting/chart-of-accounts/AddChartAccount.tsx": [
		71118,
		9,
		71118
	],
	"./modules/accounting/chart-of-accounts/ChartAccountTable": [
		34321,
		9,
		34321
	],
	"./modules/accounting/chart-of-accounts/ChartAccountTable.tsx": [
		34321,
		9,
		34321
	],
	"./modules/accounting/chart-of-accounts/ChartsOfAccount": [
		42939,
		9,
		42939
	],
	"./modules/accounting/chart-of-accounts/ChartsOfAccount.tsx": [
		42939,
		9,
		42939
	],
	"./modules/accounting/chart-of-accounts/data/accountData": [
		21792,
		9,
		21792
	],
	"./modules/accounting/chart-of-accounts/data/accountData.ts": [
		21792,
		9,
		21792
	],
	"./modules/accounting/dashboard/Acc_Dashboard": [
		14651,
		9,
		22019,
		48969,
		85167,
		14651
	],
	"./modules/accounting/dashboard/Acc_Dashboard.tsx": [
		14651,
		9,
		22019,
		48969,
		85167,
		14651
	],
	"./modules/accounting/dashboard/components/chart/DonutChart": [
		18877,
		9,
		22019,
		48969,
		85167,
		18877
	],
	"./modules/accounting/dashboard/components/chart/DonutChart.tsx": [
		18877,
		9,
		22019,
		48969,
		85167,
		18877
	],
	"./modules/accounting/dashboard/components/chart/EChart": [
		70764,
		9,
		22019,
		70764
	],
	"./modules/accounting/dashboard/components/chart/EChart.js": [
		70764,
		9,
		22019,
		70764
	],
	"./modules/accounting/dashboard/components/chart/LineChart": [
		86291,
		9,
		22019,
		86291
	],
	"./modules/accounting/dashboard/components/chart/LineChart.tsx": [
		86291,
		9,
		22019,
		86291
	],
	"./modules/accounting/dashboard/components/chart/PieChart": [
		21067,
		9,
		22019,
		21067
	],
	"./modules/accounting/dashboard/components/chart/PieChart.tsx": [
		21067,
		9,
		22019,
		21067
	],
	"./modules/accounting/dashboard/components/chart/configs/eChart": [
		72664,
		9,
		72664
	],
	"./modules/accounting/dashboard/components/chart/configs/eChart.js": [
		72664,
		9,
		72664
	],
	"./modules/accounting/dashboard/components/chart/configs/lineChart": [
		98375,
		9,
		98375
	],
	"./modules/accounting/dashboard/components/chart/configs/lineChart.js": [
		98375,
		9,
		98375
	],
	"./modules/accounting/dashboard/components/tables/BankAccountOverview": [
		19190,
		9,
		19190
	],
	"./modules/accounting/dashboard/components/tables/BankAccountOverview.tsx": [
		19190,
		9,
		19190
	],
	"./modules/accounting/dashboard/components/tables/CurrentBalanceTable": [
		80671,
		9,
		80671
	],
	"./modules/accounting/dashboard/components/tables/CurrentBalanceTable.tsx": [
		80671,
		9,
		80671
	],
	"./modules/accounting/reports/Report": [
		7512,
		9,
		65239,
		7512
	],
	"./modules/accounting/reports/Report.tsx": [
		7512,
		9,
		65239,
		7512
	],
	"./modules/accounting/reports/ReportList": [
		75359,
		9,
		20691,
		75359
	],
	"./modules/accounting/reports/ReportList.tsx": [
		75359,
		9,
		20691,
		75359
	],
	"./modules/accounting/reports/report-list/BalanceComparision": [
		6522,
		9,
		65239,
		6522
	],
	"./modules/accounting/reports/report-list/BalanceComparision.tsx": [
		6522,
		9,
		65239,
		6522
	],
	"./modules/accounting/reports/report-list/BalanceSheet": [
		1089,
		9,
		65239,
		1089
	],
	"./modules/accounting/reports/report-list/BalanceSheet.tsx": [
		1089,
		9,
		65239,
		1089
	],
	"./modules/accounting/reports/report-list/BalanceSheetDetail": [
		61726,
		9,
		65239,
		61726
	],
	"./modules/accounting/reports/report-list/BalanceSheetDetail.tsx": [
		61726,
		9,
		65239,
		61726
	],
	"./modules/accounting/reports/report-list/BalanceSummary": [
		99760,
		9,
		65239,
		99760
	],
	"./modules/accounting/reports/report-list/BalanceSummary.tsx": [
		99760,
		9,
		65239,
		99760
	],
	"./modules/accounting/reports/report-list/Bookkeeping/AccountHistory": [
		27380,
		9,
		65239,
		27380
	],
	"./modules/accounting/reports/report-list/Bookkeeping/AccountHistory.tsx": [
		27380,
		9,
		65239,
		27380
	],
	"./modules/accounting/reports/report-list/Bookkeeping/AccountList": [
		68286,
		9,
		65239,
		68286,
		69624
	],
	"./modules/accounting/reports/report-list/Bookkeeping/AccountList.tsx": [
		68286,
		9,
		65239,
		68286,
		69624
	],
	"./modules/accounting/reports/report-list/Bookkeeping/BalanceComparisonBook": [
		44631,
		9,
		65239,
		44631
	],
	"./modules/accounting/reports/report-list/Bookkeeping/BalanceComparisonBook.tsx": [
		44631,
		9,
		65239,
		44631
	],
	"./modules/accounting/reports/report-list/Bookkeeping/BankReconciliationDetail": [
		76057,
		9,
		65239,
		76057
	],
	"./modules/accounting/reports/report-list/Bookkeeping/BankReconciliationDetail.tsx": [
		76057,
		9,
		65239,
		76057
	],
	"./modules/accounting/reports/report-list/Bookkeeping/BankReconciliationSummary": [
		19396,
		9,
		65239,
		19396
	],
	"./modules/accounting/reports/report-list/Bookkeeping/BankReconciliationSummary.tsx": [
		19396,
		9,
		65239,
		19396
	],
	"./modules/accounting/reports/report-list/Bookkeeping/CashFlowBookingStatement": [
		47774,
		9,
		65239,
		47774
	],
	"./modules/accounting/reports/report-list/Bookkeeping/CashFlowBookingStatement.tsx": [
		47774,
		9,
		65239,
		47774
	],
	"./modules/accounting/reports/report-list/Bookkeeping/GeneralLedger": [
		89476,
		9,
		65239,
		89476
	],
	"./modules/accounting/reports/report-list/Bookkeeping/GeneralLedger.tsx": [
		89476,
		9,
		65239,
		89476
	],
	"./modules/accounting/reports/report-list/Bookkeeping/Journal": [
		67966,
		9,
		65239,
		67966
	],
	"./modules/accounting/reports/report-list/Bookkeeping/Journal.tsx": [
		67966,
		9,
		65239,
		67966
	],
	"./modules/accounting/reports/report-list/Bookkeeping/ProfitLossBookkeeping": [
		35710,
		9,
		65239,
		35710
	],
	"./modules/accounting/reports/report-list/Bookkeeping/ProfitLossBookkeeping.tsx": [
		35710,
		9,
		65239,
		35710
	],
	"./modules/accounting/reports/report-list/Bookkeeping/ProfitLossComparisionBookkeeping": [
		34186,
		9,
		65239,
		34186
	],
	"./modules/accounting/reports/report-list/Bookkeeping/ProfitLossComparisionBookkeeping.tsx": [
		34186,
		9,
		65239,
		34186
	],
	"./modules/accounting/reports/report-list/Bookkeeping/RecentTransactions": [
		32653,
		9,
		65239,
		32653
	],
	"./modules/accounting/reports/report-list/Bookkeeping/RecentTransactions.tsx": [
		32653,
		9,
		65239,
		32653
	],
	"./modules/accounting/reports/report-list/Bookkeeping/TransactionDetailByDate": [
		56315,
		9,
		65239,
		56315
	],
	"./modules/accounting/reports/report-list/Bookkeeping/TransactionDetailByDate.tsx": [
		56315,
		9,
		65239,
		56315
	],
	"./modules/accounting/reports/report-list/Bookkeeping/TransactionListByDate": [
		77868,
		9,
		65239,
		77868
	],
	"./modules/accounting/reports/report-list/Bookkeeping/TransactionListByDate.tsx": [
		77868,
		9,
		65239,
		77868
	],
	"./modules/accounting/reports/report-list/Bookkeeping/TrialBalance": [
		76439,
		9,
		65239,
		76439
	],
	"./modules/accounting/reports/report-list/Bookkeeping/TrialBalance.tsx": [
		76439,
		9,
		65239,
		76439
	],
	"./modules/accounting/reports/report-list/Bookkeeping/balanceSheetBookkeeping": [
		84044,
		9,
		65239,
		84044
	],
	"./modules/accounting/reports/report-list/Bookkeeping/balanceSheetBookkeeping.tsx": [
		84044,
		9,
		65239,
		84044
	],
	"./modules/accounting/reports/report-list/Budget/BudgetOverview": [
		31010,
		9,
		65239,
		31010,
		99524
	],
	"./modules/accounting/reports/report-list/Budget/BudgetOverview.tsx": [
		31010,
		9,
		65239,
		31010,
		99524
	],
	"./modules/accounting/reports/report-list/Budget/BudgetPerformance": [
		60937,
		9,
		65239,
		60937
	],
	"./modules/accounting/reports/report-list/Budget/BudgetPerformance.tsx": [
		60937,
		9,
		65239,
		60937
	],
	"./modules/accounting/reports/report-list/Budget/BudgevsActual": [
		57816,
		9,
		65239,
		57816
	],
	"./modules/accounting/reports/report-list/Budget/BudgevsActual.tsx": [
		57816,
		9,
		65239,
		57816
	],
	"./modules/accounting/reports/report-list/CashflowStatement": [
		83014,
		9,
		65239,
		83014
	],
	"./modules/accounting/reports/report-list/CashflowStatement.tsx": [
		83014,
		9,
		65239,
		83014
	],
	"./modules/accounting/reports/report-list/CustomSummaryReport": [
		25751,
		9,
		65239,
		25751
	],
	"./modules/accounting/reports/report-list/CustomSummaryReport.tsx": [
		25751,
		9,
		65239,
		25751
	],
	"./modules/accounting/reports/report-list/ExpensesAndSuppliers/ChequeDetails": [
		79257,
		9,
		65239,
		79257
	],
	"./modules/accounting/reports/report-list/ExpensesAndSuppliers/ChequeDetails.tsx": [
		79257,
		9,
		65239,
		79257
	],
	"./modules/accounting/reports/report-list/ProfitAndLoss": [
		8478,
		9,
		65239,
		8478
	],
	"./modules/accounting/reports/report-list/ProfitAndLoss.tsx": [
		8478,
		9,
		65239,
		8478
	],
	"./modules/accounting/reports/report-list/ProfitLossAsIncome": [
		45210,
		9,
		65239,
		45210
	],
	"./modules/accounting/reports/report-list/ProfitLossAsIncome.tsx": [
		45210,
		9,
		65239,
		45210
	],
	"./modules/accounting/reports/report-list/ProfitLossComparision": [
		68409,
		9,
		65239,
		68409
	],
	"./modules/accounting/reports/report-list/ProfitLossComparision.tsx": [
		68409,
		9,
		65239,
		68409
	],
	"./modules/accounting/reports/report-list/ProfitLossDetails": [
		66833,
		9,
		65239,
		66833
	],
	"./modules/accounting/reports/report-list/ProfitLossDetails.tsx": [
		66833,
		9,
		65239,
		66833
	],
	"./modules/accounting/reports/report-list/ProfitLossTrailing": [
		74819,
		9,
		65239,
		74819,
		69624
	],
	"./modules/accounting/reports/report-list/ProfitLossTrailing.tsx": [
		74819,
		9,
		65239,
		74819,
		69624
	],
	"./modules/accounting/reports/report-list/Report.css": [
		9255,
		9,
		9255
	],
	"./modules/accounting/reports/report-list/ReportNew.css": [
		51801,
		9,
		51801
	],
	"./modules/accounting/reports/report-list/SalesAndCustomer/DepositDetails": [
		13400,
		9,
		65239,
		13400
	],
	"./modules/accounting/reports/report-list/SalesAndCustomer/DepositDetails.tsx": [
		13400,
		9,
		65239,
		13400
	],
	"./modules/accounting/reports/report-list/SalesAndCustomer/IncomeByCustomerSummary": [
		26744,
		9,
		65239,
		26744
	],
	"./modules/accounting/reports/report-list/SalesAndCustomer/IncomeByCustomerSummary.tsx": [
		26744,
		9,
		65239,
		26744
	],
	"./modules/accounting/reports/report-list/StatementOfEquity": [
		10171,
		9,
		65239,
		10171
	],
	"./modules/accounting/reports/report-list/StatementOfEquity.tsx": [
		10171,
		9,
		65239,
		10171
	],
	"./modules/accounting/reports/report-list/Tax/TaxDetailReport": [
		40929,
		9,
		65239,
		63310
	],
	"./modules/accounting/reports/report-list/Tax/TaxDetailReport.tsx": [
		40929,
		9,
		65239,
		63310
	],
	"./modules/accounting/reports/report-list/Tax/TaxLiabilityReport": [
		16288,
		9,
		65239,
		16288
	],
	"./modules/accounting/reports/report-list/Tax/TaxLiabilityReport.tsx": [
		16288,
		9,
		65239,
		16288
	],
	"./modules/accounting/reports/report-list/Tax/TaxSummaryReport": [
		9389,
		9,
		65239,
		9389
	],
	"./modules/accounting/reports/report-list/Tax/TaxSummaryReport.tsx": [
		9389,
		9,
		65239,
		9389
	],
	"./modules/accounting/reports/report-list/WhatYouOwe/PayableAgingDetail": [
		38010,
		9,
		65239,
		38010
	],
	"./modules/accounting/reports/report-list/WhatYouOwe/PayableAgingDetail.tsx": [
		38010,
		9,
		65239,
		38010
	],
	"./modules/accounting/reports/report-list/WhatYouOwe/PayableAgingSummary": [
		1425,
		9,
		65239,
		1425
	],
	"./modules/accounting/reports/report-list/WhatYouOwe/PayableAgingSummary.tsx": [
		1425,
		9,
		65239,
		1425
	],
	"./modules/accounting/reports/report-list/WhoOwesYou/ReceivableAgingDetail": [
		11199,
		9,
		65239,
		11199
	],
	"./modules/accounting/reports/report-list/WhoOwesYou/ReceivableAgingDetail.tsx": [
		11199,
		9,
		65239,
		11199
	],
	"./modules/accounting/reports/report-list/WhoOwesYou/ReceivableAgingSummary": [
		52366,
		9,
		65239,
		52366
	],
	"./modules/accounting/reports/report-list/WhoOwesYou/ReceivableAgingSummary.tsx": [
		52366,
		9,
		65239,
		52366
	],
	"./modules/accounting/reports/report-list/profitLossYearToDate": [
		59779,
		9,
		65239,
		59779
	],
	"./modules/accounting/reports/report-list/profitLossYearToDate.tsx": [
		59779,
		9,
		65239,
		59779
	],
	"./modules/accounting/routes": [
		45805,
		9,
		20691,
		65239,
		22019,
		48969,
		85167,
		74819,
		31010,
		75359,
		45805,
		45027
	],
	"./modules/accounting/routes/": [
		45805,
		9,
		20691,
		65239,
		22019,
		48969,
		85167,
		74819,
		31010,
		75359,
		45805,
		45027
	],
	"./modules/accounting/routes/index": [
		45805,
		9,
		20691,
		65239,
		22019,
		48969,
		85167,
		74819,
		31010,
		75359,
		45805,
		45027
	],
	"./modules/accounting/routes/index.tsx": [
		45805,
		9,
		20691,
		65239,
		22019,
		48969,
		85167,
		74819,
		31010,
		75359,
		45805,
		45027
	],
	"./modules/appointment/components/Appointment": [
		83294,
		9,
		83294
	],
	"./modules/appointment/components/Appointment.tsx": [
		83294,
		9,
		83294
	],
	"./modules/appointment/components/AppointmentStatistics": [
		48571,
		9,
		48571
	],
	"./modules/appointment/components/AppointmentStatistics.tsx": [
		48571,
		9,
		48571
	],
	"./modules/appointment/components/StatusStore": [
		72128,
		9,
		72128
	],
	"./modules/appointment/components/StatusStore.ts": [
		72128,
		9,
		72128
	],
	"./modules/appointment/components/add-appointment/AddAppointment": [
		41513,
		9,
		63894
	],
	"./modules/appointment/components/add-appointment/AddAppointment.tsx": [
		41513,
		9,
		63894
	],
	"./modules/appointment/components/initialLayout": [
		99695,
		9,
		99695
	],
	"./modules/appointment/components/initialLayout.tsx": [
		99695,
		9,
		99695
	],
	"./modules/appointment/components/tables/AppointmentTable": [
		16214,
		9,
		16214
	],
	"./modules/appointment/components/tables/AppointmentTable.tsx": [
		16214,
		9,
		16214
	],
	"./modules/appointment/types": [
		29576,
		9,
		29576
	],
	"./modules/appointment/types/": [
		29576,
		9,
		29576
	],
	"./modules/appointment/types/index": [
		29576,
		9,
		29576
	],
	"./modules/appointment/types/index.tsx": [
		29576,
		9,
		29576
	],
	"./modules/crm/Crm": [
		98653,
		9,
		48969,
		28737,
		70791,
		98653
	],
	"./modules/crm/Crm.tsx": [
		98653,
		9,
		48969,
		28737,
		70791,
		98653
	],
	"./modules/crm/leads/common/data/LeadsData": [
		41925,
		9,
		41925
	],
	"./modules/crm/leads/common/data/LeadsData.ts": [
		41925,
		9,
		41925
	],
	"./modules/crm/leads/lead-components/LeadTabs": [
		72177,
		9,
		20691,
		72177,
		76263
	],
	"./modules/crm/leads/lead-components/LeadTabs.tsx": [
		72177,
		9,
		20691,
		72177,
		76263
	],
	"./modules/crm/leads/lead-components/LeadsDetails": [
		84202,
		9,
		20691,
		72177,
		53940
	],
	"./modules/crm/leads/lead-components/LeadsDetails.tsx": [
		84202,
		9,
		20691,
		72177,
		53940
	],
	"./modules/crm/leads/lead-components/lead-tabs/ActivityLogs": [
		62087,
		9,
		62087
	],
	"./modules/crm/leads/lead-components/lead-tabs/ActivityLogs.tsx": [
		62087,
		9,
		62087
	],
	"./modules/crm/leads/lead-components/lead-tabs/Attachments": [
		74263,
		9,
		74263
	],
	"./modules/crm/leads/lead-components/lead-tabs/Attachments.tsx": [
		74263,
		9,
		74263
	],
	"./modules/crm/leads/lead-components/lead-tabs/Notes": [
		19522,
		9,
		19522
	],
	"./modules/crm/leads/lead-components/lead-tabs/Notes.tsx": [
		19522,
		9,
		19522
	],
	"./modules/crm/leads/lead-components/lead-tabs/Profile": [
		68970,
		9,
		20691,
		68970
	],
	"./modules/crm/leads/lead-components/lead-tabs/Profile.tsx": [
		68970,
		9,
		20691,
		68970
	],
	"./modules/crm/leads/lead-components/lead-tabs/Proposal": [
		48259,
		9,
		48259
	],
	"./modules/crm/leads/lead-components/lead-tabs/Proposal.tsx": [
		48259,
		9,
		48259
	],
	"./modules/crm/leads/lead-components/lead-tabs/Reminder": [
		50735,
		9,
		50735
	],
	"./modules/crm/leads/lead-components/lead-tabs/Reminder.tsx": [
		50735,
		9,
		50735
	],
	"./modules/crm/leads/lead-components/lead-tabs/Tasks": [
		20935,
		9,
		20935
	],
	"./modules/crm/leads/lead-components/lead-tabs/Tasks.tsx": [
		20935,
		9,
		20935
	],
	"./modules/crm/leads/lead-components/lead-tabs/tab-tables/ProposalTable": [
		41591,
		9,
		41591
	],
	"./modules/crm/leads/lead-components/lead-tabs/tab-tables/ProposalTable.tsx": [
		41591,
		9,
		41591
	],
	"./modules/crm/leads/lead-components/lead-tabs/tab-tables/ReminderTable": [
		53747,
		9,
		53747
	],
	"./modules/crm/leads/lead-components/lead-tabs/tab-tables/ReminderTable.tsx": [
		53747,
		9,
		53747
	],
	"./modules/crm/leads/lead-components/lead-tabs/tab-tables/TasksTable": [
		75643,
		9,
		75643
	],
	"./modules/crm/leads/lead-components/lead-tabs/tab-tables/TasksTable.tsx": [
		75643,
		9,
		75643
	],
	"./modules/crm/leads/tables/LeadsTable": [
		19620,
		9,
		19620
	],
	"./modules/crm/leads/tables/LeadsTable.tsx": [
		19620,
		9,
		19620
	],
	"./modules/crm/my-meetings/common/data/MeetingData": [
		7839,
		9,
		7839
	],
	"./modules/crm/my-meetings/common/data/MeetingData.ts": [
		7839,
		9,
		7839
	],
	"./modules/crm/my-meetings/meeting-components/MeetingDetails": [
		88917,
		9,
		4060,
		88917
	],
	"./modules/crm/my-meetings/meeting-components/MeetingDetails.tsx": [
		88917,
		9,
		4060,
		88917
	],
	"./modules/crm/my-meetings/meeting-components/MeetingTabs": [
		99127,
		9,
		4060,
		99127
	],
	"./modules/crm/my-meetings/meeting-components/MeetingTabs.tsx": [
		99127,
		9,
		4060,
		99127
	],
	"./modules/crm/my-meetings/meeting-components/meeting-tabs/ActivityLog": [
		51872,
		9,
		51872
	],
	"./modules/crm/my-meetings/meeting-components/meeting-tabs/ActivityLog.tsx": [
		51872,
		9,
		51872
	],
	"./modules/crm/my-meetings/meeting-components/meeting-tabs/Calendar": [
		47661,
		9,
		47661
	],
	"./modules/crm/my-meetings/meeting-components/meeting-tabs/Calendar.tsx": [
		47661,
		9,
		47661
	],
	"./modules/crm/my-meetings/meeting-components/meeting-tabs/MeetingNotes": [
		49413,
		9,
		49413
	],
	"./modules/crm/my-meetings/meeting-components/meeting-tabs/MeetingNotes.tsx": [
		49413,
		9,
		49413
	],
	"./modules/crm/my-meetings/meeting-components/meeting-tabs/Reminders": [
		90818,
		9,
		90818
	],
	"./modules/crm/my-meetings/meeting-components/meeting-tabs/Reminders.tsx": [
		90818,
		9,
		90818
	],
	"./modules/crm/my-meetings/meeting-components/meeting-tabs/tab-tables/ReminderTable": [
		42645,
		9,
		42645
	],
	"./modules/crm/my-meetings/meeting-components/meeting-tabs/tab-tables/ReminderTable.tsx": [
		42645,
		9,
		42645
	],
	"./modules/crm/my-meetings/tables/MyMeetingsTable": [
		23867,
		9,
		23867
	],
	"./modules/crm/my-meetings/tables/MyMeetingsTable.tsx": [
		23867,
		9,
		23867
	],
	"./modules/crm/routes": [
		34338,
		9,
		20691,
		48969,
		28737,
		70791,
		4060,
		72177,
		98653,
		34338
	],
	"./modules/crm/routes/": [
		34338,
		9,
		20691,
		48969,
		28737,
		70791,
		4060,
		72177,
		98653,
		34338
	],
	"./modules/crm/routes/index": [
		34338,
		9,
		20691,
		48969,
		28737,
		70791,
		4060,
		72177,
		98653,
		34338
	],
	"./modules/crm/routes/index.tsx": [
		34338,
		9,
		20691,
		48969,
		28737,
		70791,
		4060,
		72177,
		98653,
		34338
	],
	"./modules/customer/common/data/CustomerData": [
		82782,
		9,
		82782
	],
	"./modules/customer/common/data/CustomerData.ts": [
		82782,
		9,
		82782
	],
	"./modules/customer/common/data/MemberAvatarGroup": [
		60606,
		9,
		60606
	],
	"./modules/customer/common/data/MemberAvatarGroup.tsx": [
		60606,
		9,
		60606
	],
	"./modules/customer/customer-add/CustomerAddBody": [
		85389,
		9,
		85389,
		89321
	],
	"./modules/customer/customer-add/CustomerAddBody copy.text": [
		99049,
		1,
		99049
	],
	"./modules/customer/customer-add/CustomerAddBody.tsx": [
		85389,
		9,
		85389,
		89321
	],
	"./modules/customer/customer-add/CustomerBilling": [
		70405,
		9,
		70405
	],
	"./modules/customer/customer-add/CustomerBilling.tsx": [
		70405,
		9,
		70405
	],
	"./modules/customer/customer-add/CustomerContact": [
		89272,
		9,
		89272
	],
	"./modules/customer/customer-add/CustomerContact.tsx": [
		89272,
		9,
		89272
	],
	"./modules/customer/customer-list/CustomerList": [
		61511,
		9,
		69993,
		15751,
		85389,
		54223
	],
	"./modules/customer/customer-list/CustomerList.tsx": [
		61511,
		9,
		69993,
		15751,
		85389,
		54223
	],
	"./modules/customer/customer-list/components/CustomerListStatitstic": [
		16596,
		9,
		69993,
		15751,
		16596
	],
	"./modules/customer/customer-list/components/CustomerListStatitstic.tsx": [
		16596,
		9,
		69993,
		15751,
		16596
	],
	"./modules/customer/customer-list/components/CustomerTable": [
		6918,
		9,
		6918
	],
	"./modules/customer/customer-list/components/CustomerTable.tsx": [
		6918,
		9,
		6918
	],
	"./modules/customer/customer-profile/CustomerProfile": [
		41773,
		9,
		20691,
		27682,
		69993,
		15751,
		3719,
		76458,
		43932,
		29993,
		90405,
		82005,
		86823,
		94762,
		56865,
		62721
	],
	"./modules/customer/customer-profile/CustomerProfile.tsx": [
		41773,
		9,
		20691,
		27682,
		69993,
		15751,
		3719,
		76458,
		43932,
		29993,
		90405,
		82005,
		86823,
		94762,
		56865,
		62721
	],
	"./modules/customer/customer-profile/components/AddressCard": [
		73223,
		9,
		69993,
		15751,
		3719,
		73223
	],
	"./modules/customer/customer-profile/components/AddressCard.tsx": [
		73223,
		9,
		69993,
		15751,
		3719,
		73223
	],
	"./modules/customer/customer-profile/components/ProfileCard": [
		19920,
		9,
		3719,
		34626
	],
	"./modules/customer/customer-profile/components/ProfileCard.tsx": [
		19920,
		9,
		3719,
		34626
	],
	"./modules/customer/customer-profile/components/ProfileDetailsTab": [
		56865,
		9,
		20691,
		27682,
		69993,
		15751,
		76458,
		43932,
		29993,
		90405,
		82005,
		86823,
		94762,
		56865
	],
	"./modules/customer/customer-profile/components/ProfileDetailsTab.tsx": [
		56865,
		9,
		20691,
		27682,
		69993,
		15751,
		76458,
		43932,
		29993,
		90405,
		82005,
		86823,
		94762,
		56865
	],
	"./modules/customer/customer-profile/components/contracts/Contract": [
		7511,
		9,
		7511
	],
	"./modules/customer/customer-profile/components/contracts/Contract.tsx": [
		7511,
		9,
		7511
	],
	"./modules/customer/customer-profile/components/contracts/ContractTable": [
		43587,
		9,
		43587
	],
	"./modules/customer/customer-profile/components/contracts/ContractTable.tsx": [
		43587,
		9,
		43587
	],
	"./modules/customer/customer-profile/components/expenses/ExpenseStatistics": [
		43754,
		9,
		69993,
		15751,
		43754
	],
	"./modules/customer/customer-profile/components/expenses/ExpenseStatistics.tsx": [
		43754,
		9,
		69993,
		15751,
		43754
	],
	"./modules/customer/customer-profile/components/expenses/Expenses": [
		71684,
		9,
		69993,
		15751,
		71684
	],
	"./modules/customer/customer-profile/components/expenses/Expenses.tsx": [
		71684,
		9,
		69993,
		15751,
		71684
	],
	"./modules/customer/customer-profile/components/expenses/ExpensesTable": [
		82370,
		9,
		82370
	],
	"./modules/customer/customer-profile/components/expenses/ExpensesTable.tsx": [
		82370,
		9,
		82370
	],
	"./modules/customer/customer-profile/components/project/ProjectStatistics": [
		76945,
		9,
		69993,
		76945
	],
	"./modules/customer/customer-profile/components/project/ProjectStatistics.tsx": [
		76945,
		9,
		69993,
		76945
	],
	"./modules/customer/customer-profile/components/project/Projects": [
		7001,
		9,
		69993,
		82005,
		7001
	],
	"./modules/customer/customer-profile/components/project/Projects.tsx": [
		7001,
		9,
		69993,
		82005,
		7001
	],
	"./modules/customer/customer-profile/components/reminder/Reminder": [
		32050,
		9,
		32050
	],
	"./modules/customer/customer-profile/components/reminder/Reminder.tsx": [
		32050,
		9,
		32050
	],
	"./modules/customer/customer-profile/components/reminder/ReminderTable": [
		80312,
		9,
		80312
	],
	"./modules/customer/customer-profile/components/reminder/ReminderTable.tsx": [
		80312,
		9,
		80312
	],
	"./modules/customer/customer-profile/components/sales/credit-notes/CreditNotes": [
		90722,
		9,
		20691,
		90405,
		90722
	],
	"./modules/customer/customer-profile/components/sales/credit-notes/CreditNotes.tsx": [
		90722,
		9,
		20691,
		90405,
		90722
	],
	"./modules/customer/customer-profile/components/sales/credit-notes/CreditTable": [
		4085,
		9,
		4085
	],
	"./modules/customer/customer-profile/components/sales/credit-notes/CreditTable.tsx": [
		4085,
		9,
		4085
	],
	"./modules/customer/customer-profile/components/sales/debit-notes/DebitNotes": [
		44770,
		9,
		44770
	],
	"./modules/customer/customer-profile/components/sales/debit-notes/DebitNotes.tsx": [
		44770,
		9,
		44770
	],
	"./modules/customer/customer-profile/components/sales/debit-notes/DebitTable": [
		11061,
		9,
		11061
	],
	"./modules/customer/customer-profile/components/sales/debit-notes/DebitTable.tsx": [
		11061,
		9,
		11061
	],
	"./modules/customer/customer-profile/components/sales/estimate/Estimate": [
		3579,
		9,
		20691,
		27682,
		76458,
		29993,
		5245
	],
	"./modules/customer/customer-profile/components/sales/estimate/Estimate.tsx": [
		3579,
		9,
		20691,
		27682,
		76458,
		29993,
		5245
	],
	"./modules/customer/customer-profile/components/sales/estimate/EstimateStatistic": [
		58209,
		9,
		69993,
		58209
	],
	"./modules/customer/customer-profile/components/sales/estimate/EstimateStatistic.tsx": [
		58209,
		9,
		69993,
		58209
	],
	"./modules/customer/customer-profile/components/sales/estimate/EstimateTable": [
		86743,
		9,
		86743
	],
	"./modules/customer/customer-profile/components/sales/estimate/EstimateTable.tsx": [
		86743,
		9,
		86743
	],
	"./modules/customer/customer-profile/components/sales/invoice/Invoice": [
		77697,
		9,
		20691,
		27682,
		43932,
		86823,
		34137
	],
	"./modules/customer/customer-profile/components/sales/invoice/Invoice.tsx": [
		77697,
		9,
		20691,
		27682,
		43932,
		86823,
		34137
	],
	"./modules/customer/customer-profile/components/sales/invoice/InvoiceStatistic": [
		31391,
		9,
		69993,
		31391
	],
	"./modules/customer/customer-profile/components/sales/invoice/InvoiceStatistic.tsx": [
		31391,
		9,
		69993,
		31391
	],
	"./modules/customer/customer-profile/components/sales/invoice/InvoiceTable": [
		49629,
		9,
		49629
	],
	"./modules/customer/customer-profile/components/sales/invoice/InvoiceTable.tsx": [
		49629,
		9,
		49629
	],
	"./modules/customer/customer-profile/components/sales/performa-invoice/PerformaInvoice": [
		63524,
		9,
		20691,
		69993,
		63524
	],
	"./modules/customer/customer-profile/components/sales/performa-invoice/PerformaInvoice.tsx": [
		63524,
		9,
		20691,
		69993,
		63524
	],
	"./modules/customer/customer-profile/components/sales/performa-invoice/PerformaStatistic": [
		50851,
		9,
		69993,
		50851
	],
	"./modules/customer/customer-profile/components/sales/performa-invoice/PerformaStatistic.tsx": [
		50851,
		9,
		69993,
		50851
	],
	"./modules/customer/customer-profile/components/sales/performa-invoice/PerformaTable": [
		13345,
		9,
		13345
	],
	"./modules/customer/customer-profile/components/sales/performa-invoice/PerformaTable.tsx": [
		13345,
		9,
		13345
	],
	"./modules/customer/customer-profile/components/sales/proposal/Proposal": [
		41387,
		9,
		20691,
		41387
	],
	"./modules/customer/customer-profile/components/sales/proposal/Proposal.tsx": [
		41387,
		9,
		20691,
		41387
	],
	"./modules/customer/customer-profile/components/sales/proposal/ProposalTable": [
		2951,
		9,
		2951
	],
	"./modules/customer/customer-profile/components/sales/proposal/ProposalTable.tsx": [
		2951,
		9,
		2951
	],
	"./modules/customer/customer-profile/components/tabs/ContactTab": [
		78363,
		9,
		78363
	],
	"./modules/customer/customer-profile/components/tabs/ContactTab.tsx": [
		78363,
		9,
		78363
	],
	"./modules/customer/customer-profile/components/tabs/Map": [
		51802,
		9,
		51802
	],
	"./modules/customer/customer-profile/components/tabs/Map.tsx": [
		51802,
		9,
		51802
	],
	"./modules/customer/customer-profile/components/tabs/ProfileTab": [
		94762,
		9,
		94762
	],
	"./modules/customer/customer-profile/components/tabs/ProfileTab.tsx": [
		94762,
		9,
		94762
	],
	"./modules/customer/customer-profile/components/tabs/SalesTab": [
		52943,
		9,
		20691,
		27682,
		76458,
		43932,
		29993,
		90405,
		86823,
		52943
	],
	"./modules/customer/customer-profile/components/tabs/SalesTab.tsx": [
		52943,
		9,
		20691,
		27682,
		76458,
		43932,
		29993,
		90405,
		86823,
		52943
	],
	"./modules/customer/customer-profile/components/tabs/contact-model/ContactModel": [
		66130,
		9,
		66130
	],
	"./modules/customer/customer-profile/components/tabs/contact-model/ContactModel.tsx": [
		66130,
		9,
		66130
	],
	"./modules/customer/customer-profile/components/tabs/contacts/ContactsTable": [
		88421,
		9,
		88421
	],
	"./modules/customer/customer-profile/components/tabs/contacts/ContactsTable.tsx": [
		88421,
		9,
		88421
	],
	"./modules/customer/customer-profile/components/tabs/vehicle/CustomerVehicleTable": [
		89917,
		9,
		89917
	],
	"./modules/customer/customer-profile/components/tabs/vehicle/CustomerVehicleTable.tsx": [
		89917,
		9,
		89917
	],
	"./modules/customer/lang/en": [
		57209,
		9,
		57209
	],
	"./modules/customer/lang/en.tsx": [
		57209,
		9,
		57209
	],
	"./modules/customer/routes": [
		85296,
		9,
		20691,
		27682,
		69993,
		15751,
		3719,
		76458,
		43932,
		29993,
		90405,
		82005,
		86823,
		94762,
		56865,
		85389,
		40546
	],
	"./modules/customer/routes/": [
		85296,
		9,
		20691,
		27682,
		69993,
		15751,
		3719,
		76458,
		43932,
		29993,
		90405,
		82005,
		86823,
		94762,
		56865,
		85389,
		40546
	],
	"./modules/customer/routes/index": [
		85296,
		9,
		20691,
		27682,
		69993,
		15751,
		3719,
		76458,
		43932,
		29993,
		90405,
		82005,
		86823,
		94762,
		56865,
		85389,
		40546
	],
	"./modules/customer/routes/index.tsx": [
		85296,
		9,
		20691,
		27682,
		69993,
		15751,
		3719,
		76458,
		43932,
		29993,
		90405,
		82005,
		86823,
		94762,
		56865,
		85389,
		40546
	],
	"./modules/customer/types/types": [
		70501,
		9,
		92882
	],
	"./modules/customer/types/types.tsx": [
		70501,
		9,
		92882
	],
	"./modules/files/components/FilesPreview": [
		72632,
		9,
		72632
	],
	"./modules/files/components/FilesPreview.tsx": [
		72632,
		9,
		72632
	],
	"./modules/files/types": [
		422,
		9,
		422
	],
	"./modules/files/types/": [
		422,
		9,
		422
	],
	"./modules/files/types/index": [
		422,
		9,
		422
	],
	"./modules/files/types/index.tsx": [
		422,
		9,
		422
	],
	"./modules/hr/components/contracts/Contracts": [
		90769,
		9,
		90769
	],
	"./modules/hr/components/contracts/Contracts.tsx": [
		90769,
		9,
		90769
	],
	"./modules/hr/components/dashboard/HrDashboard": [
		62595,
		9,
		22019,
		62595,
		52194
	],
	"./modules/hr/components/dashboard/HrDashboard.tsx": [
		62595,
		9,
		22019,
		62595,
		52194
	],
	"./modules/hr/components/dashboard/components/charts/AttendanceColumnChart": [
		87509,
		9,
		22019,
		87509
	],
	"./modules/hr/components/dashboard/components/charts/AttendanceColumnChart.tsx": [
		87509,
		9,
		22019,
		87509
	],
	"./modules/hr/components/dashboard/components/charts/EmployeeDistributionDonutChart": [
		22252,
		9,
		22019,
		22252
	],
	"./modules/hr/components/dashboard/components/charts/EmployeeDistributionDonutChart.tsx": [
		22252,
		9,
		22019,
		22252
	],
	"./modules/hr/components/dashboard/components/charts/HeadCountBarChart": [
		96410,
		9,
		22019,
		96410
	],
	"./modules/hr/components/dashboard/components/charts/HeadCountBarChart.tsx": [
		96410,
		9,
		22019,
		96410
	],
	"./modules/hr/components/dashboard/components/charts/HeadCountPieChart": [
		23713,
		9,
		22019,
		23713
	],
	"./modules/hr/components/dashboard/components/charts/HeadCountPieChart.tsx": [
		23713,
		9,
		22019,
		23713
	],
	"./modules/hr/components/dashboard/components/charts/HrCalendar": [
		90562,
		9,
		90562
	],
	"./modules/hr/components/dashboard/components/charts/HrCalendar.tsx": [
		90562,
		9,
		90562
	],
	"./modules/hr/components/dashboard/components/charts/SalaryBarChart": [
		74117,
		9,
		22019,
		74117
	],
	"./modules/hr/components/dashboard/components/charts/SalaryBarChart.tsx": [
		74117,
		9,
		22019,
		74117
	],
	"./modules/hr/components/dashboard/components/charts/StaffRatioColumnChart": [
		43447,
		9,
		22019,
		43447
	],
	"./modules/hr/components/dashboard/components/charts/StaffRatioColumnChart.tsx": [
		43447,
		9,
		22019,
		43447
	],
	"./modules/hr/components/dashboard/components/tables/AnnouncementTable": [
		73067,
		9,
		73067
	],
	"./modules/hr/components/dashboard/components/tables/AnnouncementTable.tsx": [
		73067,
		9,
		73067
	],
	"./modules/hr/components/dashboard/components/tables/BirthdaysTable": [
		99816,
		9,
		99816
	],
	"./modules/hr/components/dashboard/components/tables/BirthdaysTable.tsx": [
		99816,
		9,
		99816
	],
	"./modules/hr/components/dashboard/components/tables/EventTable": [
		47506,
		9,
		47506
	],
	"./modules/hr/components/dashboard/components/tables/EventTable.tsx": [
		47506,
		9,
		47506
	],
	"./modules/hr/components/dashboard/components/tables/MeetingTable": [
		8383,
		9,
		8383
	],
	"./modules/hr/components/dashboard/components/tables/MeetingTable.tsx": [
		8383,
		9,
		8383
	],
	"./modules/hr/components/dependants/Dependants": [
		27531,
		9,
		27531
	],
	"./modules/hr/components/dependants/Dependants.tsx": [
		27531,
		9,
		27531
	],
	"./modules/hr/components/employee-profile/EmployeeProfile": [
		45848,
		9,
		45848
	],
	"./modules/hr/components/employee-profile/EmployeeProfile.tsx": [
		45848,
		9,
		45848
	],
	"./modules/hr/components/employee-profile/common/data/EmployeeData": [
		98394,
		9,
		98394
	],
	"./modules/hr/components/employee-profile/common/data/EmployeeData.ts": [
		98394,
		9,
		98394
	],
	"./modules/hr/components/employee-profile/employee-add/AddEmployeeBody": [
		38029,
		9,
		38029
	],
	"./modules/hr/components/employee-profile/employee-add/AddEmployeeBody.tsx": [
		38029,
		9,
		38029
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/DependentDetails": [
		58651,
		9,
		58651,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/DependentDetails.tsx": [
		58651,
		9,
		58651,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeContactDetails": [
		96148,
		9,
		96148,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeContactDetails.tsx": [
		96148,
		9,
		96148,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeEmergencyContactDetails": [
		53626,
		9,
		31245,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeEmergencyContactDetails.tsx": [
		53626,
		9,
		31245,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeFileManager": [
		37615,
		9,
		37615
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeFileManager.tsx": [
		37615,
		9,
		37615
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeJobDetails": [
		22875,
		9,
		22875,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeJobDetails.tsx": [
		22875,
		9,
		22875,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeLetters": [
		81927,
		9,
		86178,
		81927
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeLetters.tsx": [
		81927,
		9,
		86178,
		81927
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeQualifications": [
		58404,
		9,
		58404,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeQualifications.tsx": [
		58404,
		9,
		58404,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeTrainings": [
		113,
		9,
		48969,
		85167,
		113
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeTrainings.tsx": [
		113,
		9,
		48969,
		85167,
		113
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeWorkExperiences": [
		87202,
		9,
		87202
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/EmployeeWorkExperiences.tsx": [
		87202,
		9,
		87202
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/ImmigrationDetails": [
		36538,
		9,
		36538,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/ImmigrationDetails.tsx": [
		36538,
		9,
		36538,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/PersonalDetails": [
		98558,
		9,
		98558,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/PersonalDetails.tsx": [
		98558,
		9,
		98558,
		89321
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/AttachmentsForm": [
		4804,
		9,
		4804
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/AttachmentsForm.tsx": [
		4804,
		9,
		4804
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/EducationForm": [
		26848,
		9,
		26848
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/EducationForm.tsx": [
		26848,
		9,
		26848
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/LanguageForm": [
		87986,
		9,
		87986
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/LanguageForm.tsx": [
		87986,
		9,
		87986
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/LicenseForm": [
		59991,
		9,
		59991
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/LicenseForm.tsx": [
		59991,
		9,
		59991
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/SkillsForm": [
		6502,
		9,
		6502
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/SkillsForm.tsx": [
		6502,
		9,
		6502
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/WorkExperienceForm": [
		87291,
		9,
		87291
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/forms/WorkExperienceForm.tsx": [
		87291,
		9,
		87291
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/ContactDetailsTable": [
		42254,
		9,
		42254
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/ContactDetailsTable.tsx": [
		42254,
		9,
		42254
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/DependentsTable": [
		94824,
		9,
		94824
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/DependentsTable.tsx": [
		94824,
		9,
		94824
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/EducationTable": [
		42296,
		9,
		42296
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/EducationTable.tsx": [
		42296,
		9,
		42296
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/EmergencyContactTable": [
		17803,
		9,
		17803
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/EmergencyContactTable.tsx": [
		17803,
		9,
		17803
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/EmployeeLettersTable": [
		26191,
		9,
		26191
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/EmployeeLettersTable.tsx": [
		26191,
		9,
		26191
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/ImmigrationTable": [
		54940,
		9,
		54940
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/ImmigrationTable.tsx": [
		54940,
		9,
		54940
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/LanguageTable": [
		82046,
		9,
		82046
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/LanguageTable.tsx": [
		82046,
		9,
		82046
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/LicenseTable": [
		69585,
		9,
		69585
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/LicenseTable.tsx": [
		69585,
		9,
		69585
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/SkillTable": [
		48419,
		9,
		48419
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/SkillTable.tsx": [
		48419,
		9,
		48419
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/TrainingLibrariesTable": [
		37983,
		9,
		37983
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/TrainingLibrariesTable.tsx": [
		37983,
		9,
		37983
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/TrainingProgramsTable": [
		55083,
		9,
		55083
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/TrainingProgramsTable.tsx": [
		55083,
		9,
		55083
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/TrainingResultsTable": [
		94550,
		9,
		94550
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/TrainingResultsTable.tsx": [
		94550,
		9,
		94550
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/WorkExperienceTable": [
		76285,
		9,
		76285
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/WorkExperienceTable.tsx": [
		76285,
		9,
		76285
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/ContactUploadTable": [
		84975,
		9,
		84975
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/ContactUploadTable.tsx": [
		84975,
		9,
		84975
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/DependentsUploadTable": [
		76757,
		9,
		76757
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/DependentsUploadTable.tsx": [
		76757,
		9,
		76757
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/EmergencyContactUploadTable": [
		17546,
		9,
		17546
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/EmergencyContactUploadTable.tsx": [
		17546,
		9,
		17546
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/EmployeeFileManagerUploadTable": [
		84582,
		9,
		84582
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/EmployeeFileManagerUploadTable.tsx": [
		84582,
		9,
		84582
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/ImmigrationUploadTable": [
		33174,
		9,
		10793
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/ImmigrationUploadTable.tsx": [
		33174,
		9,
		10793
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/JobDetailsUploadTable": [
		12746,
		9,
		12746
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/JobDetailsUploadTable.tsx": [
		12746,
		9,
		12746
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/PersonalUploadTable": [
		89677,
		9,
		89677
	],
	"./modules/hr/components/employee-profile/employee-add/employee-tabs/tables/upload/PersonalUploadTable.tsx": [
		89677,
		9,
		89677
	],
	"./modules/hr/components/employee-profile/employee-details/EmployeeDetails": [
		63894,
		9,
		86178,
		48969,
		85167,
		58404,
		98558,
		113,
		96148,
		36538,
		22875,
		31245,
		58651,
		41513,
		89321
	],
	"./modules/hr/components/employee-profile/employee-details/EmployeeDetails.tsx": [
		63894,
		9,
		86178,
		48969,
		85167,
		58404,
		98558,
		113,
		96148,
		36538,
		22875,
		31245,
		58651,
		41513,
		89321
	],
	"./modules/hr/components/employee-profile/tables/EmployeeProfileTable": [
		93692,
		9,
		93692
	],
	"./modules/hr/components/employee-profile/tables/EmployeeProfileTable.tsx": [
		93692,
		9,
		93692
	],
	"./modules/hr/components/file-manager/FileManager": [
		61328,
		9,
		69993,
		15751,
		61328
	],
	"./modules/hr/components/file-manager/FileManager.tsx": [
		61328,
		9,
		69993,
		15751,
		61328
	],
	"./modules/hr/components/file-manager/components/FileManagerStatitstics": [
		3994,
		9,
		69993,
		15751,
		3994
	],
	"./modules/hr/components/file-manager/components/FileManagerStatitstics.tsx": [
		3994,
		9,
		69993,
		15751,
		3994
	],
	"./modules/hr/components/file-manager/components/FolderDetail": [
		37119,
		9,
		37119
	],
	"./modules/hr/components/file-manager/components/FolderDetail.tsx": [
		37119,
		9,
		37119
	],
	"./modules/hr/components/file-manager/components/FolderDisplay": [
		23988,
		9,
		23988
	],
	"./modules/hr/components/file-manager/components/FolderDisplay.tsx": [
		23988,
		9,
		23988
	],
	"./modules/hr/components/job-positions/JobPositions": [
		95928,
		9,
		95928
	],
	"./modules/hr/components/job-positions/JobPositions.tsx": [
		95928,
		9,
		95928
	],
	"./modules/hr/components/job-positions/components/JobDetails": [
		31485,
		9,
		31485
	],
	"./modules/hr/components/job-positions/components/JobDetails.tsx": [
		31485,
		9,
		31485
	],
	"./modules/hr/components/job-positions/tables/JobPositionTable": [
		25153,
		9,
		25153
	],
	"./modules/hr/components/job-positions/tables/JobPositionTable.tsx": [
		25153,
		9,
		25153
	],
	"./modules/hr/components/layoff-checklist/LayoffChecklist": [
		39558,
		9,
		39558
	],
	"./modules/hr/components/layoff-checklist/LayoffChecklist.tsx": [
		39558,
		9,
		39558
	],
	"./modules/hr/components/org-hierarchical-view/OrgHierarchicalView": [
		26765,
		9,
		26765
	],
	"./modules/hr/components/org-hierarchical-view/OrgHierarchicalView.tsx": [
		26765,
		9,
		26765
	],
	"./modules/hr/components/org-hierarchical-view/components/OrgHierarchicalChart": [
		82999,
		9,
		20045,
		65207,
		82999
	],
	"./modules/hr/components/org-hierarchical-view/components/OrgHierarchicalChart.tsx": [
		82999,
		9,
		20045,
		65207,
		82999
	],
	"./modules/hr/components/org-hierarchical-view/components/OrgHierarchicalViewDetails": [
		34252,
		9,
		34252
	],
	"./modules/hr/components/org-hierarchical-view/components/OrgHierarchicalViewDetails.tsx": [
		34252,
		9,
		34252
	],
	"./modules/hr/components/org-hierarchical-view/tables/OrgHierarchicalViewTable": [
		6499,
		9,
		6499
	],
	"./modules/hr/components/org-hierarchical-view/tables/OrgHierarchicalViewTable.tsx": [
		6499,
		9,
		6499
	],
	"./modules/hr/components/q&a/QAndA": [
		99514,
		9,
		99514
	],
	"./modules/hr/components/q&a/QAndA.tsx": [
		99514,
		9,
		99514
	],
	"./modules/hr/components/reports/Reports": [
		97001,
		9,
		97001
	],
	"./modules/hr/components/reports/Reports.tsx": [
		97001,
		9,
		97001
	],
	"./modules/hr/components/settings/HrSettings": [
		88587,
		9,
		86178,
		88587
	],
	"./modules/hr/components/settings/HrSettings.tsx": [
		88587,
		9,
		86178,
		88587
	],
	"./modules/hr/components/settings/settings-tabs/CompanyPolicies": [
		10394,
		9,
		10394
	],
	"./modules/hr/components/settings/settings-tabs/CompanyPolicies.tsx": [
		10394,
		9,
		10394
	],
	"./modules/hr/components/settings/settings-tabs/ContractType": [
		78319,
		9,
		78319
	],
	"./modules/hr/components/settings/settings-tabs/ContractType.tsx": [
		78319,
		9,
		78319
	],
	"./modules/hr/components/settings/settings-tabs/EmploymentStatus": [
		89745,
		9,
		89745
	],
	"./modules/hr/components/settings/settings-tabs/EmploymentStatus.tsx": [
		89745,
		9,
		89745
	],
	"./modules/hr/components/settings/settings-tabs/JobCategory": [
		34124,
		9,
		34124
	],
	"./modules/hr/components/settings/settings-tabs/JobCategory.tsx": [
		34124,
		9,
		34124
	],
	"./modules/hr/components/settings/settings-tabs/JobSpecification": [
		7813,
		9,
		7813
	],
	"./modules/hr/components/settings/settings-tabs/JobSpecification.tsx": [
		7813,
		9,
		7813
	],
	"./modules/hr/components/settings/settings-tabs/LetterHeads": [
		73356,
		9,
		73356
	],
	"./modules/hr/components/settings/settings-tabs/LetterHeads.tsx": [
		73356,
		9,
		73356
	],
	"./modules/hr/components/settings/settings-tabs/LetterTemplates": [
		40020,
		9,
		86178,
		40020
	],
	"./modules/hr/components/settings/settings-tabs/LetterTemplates.tsx": [
		40020,
		9,
		86178,
		40020
	],
	"./modules/hr/components/settings/settings-tabs/MaritalStatus": [
		96995,
		9,
		96995
	],
	"./modules/hr/components/settings/settings-tabs/MaritalStatus.tsx": [
		96995,
		9,
		96995
	],
	"./modules/hr/components/settings/settings-tabs/Nationality": [
		62719,
		9,
		62719
	],
	"./modules/hr/components/settings/settings-tabs/Nationality.tsx": [
		62719,
		9,
		62719
	],
	"./modules/hr/components/settings/settings-tabs/SubUnit": [
		60945,
		9,
		60945
	],
	"./modules/hr/components/settings/settings-tabs/SubUnit.tsx": [
		60945,
		9,
		60945
	],
	"./modules/hr/components/settings/settings-tabs/Workplace": [
		17913,
		9,
		17913
	],
	"./modules/hr/components/settings/settings-tabs/Workplace.tsx": [
		17913,
		9,
		17913
	],
	"./modules/hr/components/settings/settings-tabs/tables/CompanyPoliciesTable": [
		64934,
		9,
		64934
	],
	"./modules/hr/components/settings/settings-tabs/tables/CompanyPoliciesTable.tsx": [
		64934,
		9,
		64934
	],
	"./modules/hr/components/settings/settings-tabs/tables/ContractTypeTable": [
		7753,
		9,
		7753
	],
	"./modules/hr/components/settings/settings-tabs/tables/ContractTypeTable.tsx": [
		7753,
		9,
		7753
	],
	"./modules/hr/components/settings/settings-tabs/tables/EmploymentStatusTable": [
		17767,
		9,
		17767
	],
	"./modules/hr/components/settings/settings-tabs/tables/EmploymentStatusTable.tsx": [
		17767,
		9,
		17767
	],
	"./modules/hr/components/settings/settings-tabs/tables/JobCategoryTable": [
		68892,
		9,
		68892
	],
	"./modules/hr/components/settings/settings-tabs/tables/JobCategoryTable.tsx": [
		68892,
		9,
		68892
	],
	"./modules/hr/components/settings/settings-tabs/tables/JobSpecificationTable": [
		15167,
		9,
		15167
	],
	"./modules/hr/components/settings/settings-tabs/tables/JobSpecificationTable.tsx": [
		15167,
		9,
		15167
	],
	"./modules/hr/components/settings/settings-tabs/tables/LetterHeadsTable": [
		20160,
		9,
		20160
	],
	"./modules/hr/components/settings/settings-tabs/tables/LetterHeadsTable.tsx": [
		20160,
		9,
		20160
	],
	"./modules/hr/components/settings/settings-tabs/tables/LetterTemplatesTable": [
		75064,
		9,
		75064
	],
	"./modules/hr/components/settings/settings-tabs/tables/LetterTemplatesTable.tsx": [
		75064,
		9,
		75064
	],
	"./modules/hr/components/settings/settings-tabs/tables/MaritalStatusTable": [
		96137,
		9,
		96137
	],
	"./modules/hr/components/settings/settings-tabs/tables/MaritalStatusTable.tsx": [
		96137,
		9,
		96137
	],
	"./modules/hr/components/settings/settings-tabs/tables/NationalityTable": [
		95725,
		9,
		95725
	],
	"./modules/hr/components/settings/settings-tabs/tables/NationalityTable.tsx": [
		95725,
		9,
		95725
	],
	"./modules/hr/components/settings/settings-tabs/tables/SubUnitTable": [
		93423,
		9,
		93423
	],
	"./modules/hr/components/settings/settings-tabs/tables/SubUnitTable.tsx": [
		93423,
		9,
		93423
	],
	"./modules/hr/components/settings/settings-tabs/tables/WorkplaceTable": [
		3695,
		9,
		3695
	],
	"./modules/hr/components/settings/settings-tabs/tables/WorkplaceTable.tsx": [
		3695,
		9,
		3695
	],
	"./modules/hr/components/training/Training": [
		69659,
		9,
		48969,
		85167,
		69659
	],
	"./modules/hr/components/training/Training.tsx": [
		69659,
		9,
		48969,
		85167,
		69659
	],
	"./modules/hr/components/training/tables/TrainingLibrariesTable": [
		29226,
		9,
		29226
	],
	"./modules/hr/components/training/tables/TrainingLibrariesTable.tsx": [
		29226,
		9,
		29226
	],
	"./modules/hr/components/training/tables/TrainingProgramsTable": [
		74208,
		9,
		74208
	],
	"./modules/hr/components/training/tables/TrainingProgramsTable.tsx": [
		74208,
		9,
		74208
	],
	"./modules/hr/components/training/tables/TrainingResultsTable": [
		37315,
		9,
		37315
	],
	"./modules/hr/components/training/tables/TrainingResultsTable.tsx": [
		37315,
		9,
		37315
	],
	"./modules/hr/routes": [
		63834,
		9,
		69993,
		15751,
		22019,
		86178,
		48969,
		85167,
		20045,
		65207,
		714,
		58404,
		98558,
		113,
		96148,
		36538,
		22875,
		31245,
		58651,
		88587,
		41513,
		62595,
		69659,
		63834
	],
	"./modules/hr/routes/": [
		63834,
		9,
		69993,
		15751,
		22019,
		86178,
		48969,
		85167,
		20045,
		65207,
		714,
		58404,
		98558,
		113,
		96148,
		36538,
		22875,
		31245,
		58651,
		88587,
		41513,
		62595,
		69659,
		63834
	],
	"./modules/hr/routes/index": [
		63834,
		9,
		69993,
		15751,
		22019,
		86178,
		48969,
		85167,
		20045,
		65207,
		714,
		58404,
		98558,
		113,
		96148,
		36538,
		22875,
		31245,
		58651,
		88587,
		41513,
		62595,
		69659,
		63834
	],
	"./modules/hr/routes/index.tsx": [
		63834,
		9,
		69993,
		15751,
		22019,
		86178,
		48969,
		85167,
		20045,
		65207,
		714,
		58404,
		98558,
		113,
		96148,
		36538,
		22875,
		31245,
		58651,
		88587,
		41513,
		62595,
		69659,
		63834
	],
	"./modules/hr/types": [
		82775,
		9,
		82775
	],
	"./modules/hr/types/": [
		82775,
		9,
		82775
	],
	"./modules/hr/types/index": [
		82775,
		9,
		82775
	],
	"./modules/hr/types/index.tsx": [
		82775,
		9,
		82775
	],
	"./modules/inspection-report/InspectionReport": [
		64030,
		9,
		64030
	],
	"./modules/inspection-report/InspectionReport.tsx": [
		64030,
		9,
		64030
	],
	"./modules/inspection-report/routes": [
		64069,
		9,
		64069
	],
	"./modules/inspection-report/routes/": [
		64069,
		9,
		64069
	],
	"./modules/inspection-report/routes/index": [
		64069,
		9,
		64069
	],
	"./modules/inspection-report/routes/index.tsx": [
		64069,
		9,
		64069
	],
	"./modules/inventory/assets/images/delivered.png": [
		56784,
		1,
		56784
	],
	"./modules/inventory/assets/images/icon/barcode.png": [
		73020,
		1,
		73020
	],
	"./modules/inventory/components/internal-delivery/DeliveryNote": [
		52713,
		9,
		20691,
		27682,
		56780,
		21669
	],
	"./modules/inventory/components/internal-delivery/DeliveryNote.tsx": [
		52713,
		9,
		20691,
		27682,
		56780,
		21669
	],
	"./modules/inventory/components/internal-delivery/IDVPdf": [
		44618,
		9,
		27682,
		39470
	],
	"./modules/inventory/components/internal-delivery/IDVPdf.tsx": [
		44618,
		9,
		27682,
		39470
	],
	"./modules/inventory/components/internal-delivery/InternalDeliveryExportView": [
		28215,
		9,
		20691,
		27682,
		56780,
		49275
	],
	"./modules/inventory/components/internal-delivery/InternalDeliveryExportView.tsx": [
		28215,
		9,
		20691,
		27682,
		56780,
		49275
	],
	"./modules/inventory/components/internal-delivery/InternalDeliveryTable": [
		56780,
		9,
		20691,
		27682,
		56780,
		50477
	],
	"./modules/inventory/components/internal-delivery/InternalDeliveryTable.tsx": [
		56780,
		9,
		20691,
		27682,
		56780,
		50477
	],
	"./modules/inventory/components/internal-delivery/Preview": [
		11217,
		9,
		20691,
		27682,
		44381
	],
	"./modules/inventory/components/internal-delivery/Preview.tsx": [
		11217,
		9,
		20691,
		27682,
		44381
	],
	"./modules/inventory/components/internal-delivery/transfer-add/SerialModel": [
		74860,
		9,
		74860
	],
	"./modules/inventory/components/internal-delivery/transfer-add/SerialModel.tsx": [
		74860,
		9,
		74860
	],
	"./modules/inventory/components/internal-delivery/transfer-add/TransferAdd": [
		50505,
		9,
		93889,
		50505,
		84010
	],
	"./modules/inventory/components/internal-delivery/transfer-add/TransferAdd.tsx": [
		50505,
		9,
		93889,
		50505,
		84010
	],
	"./modules/inventory/components/internal-delivery/transfer-add/TransferAddTable": [
		99493,
		9,
		93889,
		99493
	],
	"./modules/inventory/components/internal-delivery/transfer-add/TransferAddTable.tsx": [
		99493,
		9,
		93889,
		99493
	],
	"./modules/inventory/components/inventory-delivering/DeliverTable": [
		76382,
		9,
		20691,
		27682,
		47079,
		8460
	],
	"./modules/inventory/components/inventory-delivering/DeliverTable.tsx": [
		76382,
		9,
		20691,
		27682,
		47079,
		8460
	],
	"./modules/inventory/components/inventory-delivering/DeliveryVoucherAddTable": [
		63074,
		9,
		93889,
		63074
	],
	"./modules/inventory/components/inventory-delivering/DeliveryVoucherAddTable.tsx": [
		63074,
		9,
		93889,
		63074
	],
	"./modules/inventory/components/inventory-delivering/DeliveryVoucherExportView": [
		97252,
		9,
		97252
	],
	"./modules/inventory/components/inventory-delivering/DeliveryVoucherExportView.tsx": [
		97252,
		9,
		97252
	],
	"./modules/inventory/components/inventory-delivering/DeliveryVouhcerPDF": [
		43949,
		9,
		27682,
		60529
	],
	"./modules/inventory/components/inventory-delivering/DeliveryVouhcerPDF.tsx": [
		43949,
		9,
		27682,
		60529
	],
	"./modules/inventory/components/inventory-delivering/DelveryVoucher": [
		39204,
		9,
		93889,
		39204,
		84010
	],
	"./modules/inventory/components/inventory-delivering/DelveryVoucher.tsx": [
		39204,
		9,
		93889,
		39204,
		84010
	],
	"./modules/inventory/components/inventory-delivering/Preview": [
		47079,
		9,
		20691,
		27682,
		47079,
		43901
	],
	"./modules/inventory/components/inventory-delivering/Preview.tsx": [
		47079,
		9,
		20691,
		27682,
		47079,
		43901
	],
	"./modules/inventory/components/inventory-delivering/SerialModel": [
		62064,
		9,
		62064
	],
	"./modules/inventory/components/inventory-delivering/SerialModel.tsx": [
		62064,
		9,
		62064
	],
	"./modules/inventory/components/inventory-delivering/VoucherDeliver": [
		3070,
		9,
		20691,
		27682,
		47079,
		11468
	],
	"./modules/inventory/components/inventory-delivering/VoucherDeliver.tsx": [
		3070,
		9,
		20691,
		27682,
		47079,
		11468
	],
	"./modules/inventory/components/inventory-issues/InventoryIssueNotes": [
		34814,
		9,
		20691,
		27682,
		92480,
		16236
	],
	"./modules/inventory/components/inventory-issues/InventoryIssueNotes.tsx": [
		34814,
		9,
		20691,
		27682,
		92480,
		16236
	],
	"./modules/inventory/components/inventory-issues/IssueNote": [
		20719,
		9,
		20719,
		73020
	],
	"./modules/inventory/components/inventory-issues/IssueNote.tsx": [
		20719,
		9,
		20719,
		73020
	],
	"./modules/inventory/components/inventory-issues/IssueNoteAddTable": [
		29016,
		9,
		29016
	],
	"./modules/inventory/components/inventory-issues/IssueNoteAddTable.tsx": [
		29016,
		9,
		29016
	],
	"./modules/inventory/components/inventory-issues/IssueNotePDF": [
		43417,
		9,
		27682,
		26037
	],
	"./modules/inventory/components/inventory-issues/IssueNotePDF.tsx": [
		43417,
		9,
		27682,
		26037
	],
	"./modules/inventory/components/inventory-issues/Preview": [
		62402,
		9,
		20691,
		27682,
		11414
	],
	"./modules/inventory/components/inventory-issues/Preview.tsx": [
		62402,
		9,
		20691,
		27682,
		11414
	],
	"./modules/inventory/components/inventory-issues/SerialModel": [
		30317,
		9,
		30317
	],
	"./modules/inventory/components/inventory-issues/SerialModel.tsx": [
		30317,
		9,
		30317
	],
	"./modules/inventory/components/inventory-issues/tables/InventoryIssueNotesTable": [
		92480,
		9,
		20691,
		27682,
		92480,
		43901
	],
	"./modules/inventory/components/inventory-issues/tables/InventoryIssueNotesTable.tsx": [
		92480,
		9,
		20691,
		27682,
		92480,
		43901
	],
	"./modules/inventory/components/inventory-receiving/BarcodePdf": [
		44136,
		9,
		27682,
		59298,
		75052
	],
	"./modules/inventory/components/inventory-receiving/BarcodePdf.tsx": [
		44136,
		9,
		27682,
		59298,
		75052
	],
	"./modules/inventory/components/inventory-receiving/DamageGRNItem": [
		23143,
		9,
		27682,
		59298,
		8875
	],
	"./modules/inventory/components/inventory-receiving/DamageGRNItem.tsx": [
		23143,
		9,
		27682,
		59298,
		8875
	],
	"./modules/inventory/components/inventory-receiving/Preview": [
		2724,
		9,
		20691,
		27682,
		59298,
		66354,
		2724
	],
	"./modules/inventory/components/inventory-receiving/Preview.tsx": [
		2724,
		9,
		20691,
		27682,
		59298,
		66354,
		2724
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucher": [
		91995,
		9,
		20691,
		27682,
		59298,
		66354,
		2724,
		91995
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucher.tsx": [
		91995,
		9,
		20691,
		27682,
		59298,
		66354,
		2724,
		91995
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucherAddEditBody": [
		5053,
		9,
		86178,
		93889,
		34227,
		5053,
		21665
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucherAddEditBody.tsx": [
		5053,
		9,
		86178,
		93889,
		34227,
		5053,
		21665
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucherAddEditTable": [
		26221,
		9,
		86178,
		93889,
		34227,
		26221
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucherAddEditTable copy.txt": [
		32976,
		1,
		32976
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucherAddEditTable.tsx": [
		26221,
		9,
		86178,
		93889,
		34227,
		26221
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucherExportView": [
		17255,
		9,
		17255
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucherExportView.tsx": [
		17255,
		9,
		17255
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucherPDF": [
		87350,
		9,
		27682,
		66354
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucherPDF.tsx": [
		87350,
		9,
		27682,
		66354
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucherTable": [
		40156,
		9,
		20691,
		27682,
		59298,
		66354,
		2724,
		40156
	],
	"./modules/inventory/components/inventory-receiving/ReceivingVoucherTable.tsx": [
		40156,
		9,
		20691,
		27682,
		59298,
		66354,
		2724,
		40156
	],
	"./modules/inventory/components/inventory-receiving/SerialModel": [
		2303,
		9,
		86178,
		34227,
		2303
	],
	"./modules/inventory/components/inventory-receiving/SerialModel.tsx": [
		2303,
		9,
		86178,
		34227,
		2303
	],
	"./modules/inventory/components/item/ItemDetails": [
		9619,
		9,
		20691,
		48969,
		85167,
		28737,
		70791,
		57754,
		600,
		48997
	],
	"./modules/inventory/components/item/ItemDetails.tsx": [
		9619,
		9,
		20691,
		48969,
		85167,
		28737,
		70791,
		57754,
		600,
		48997
	],
	"./modules/inventory/components/item/ItemList": [
		51605,
		9,
		51605
	],
	"./modules/inventory/components/item/ItemList.tsx": [
		51605,
		9,
		51605
	],
	"./modules/inventory/components/item/add_edit_item/AddEditItem": [
		98533,
		9,
		98533,
		21948
	],
	"./modules/inventory/components/item/add_edit_item/AddEditItem.tsx": [
		98533,
		9,
		98533,
		21948
	],
	"./modules/inventory/components/item/add_edit_item/tabs/GeneralTab": [
		603,
		9,
		603
	],
	"./modules/inventory/components/item/add_edit_item/tabs/GeneralTab.tsx": [
		603,
		9,
		603
	],
	"./modules/inventory/components/item/add_edit_item/tabs/PricingTab": [
		93333,
		9,
		93333
	],
	"./modules/inventory/components/item/add_edit_item/tabs/PricingTab.tsx": [
		93333,
		9,
		93333
	],
	"./modules/inventory/components/item/add_edit_item/tabs/PropertyTab": [
		93608,
		9,
		93608
	],
	"./modules/inventory/components/item/add_edit_item/tabs/PropertyTab.tsx": [
		93608,
		9,
		93608
	],
	"./modules/inventory/components/item/common/charts/PurchaseSalesChart": [
		94369,
		9,
		94369
	],
	"./modules/inventory/components/item/common/charts/PurchaseSalesChart.tsx": [
		94369,
		9,
		94369
	],
	"./modules/inventory/components/item/common/charts/ReturnSalesChart": [
		55134,
		9,
		55134
	],
	"./modules/inventory/components/item/common/charts/ReturnSalesChart.tsx": [
		55134,
		9,
		55134
	],
	"./modules/inventory/components/item/common/charts/WarehouseChart": [
		92460,
		9,
		70079
	],
	"./modules/inventory/components/item/common/charts/WarehouseChart.tsx": [
		92460,
		9,
		70079
	],
	"./modules/inventory/components/item/common/data/ItemsData": [
		45923,
		9,
		45923
	],
	"./modules/inventory/components/item/common/data/ItemsData.ts": [
		45923,
		9,
		45923
	],
	"./modules/inventory/components/item/item-components/ItemAddBody": [
		14863,
		9,
		14863
	],
	"./modules/inventory/components/item/item-components/ItemAddBody.tsx": [
		14863,
		9,
		14863
	],
	"./modules/inventory/components/item/item-components/ItemTabs": [
		600,
		9,
		20691,
		48969,
		85167,
		28737,
		70791,
		57754,
		600,
		76263
	],
	"./modules/inventory/components/item/item-components/ItemTabs.tsx": [
		600,
		9,
		20691,
		48969,
		85167,
		28737,
		70791,
		57754,
		600,
		76263
	],
	"./modules/inventory/components/item/item-components/item-tabs/ActivityLogs": [
		41234,
		9,
		41234
	],
	"./modules/inventory/components/item/item-components/item-tabs/ActivityLogs.tsx": [
		41234,
		9,
		41234
	],
	"./modules/inventory/components/item/item-components/item-tabs/Overview": [
		63537,
		9,
		20691,
		48969,
		85167,
		28737,
		70791,
		57754,
		63537
	],
	"./modules/inventory/components/item/item-components/item-tabs/Overview.tsx": [
		63537,
		9,
		20691,
		48969,
		85167,
		28737,
		70791,
		57754,
		63537
	],
	"./modules/inventory/components/item/item-components/item-tabs/SerialNumberTrackingTable": [
		1634,
		9,
		1634
	],
	"./modules/inventory/components/item/item-components/item-tabs/SerialNumberTrackingTable.tsx": [
		1634,
		9,
		1634
	],
	"./modules/inventory/components/item/item-components/item-tabs/StockInventory": [
		48586,
		9,
		48586
	],
	"./modules/inventory/components/item/item-components/item-tabs/StockInventory.tsx": [
		48586,
		9,
		48586
	],
	"./modules/inventory/components/item/item-components/item-tabs/TransactionsHistory": [
		80099,
		9,
		80099
	],
	"./modules/inventory/components/item/item-components/item-tabs/TransactionsHistory.tsx": [
		80099,
		9,
		80099
	],
	"./modules/inventory/components/item/item-components/itemTable": [
		23766,
		9,
		23766
	],
	"./modules/inventory/components/item/item-components/itemTable.tsx": [
		23766,
		9,
		23766
	],
	"./modules/inventory/components/packaging-list/PackageList": [
		12693,
		9,
		20691,
		27682,
		75165,
		86251
	],
	"./modules/inventory/components/packaging-list/PackageList.tsx": [
		12693,
		9,
		20691,
		27682,
		75165,
		86251
	],
	"./modules/inventory/components/packaging-list/PackageTable": [
		75165,
		9,
		20691,
		27682,
		75165,
		39135
	],
	"./modules/inventory/components/packaging-list/PackageTable.tsx": [
		75165,
		9,
		20691,
		27682,
		75165,
		39135
	],
	"./modules/inventory/components/packaging-list/PackingPDF": [
		59876,
		9,
		27682,
		72464
	],
	"./modules/inventory/components/packaging-list/PackingPDF.tsx": [
		59876,
		9,
		27682,
		72464
	],
	"./modules/inventory/components/packaging-list/Preview": [
		58189,
		9,
		20691,
		27682,
		18833
	],
	"./modules/inventory/components/packaging-list/Preview.tsx": [
		58189,
		9,
		20691,
		27682,
		18833
	],
	"./modules/inventory/components/packaging-list/ShipmentAdd": [
		59746,
		9,
		59746
	],
	"./modules/inventory/components/packaging-list/ShipmentAdd.tsx": [
		59746,
		9,
		59746
	],
	"./modules/inventory/components/reports/InventoryReports": [
		18391,
		9,
		69993,
		15751,
		60199,
		18391,
		25819
	],
	"./modules/inventory/components/reports/InventoryReports.tsx": [
		18391,
		9,
		69993,
		15751,
		60199,
		18391,
		25819
	],
	"./modules/inventory/components/reports/tabs/CategoryWiseLowStock": [
		33263,
		9,
		33263
	],
	"./modules/inventory/components/reports/tabs/CategoryWiseLowStock.tsx": [
		33263,
		9,
		33263
	],
	"./modules/inventory/components/reports/tabs/CustomersSummary": [
		46554,
		9,
		46554
	],
	"./modules/inventory/components/reports/tabs/CustomersSummary.tsx": [
		46554,
		9,
		46554
	],
	"./modules/inventory/components/reports/tabs/ItemsReports": [
		17130,
		9,
		60199,
		17130
	],
	"./modules/inventory/components/reports/tabs/ItemsReports.tsx": [
		17130,
		9,
		60199,
		17130
	],
	"./modules/inventory/components/reports/tabs/LotWiseStockReports": [
		88369,
		9,
		88369
	],
	"./modules/inventory/components/reports/tabs/LotWiseStockReports.tsx": [
		88369,
		9,
		88369
	],
	"./modules/inventory/components/reports/tabs/ProductPurchaseReport": [
		86513,
		9,
		86513
	],
	"./modules/inventory/components/reports/tabs/ProductPurchaseReport.tsx": [
		86513,
		9,
		86513
	],
	"./modules/inventory/components/reports/tabs/ProductSellReport": [
		50708,
		9,
		50708
	],
	"./modules/inventory/components/reports/tabs/ProductSellReport.tsx": [
		50708,
		9,
		50708
	],
	"./modules/inventory/components/reports/tabs/PurchaseAndSales": [
		34495,
		9,
		69993,
		15751,
		34495
	],
	"./modules/inventory/components/reports/tabs/PurchaseAndSales.tsx": [
		34495,
		9,
		69993,
		15751,
		34495
	],
	"./modules/inventory/components/reports/tabs/ReorderLevelReport": [
		80812,
		9,
		80812
	],
	"./modules/inventory/components/reports/tabs/ReorderLevelReport.tsx": [
		80812,
		9,
		80812
	],
	"./modules/inventory/components/reports/tabs/StockAdjustmentReport": [
		29446,
		9,
		15751,
		29446
	],
	"./modules/inventory/components/reports/tabs/StockAdjustmentReport.tsx": [
		29446,
		9,
		15751,
		29446
	],
	"./modules/inventory/components/reports/tabs/StockAgeing": [
		34493,
		9,
		56874
	],
	"./modules/inventory/components/reports/tabs/StockAgeing.tsx": [
		34493,
		9,
		56874
	],
	"./modules/inventory/components/reports/tabs/StockBalance": [
		30889,
		9,
		30889
	],
	"./modules/inventory/components/reports/tabs/StockBalance.tsx": [
		30889,
		9,
		30889
	],
	"./modules/inventory/components/reports/tabs/StockLedger": [
		8482,
		9,
		69993,
		15751,
		8482
	],
	"./modules/inventory/components/reports/tabs/StockLedger.tsx": [
		8482,
		9,
		69993,
		15751,
		8482
	],
	"./modules/inventory/components/reports/tabs/StockReport": [
		9967,
		9,
		9967
	],
	"./modules/inventory/components/reports/tabs/StockReport.tsx": [
		9967,
		9,
		9967
	],
	"./modules/inventory/components/reports/tabs/SupplierSummary": [
		2547,
		9,
		2547
	],
	"./modules/inventory/components/reports/tabs/SupplierSummary.tsx": [
		2547,
		9,
		2547
	],
	"./modules/inventory/components/reports/tabs/TrendingProducts": [
		65819,
		9,
		88200
	],
	"./modules/inventory/components/reports/tabs/TrendingProducts.tsx": [
		65819,
		9,
		88200
	],
	"./modules/inventory/components/reports/tabs/WarehouseWiseStockBalance": [
		3780,
		9,
		3780
	],
	"./modules/inventory/components/reports/tabs/WarehouseWiseStockBalance.tsx": [
		3780,
		9,
		3780
	],
	"./modules/inventory/components/reports/tabs/components/PurchaseAndSalesCards": [
		53823,
		9,
		69993,
		15751,
		53823
	],
	"./modules/inventory/components/reports/tabs/components/PurchaseAndSalesCards.tsx": [
		53823,
		9,
		69993,
		15751,
		53823
	],
	"./modules/inventory/components/reports/tabs/components/StockAdjustmentStatistics": [
		14180,
		9,
		15751,
		14180
	],
	"./modules/inventory/components/reports/tabs/components/StockAdjustmentStatistics.tsx": [
		14180,
		9,
		15751,
		14180
	],
	"./modules/inventory/components/reports/tabs/components/StockLedgerStatistics": [
		70342,
		9,
		69993,
		15751,
		70342
	],
	"./modules/inventory/components/reports/tabs/components/StockLedgerStatistics.tsx": [
		70342,
		9,
		69993,
		15751,
		70342
	],
	"./modules/inventory/components/reports/tabs/components/TrendingProductsChart": [
		10411,
		9,
		10411
	],
	"./modules/inventory/components/reports/tabs/components/TrendingProductsChart.tsx": [
		10411,
		9,
		10411
	],
	"./modules/inventory/components/reports/tabs/tables/CategoryWiseLowStockTable": [
		18501,
		9,
		18501
	],
	"./modules/inventory/components/reports/tabs/tables/CategoryWiseLowStockTable.tsx": [
		18501,
		9,
		18501
	],
	"./modules/inventory/components/reports/tabs/tables/CustomersSummaryTable": [
		13014,
		9,
		13014
	],
	"./modules/inventory/components/reports/tabs/tables/CustomersSummaryTable.tsx": [
		13014,
		9,
		13014
	],
	"./modules/inventory/components/reports/tabs/tables/ItemReportsTable": [
		60199,
		9,
		60199
	],
	"./modules/inventory/components/reports/tabs/tables/ItemReportsTable.tsx": [
		60199,
		9,
		60199
	],
	"./modules/inventory/components/reports/tabs/tables/LotWiseStockReportTable": [
		61300,
		9,
		61300
	],
	"./modules/inventory/components/reports/tabs/tables/LotWiseStockReportTable.tsx": [
		61300,
		9,
		61300
	],
	"./modules/inventory/components/reports/tabs/tables/ProductPurchaseReportTable": [
		51711,
		9,
		51711
	],
	"./modules/inventory/components/reports/tabs/tables/ProductPurchaseReportTable.tsx": [
		51711,
		9,
		51711
	],
	"./modules/inventory/components/reports/tabs/tables/ProductSellReportTable": [
		67844,
		9,
		67844
	],
	"./modules/inventory/components/reports/tabs/tables/ProductSellReportTable.tsx": [
		67844,
		9,
		67844
	],
	"./modules/inventory/components/reports/tabs/tables/ReorderLevelReportTable": [
		86332,
		9,
		86332
	],
	"./modules/inventory/components/reports/tabs/tables/ReorderLevelReportTable.tsx": [
		86332,
		9,
		86332
	],
	"./modules/inventory/components/reports/tabs/tables/StockAdjustmentReportTable": [
		87114,
		9,
		87114
	],
	"./modules/inventory/components/reports/tabs/tables/StockAdjustmentReportTable.tsx": [
		87114,
		9,
		87114
	],
	"./modules/inventory/components/reports/tabs/tables/StockAgeingTable": [
		6394,
		9,
		6394
	],
	"./modules/inventory/components/reports/tabs/tables/StockAgeingTable.tsx": [
		6394,
		9,
		6394
	],
	"./modules/inventory/components/reports/tabs/tables/StockBalanceTable": [
		97787,
		9,
		97787
	],
	"./modules/inventory/components/reports/tabs/tables/StockBalanceTable.tsx": [
		97787,
		9,
		97787
	],
	"./modules/inventory/components/reports/tabs/tables/StockLedgerTable": [
		52006,
		9,
		52006
	],
	"./modules/inventory/components/reports/tabs/tables/StockLedgerTable.tsx": [
		52006,
		9,
		52006
	],
	"./modules/inventory/components/reports/tabs/tables/StockReportTable": [
		72853,
		9,
		72853
	],
	"./modules/inventory/components/reports/tabs/tables/StockReportTable.tsx": [
		72853,
		9,
		72853
	],
	"./modules/inventory/components/reports/tabs/tables/SuppiersSummaryTable": [
		9742,
		9,
		9742
	],
	"./modules/inventory/components/reports/tabs/tables/SuppiersSummaryTable.tsx": [
		9742,
		9,
		9742
	],
	"./modules/inventory/components/reports/tabs/tables/TrendingProductsTable": [
		89344,
		9,
		89344
	],
	"./modules/inventory/components/reports/tabs/tables/TrendingProductsTable.tsx": [
		89344,
		9,
		89344
	],
	"./modules/inventory/components/reports/tabs/tables/WarehouseWiseStockBalanceTable": [
		18564,
		9,
		18564
	],
	"./modules/inventory/components/reports/tabs/tables/WarehouseWiseStockBalanceTable.tsx": [
		18564,
		9,
		18564
	],
	"./modules/inventory/components/return-orders/OrderReturnAdd": [
		33758,
		9,
		93889,
		33758,
		21665
	],
	"./modules/inventory/components/return-orders/OrderReturnAdd.tsx": [
		33758,
		9,
		93889,
		33758,
		21665
	],
	"./modules/inventory/components/return-orders/OrderReturnAddTable": [
		43396,
		9,
		93889,
		43396
	],
	"./modules/inventory/components/return-orders/OrderReturnAddTable.tsx": [
		43396,
		9,
		93889,
		43396
	],
	"./modules/inventory/components/return-orders/Preview": [
		7297,
		9,
		20691,
		27682,
		37933
	],
	"./modules/inventory/components/return-orders/Preview.tsx": [
		7297,
		9,
		20691,
		27682,
		37933
	],
	"./modules/inventory/components/return-orders/ReturnOrderExportView": [
		67802,
		9,
		67802
	],
	"./modules/inventory/components/return-orders/ReturnOrderExportView.tsx": [
		67802,
		9,
		67802
	],
	"./modules/inventory/components/return-orders/ReturnOrderPDF": [
		78533,
		9,
		27682,
		23545
	],
	"./modules/inventory/components/return-orders/ReturnOrderPDF.tsx": [
		78533,
		9,
		27682,
		23545
	],
	"./modules/inventory/components/return-orders/ReturnOrders": [
		80160,
		9,
		20691,
		27682,
		24878,
		63347
	],
	"./modules/inventory/components/return-orders/ReturnOrders.tsx": [
		80160,
		9,
		20691,
		27682,
		24878,
		63347
	],
	"./modules/inventory/components/return-orders/ReturnOrdersTable": [
		24878,
		9,
		20691,
		27682,
		24878,
		64232
	],
	"./modules/inventory/components/return-orders/ReturnOrdersTable.tsx": [
		24878,
		9,
		20691,
		27682,
		24878,
		64232
	],
	"./modules/inventory/components/return-orders/SerialModel": [
		49538,
		9,
		49538
	],
	"./modules/inventory/components/return-orders/SerialModel.tsx": [
		49538,
		9,
		49538
	],
	"./modules/inventory/components/settings/components/Sizes/SizesAdd": [
		69861,
		9,
		69861
	],
	"./modules/inventory/components/settings/components/Sizes/SizesAdd.tsx": [
		69861,
		9,
		69861
	],
	"./modules/inventory/components/settings/components/Sizes/SizesComponent": [
		79149,
		9,
		79149
	],
	"./modules/inventory/components/settings/components/Sizes/SizesComponent.tsx": [
		79149,
		9,
		79149
	],
	"./modules/inventory/components/settings/components/Sizes/SizesTable": [
		28012,
		9,
		28012
	],
	"./modules/inventory/components/settings/components/Sizes/SizesTable.tsx": [
		28012,
		9,
		28012
	],
	"./modules/inventory/components/settings/components/approval-settings/ApprovalSettings": [
		71029,
		9,
		71029
	],
	"./modules/inventory/components/settings/components/approval-settings/ApprovalSettings.tsx": [
		71029,
		9,
		71029
	],
	"./modules/inventory/components/settings/components/approval-settings/ApprovalSettingsAdd": [
		19372,
		9,
		19372
	],
	"./modules/inventory/components/settings/components/approval-settings/ApprovalSettingsAdd.tsx": [
		19372,
		9,
		19372
	],
	"./modules/inventory/components/settings/components/approval-settings/ApprovalSettingsTable": [
		87409,
		9,
		87409
	],
	"./modules/inventory/components/settings/components/approval-settings/ApprovalSettingsTable.tsx": [
		87409,
		9,
		87409
	],
	"./modules/inventory/components/settings/components/brand/BrandAdd": [
		96085,
		9,
		96085
	],
	"./modules/inventory/components/settings/components/brand/BrandAdd.tsx": [
		96085,
		9,
		96085
	],
	"./modules/inventory/components/settings/components/brand/BrandComponent": [
		21533,
		9,
		21533
	],
	"./modules/inventory/components/settings/components/brand/BrandComponent.tsx": [
		21533,
		9,
		21533
	],
	"./modules/inventory/components/settings/components/brand/BrandTable": [
		9551,
		9,
		31932
	],
	"./modules/inventory/components/settings/components/brand/BrandTable.tsx": [
		9551,
		9,
		31932
	],
	"./modules/inventory/components/settings/components/category/Category": [
		76696,
		9,
		76696
	],
	"./modules/inventory/components/settings/components/category/Category.tsx": [
		76696,
		9,
		76696
	],
	"./modules/inventory/components/settings/components/category/CategoryAdd": [
		49067,
		9,
		49067
	],
	"./modules/inventory/components/settings/components/category/CategoryAdd.tsx": [
		49067,
		9,
		49067
	],
	"./modules/inventory/components/settings/components/category/CategoryTable": [
		37510,
		9,
		37510
	],
	"./modules/inventory/components/settings/components/category/CategoryTable.tsx": [
		37510,
		9,
		37510
	],
	"./modules/inventory/components/settings/components/colors/Colors": [
		31052,
		9,
		31052
	],
	"./modules/inventory/components/settings/components/colors/Colors.tsx": [
		31052,
		9,
		31052
	],
	"./modules/inventory/components/settings/components/colors/ColorsAdd": [
		26471,
		9,
		26471
	],
	"./modules/inventory/components/settings/components/colors/ColorsAdd.tsx": [
		26471,
		9,
		26471
	],
	"./modules/inventory/components/settings/components/colors/ColorsTable": [
		79594,
		9,
		79594
	],
	"./modules/inventory/components/settings/components/colors/ColorsTable.tsx": [
		79594,
		9,
		79594
	],
	"./modules/inventory/components/settings/components/general/General": [
		34262,
		9,
		16887,
		34262
	],
	"./modules/inventory/components/settings/components/general/General.tsx": [
		34262,
		9,
		16887,
		34262
	],
	"./modules/inventory/components/settings/components/general/SettingsTabs": [
		16887,
		9,
		16887
	],
	"./modules/inventory/components/settings/components/general/SettingsTabs.tsx": [
		16887,
		9,
		16887
	],
	"./modules/inventory/components/settings/components/general/Tabs/ItemSettings": [
		90907,
		9,
		90907
	],
	"./modules/inventory/components/settings/components/general/Tabs/ItemSettings.tsx": [
		90907,
		9,
		90907
	],
	"./modules/inventory/components/settings/components/general/Tabs/PDFSettings": [
		69528,
		9,
		47147
	],
	"./modules/inventory/components/settings/components/general/Tabs/PDFSettings.tsx": [
		69528,
		9,
		47147
	],
	"./modules/inventory/components/settings/components/general/Tabs/ReceivingAndDeliverying": [
		56694,
		9,
		56694
	],
	"./modules/inventory/components/settings/components/general/Tabs/ReceivingAndDeliverying.tsx": [
		56694,
		9,
		56694
	],
	"./modules/inventory/components/settings/components/general/Tabs/ReceivingExporting": [
		51109,
		9,
		51109
	],
	"./modules/inventory/components/settings/components/general/Tabs/ReceivingExporting.tsx": [
		51109,
		9,
		51109
	],
	"./modules/inventory/components/settings/components/general/Tabs/SerialNumbers": [
		82151,
		9,
		82151
	],
	"./modules/inventory/components/settings/components/general/Tabs/SerialNumbers.tsx": [
		82151,
		9,
		82151
	],
	"./modules/inventory/components/settings/components/general/Tabs/Shipments": [
		78608,
		9,
		78608
	],
	"./modules/inventory/components/settings/components/general/Tabs/Shipments.tsx": [
		78608,
		9,
		78608
	],
	"./modules/inventory/components/settings/components/group/Group": [
		55658,
		9,
		55658
	],
	"./modules/inventory/components/settings/components/group/Group.tsx": [
		55658,
		9,
		55658
	],
	"./modules/inventory/components/settings/components/group/GroupAdd": [
		17441,
		9,
		17441
	],
	"./modules/inventory/components/settings/components/group/GroupAdd.tsx": [
		17441,
		9,
		17441
	],
	"./modules/inventory/components/settings/components/group/GroupTable": [
		66832,
		9,
		66832
	],
	"./modules/inventory/components/settings/components/group/GroupTable.tsx": [
		66832,
		9,
		66832
	],
	"./modules/inventory/components/settings/components/min-max-inventory/InventoryTable": [
		45842,
		9,
		45842
	],
	"./modules/inventory/components/settings/components/min-max-inventory/InventoryTable.tsx": [
		45842,
		9,
		45842
	],
	"./modules/inventory/components/settings/components/min-max-inventory/MinMaxInventory": [
		89246,
		9,
		89246
	],
	"./modules/inventory/components/settings/components/min-max-inventory/MinMaxInventory.tsx": [
		89246,
		9,
		89246
	],
	"./modules/inventory/components/settings/components/model/ModalAdd": [
		27265,
		9,
		27265
	],
	"./modules/inventory/components/settings/components/model/ModalAdd.tsx": [
		27265,
		9,
		27265
	],
	"./modules/inventory/components/settings/components/model/ModelComponent": [
		60725,
		9,
		60725
	],
	"./modules/inventory/components/settings/components/model/ModelComponent.tsx": [
		60725,
		9,
		60725
	],
	"./modules/inventory/components/settings/components/model/ModelTable": [
		36468,
		9,
		36468
	],
	"./modules/inventory/components/settings/components/model/ModelTable.tsx": [
		36468,
		9,
		36468
	],
	"./modules/inventory/components/settings/components/prefix-settings/PrefixSettings": [
		42585,
		9,
		42585
	],
	"./modules/inventory/components/settings/components/prefix-settings/PrefixSettings.tsx": [
		42585,
		9,
		42585
	],
	"./modules/inventory/components/settings/components/reset/ResetData": [
		67818,
		9,
		67818
	],
	"./modules/inventory/components/settings/components/reset/ResetData.tsx": [
		67818,
		9,
		67818
	],
	"./modules/inventory/components/settings/components/sub_category/SubCategory": [
		64413,
		9,
		64413
	],
	"./modules/inventory/components/settings/components/sub_category/SubCategory.tsx": [
		64413,
		9,
		64413
	],
	"./modules/inventory/components/settings/components/sub_category/SubCategoryAdd": [
		68612,
		9,
		68612
	],
	"./modules/inventory/components/settings/components/sub_category/SubCategoryAdd.tsx": [
		68612,
		9,
		68612
	],
	"./modules/inventory/components/settings/components/sub_category/SubCategoryTable": [
		17689,
		9,
		17689
	],
	"./modules/inventory/components/settings/components/sub_category/SubCategoryTable.tsx": [
		17689,
		9,
		17689
	],
	"./modules/inventory/components/settings/components/sub_category_2/SubCategory2": [
		78130,
		9,
		78130
	],
	"./modules/inventory/components/settings/components/sub_category_2/SubCategory2.tsx": [
		78130,
		9,
		78130
	],
	"./modules/inventory/components/settings/components/sub_category_2/SubCategoryAdd_2": [
		33554,
		9,
		33554
	],
	"./modules/inventory/components/settings/components/sub_category_2/SubCategoryAdd_2.tsx": [
		33554,
		9,
		33554
	],
	"./modules/inventory/components/settings/components/sub_category_2/SubCategoryTable_2": [
		82739,
		9,
		82739
	],
	"./modules/inventory/components/settings/components/sub_category_2/SubCategoryTable_2.tsx": [
		82739,
		9,
		82739
	],
	"./modules/inventory/components/settings/components/sub_category_3/SubCategory3": [
		81804,
		9,
		81804
	],
	"./modules/inventory/components/settings/components/sub_category_3/SubCategory3.tsx": [
		81804,
		9,
		81804
	],
	"./modules/inventory/components/settings/components/sub_category_3/SubCategoryAdd_3": [
		67848,
		9,
		67848
	],
	"./modules/inventory/components/settings/components/sub_category_3/SubCategoryAdd_3.tsx": [
		67848,
		9,
		67848
	],
	"./modules/inventory/components/settings/components/sub_category_3/SubCategoryTable_3": [
		72585,
		9,
		72585
	],
	"./modules/inventory/components/settings/components/sub_category_3/SubCategoryTable_3.tsx": [
		72585,
		9,
		72585
	],
	"./modules/inventory/components/settings/components/unit/Unit": [
		51408,
		9,
		51408
	],
	"./modules/inventory/components/settings/components/unit/Unit.tsx": [
		51408,
		9,
		51408
	],
	"./modules/inventory/components/settings/components/unit/UnitAdd": [
		32128,
		9,
		9747
	],
	"./modules/inventory/components/settings/components/unit/UnitAdd.tsx": [
		32128,
		9,
		9747
	],
	"./modules/inventory/components/settings/components/unit/UnitTable": [
		61649,
		9,
		84030
	],
	"./modules/inventory/components/settings/components/unit/UnitTable.tsx": [
		61649,
		9,
		84030
	],
	"./modules/inventory/components/settings/components/warehouse-custom-fields/WarehouseCustomFieldsAdd": [
		47929,
		9,
		47929
	],
	"./modules/inventory/components/settings/components/warehouse-custom-fields/WarehouseCustomFieldsAdd.tsx": [
		47929,
		9,
		47929
	],
	"./modules/inventory/components/settings/components/warehouse-custom-fields/WarehouseFileds": [
		12317,
		9,
		12317
	],
	"./modules/inventory/components/settings/components/warehouse-custom-fields/WarehouseFileds.tsx": [
		12317,
		9,
		12317
	],
	"./modules/inventory/components/settings/components/warehouse-custom-fields/WarehouseTable": [
		53694,
		9,
		53694
	],
	"./modules/inventory/components/settings/components/warehouse-custom-fields/WarehouseTable.tsx": [
		53694,
		9,
		53694
	],
	"./modules/inventory/components/settings/components/warranty/WarrantyAdd": [
		32391,
		9,
		32391
	],
	"./modules/inventory/components/settings/components/warranty/WarrantyAdd.tsx": [
		32391,
		9,
		32391
	],
	"./modules/inventory/components/settings/components/warranty/WarrantyComponent": [
		44539,
		9,
		44539
	],
	"./modules/inventory/components/settings/components/warranty/WarrantyComponent.tsx": [
		44539,
		9,
		44539
	],
	"./modules/inventory/components/settings/components/warranty/WarrantyTable": [
		37066,
		9,
		37066
	],
	"./modules/inventory/components/settings/components/warranty/WarrantyTable.tsx": [
		37066,
		9,
		37066
	],
	"./modules/inventory/components/settings/inventorySettings": [
		24219,
		9,
		16887,
		24219,
		15574
	],
	"./modules/inventory/components/settings/inventorySettings.tsx": [
		24219,
		9,
		16887,
		24219,
		15574
	],
	"./modules/inventory/components/stock/Preview": [
		54455,
		9,
		20691,
		27682,
		97275
	],
	"./modules/inventory/components/stock/Preview.tsx": [
		54455,
		9,
		20691,
		27682,
		97275
	],
	"./modules/inventory/components/stock/Stock": [
		57677,
		9,
		20691,
		27682,
		71657,
		10979
	],
	"./modules/inventory/components/stock/Stock.tsx": [
		57677,
		9,
		20691,
		27682,
		71657,
		10979
	],
	"./modules/inventory/components/stock/StockAdjustmentPDF": [
		12292,
		9,
		27682,
		13264
	],
	"./modules/inventory/components/stock/StockAdjustmentPDF.tsx": [
		12292,
		9,
		27682,
		13264
	],
	"./modules/inventory/components/stock/StockTable": [
		71657,
		9,
		20691,
		27682,
		71657,
		39135
	],
	"./modules/inventory/components/stock/StockTable.tsx": [
		71657,
		9,
		20691,
		27682,
		71657,
		39135
	],
	"./modules/inventory/components/stock/stock-add/SerialModel": [
		62933,
		9,
		62933
	],
	"./modules/inventory/components/stock/stock-add/SerialModel.tsx": [
		62933,
		9,
		62933
	],
	"./modules/inventory/components/stock/stock-add/StockAdd": [
		87375,
		9,
		93889,
		87375,
		84010
	],
	"./modules/inventory/components/stock/stock-add/StockAdd.tsx": [
		87375,
		9,
		93889,
		87375,
		84010
	],
	"./modules/inventory/components/stock/stock-add/StockAddTable": [
		86651,
		9,
		93889,
		86651
	],
	"./modules/inventory/components/stock/stock-add/StockAddTable.tsx": [
		86651,
		9,
		93889,
		86651
	],
	"./modules/inventory/components/warehouse/AddBinLocation": [
		84215,
		9,
		84215
	],
	"./modules/inventory/components/warehouse/AddBinLocation.tsx": [
		84215,
		9,
		84215
	],
	"./modules/inventory/components/warehouse/BinLocationTab": [
		5261,
		9,
		5261
	],
	"./modules/inventory/components/warehouse/BinLocationTab.tsx": [
		5261,
		9,
		5261
	],
	"./modules/inventory/components/warehouse/BinLocationTable": [
		4792,
		9,
		4792
	],
	"./modules/inventory/components/warehouse/BinLocationTable.tsx": [
		4792,
		9,
		4792
	],
	"./modules/inventory/components/warehouse/Warehouse": [
		96029,
		9,
		96029,
		65031
	],
	"./modules/inventory/components/warehouse/Warehouse.tsx": [
		96029,
		9,
		96029,
		65031
	],
	"./modules/inventory/components/warehouse/WarehouseTab": [
		27140,
		9,
		27140
	],
	"./modules/inventory/components/warehouse/WarehouseTab.tsx": [
		27140,
		9,
		27140
	],
	"./modules/inventory/components/warehouse/WarehouseTable": [
		18073,
		9,
		18073
	],
	"./modules/inventory/components/warehouse/WarehouseTable.tsx": [
		18073,
		9,
		18073
	],
	"./modules/inventory/helpers/DataFormatHelper": [
		84610,
		9,
		84610
	],
	"./modules/inventory/helpers/DataFormatHelper.tsx": [
		84610,
		9,
		84610
	],
	"./modules/inventory/helpers/DeliveryVoucherHelper": [
		5817,
		9,
		5817
	],
	"./modules/inventory/helpers/DeliveryVoucherHelper.tsx": [
		5817,
		9,
		5817
	],
	"./modules/inventory/helpers/IssueNoteHelper": [
		90482,
		9,
		90482
	],
	"./modules/inventory/helpers/IssueNoteHelper.tsx": [
		90482,
		9,
		90482
	],
	"./modules/inventory/helpers/RecievingVoucherHelper": [
		32579,
		9,
		32579
	],
	"./modules/inventory/helpers/RecievingVoucherHelper.tsx": [
		32579,
		9,
		32579
	],
	"./modules/inventory/helpers/ReturnOrderHelper": [
		12169,
		9,
		12169
	],
	"./modules/inventory/helpers/ReturnOrderHelper.tsx": [
		12169,
		9,
		12169
	],
	"./modules/inventory/hooks/useDeliveryVoucherItems": [
		93783,
		9,
		93783
	],
	"./modules/inventory/hooks/useDeliveryVoucherItems.tsx": [
		93783,
		9,
		93783
	],
	"./modules/inventory/hooks/useInternalTransferItems": [
		6623,
		9,
		6623
	],
	"./modules/inventory/hooks/useInternalTransferItems.tsx": [
		6623,
		9,
		6623
	],
	"./modules/inventory/hooks/useIssueNoteItems": [
		12866,
		9,
		12866
	],
	"./modules/inventory/hooks/useIssueNoteItems.tsx": [
		12866,
		9,
		12866
	],
	"./modules/inventory/hooks/useReceivingVoucherItems": [
		81301,
		9,
		81301
	],
	"./modules/inventory/hooks/useReceivingVoucherItems.tsx": [
		81301,
		9,
		81301
	],
	"./modules/inventory/hooks/useReturnOrderItems": [
		8375,
		9,
		8375
	],
	"./modules/inventory/hooks/useReturnOrderItems.tsx": [
		8375,
		9,
		8375
	],
	"./modules/inventory/hooks/useStockAdjustment": [
		12286,
		9,
		12286
	],
	"./modules/inventory/hooks/useStockAdjustment.tsx": [
		12286,
		9,
		12286
	],
	"./modules/inventory/lang/en": [
		34255,
		9,
		34255
	],
	"./modules/inventory/lang/en.tsx": [
		34255,
		9,
		34255
	],
	"./modules/inventory/routes": [
		69086,
		9,
		20691,
		27682,
		69993,
		15751,
		86178,
		48969,
		93889,
		85167,
		34227,
		28737,
		59298,
		70791,
		57754,
		65027,
		66354,
		47079,
		56780,
		2724,
		16887,
		60199,
		600,
		92480,
		71657,
		24878,
		75165,
		24219,
		18391,
		5053,
		39204,
		69086
	],
	"./modules/inventory/routes/": [
		69086,
		9,
		20691,
		27682,
		69993,
		15751,
		86178,
		48969,
		93889,
		85167,
		34227,
		28737,
		59298,
		70791,
		57754,
		65027,
		66354,
		47079,
		56780,
		2724,
		16887,
		60199,
		600,
		92480,
		71657,
		24878,
		75165,
		24219,
		18391,
		5053,
		39204,
		69086
	],
	"./modules/inventory/routes/index": [
		69086,
		9,
		20691,
		27682,
		69993,
		15751,
		86178,
		48969,
		93889,
		85167,
		34227,
		28737,
		59298,
		70791,
		57754,
		65027,
		66354,
		47079,
		56780,
		2724,
		16887,
		60199,
		600,
		92480,
		71657,
		24878,
		75165,
		24219,
		18391,
		5053,
		39204,
		69086
	],
	"./modules/inventory/routes/index.tsx": [
		69086,
		9,
		20691,
		27682,
		69993,
		15751,
		86178,
		48969,
		93889,
		85167,
		34227,
		28737,
		59298,
		70791,
		57754,
		65027,
		66354,
		47079,
		56780,
		2724,
		16887,
		60199,
		600,
		92480,
		71657,
		24878,
		75165,
		24219,
		18391,
		5053,
		39204,
		69086
	],
	"./modules/inventory/types/types": [
		30828,
		9,
		30828
	],
	"./modules/inventory/types/types.tsx": [
		30828,
		9,
		30828
	],
	"./modules/jobs/JobCardDashboard": [
		46030,
		9,
		97285,
		68763,
		46030
	],
	"./modules/jobs/JobCardDashboard.tsx": [
		46030,
		9,
		97285,
		68763,
		46030
	],
	"./modules/jobs/JobCardList": [
		5408,
		9,
		97285,
		68763,
		5408,
		40583
	],
	"./modules/jobs/JobCardList.tsx": [
		5408,
		9,
		97285,
		68763,
		5408,
		40583
	],
	"./modules/jobs/JobCardSettings": [
		57875,
		9,
		57875
	],
	"./modules/jobs/JobCardSettings.tsx": [
		57875,
		9,
		57875
	],
	"./modules/jobs/components/JobCardFilters": [
		84152,
		9,
		84152
	],
	"./modules/jobs/components/JobCardFilters.tsx": [
		84152,
		9,
		84152
	],
	"./modules/jobs/components/JobCardView": [
		41906,
		9,
		20691,
		65239,
		41906
	],
	"./modules/jobs/components/JobCardView.tsx": [
		41906,
		9,
		20691,
		65239,
		41906
	],
	"./modules/jobs/components/JobCards": [
		35610,
		9,
		97285,
		68763,
		35610
	],
	"./modules/jobs/components/JobCards.tsx": [
		35610,
		9,
		97285,
		68763,
		35610
	],
	"./modules/jobs/components/add-job-card/AddJobCard": [
		13191,
		9,
		13191
	],
	"./modules/jobs/components/add-job-card/AddJobCard.tsx": [
		13191,
		9,
		13191
	],
	"./modules/jobs/components/dashboard/JobCardStatistics": [
		88649,
		9,
		88649
	],
	"./modules/jobs/components/dashboard/JobCardStatistics.tsx": [
		88649,
		9,
		88649
	],
	"./modules/jobs/components/dashboard/initialLayout": [
		49593,
		9,
		49593
	],
	"./modules/jobs/components/dashboard/initialLayout.tsx": [
		49593,
		9,
		49593
	],
	"./modules/jobs/components/dashboard/stores/statusStore": [
		94599,
		9,
		94599
	],
	"./modules/jobs/components/dashboard/stores/statusStore.ts": [
		94599,
		9,
		94599
	],
	"./modules/jobs/components/data/JobCard": [
		49806,
		9,
		49806
	],
	"./modules/jobs/components/data/JobCard.ts": [
		49806,
		9,
		49806
	],
	"./modules/jobs/components/job-card-info/CommentSection": [
		34200,
		9,
		34200
	],
	"./modules/jobs/components/job-card-info/CommentSection.tsx": [
		34200,
		9,
		34200
	],
	"./modules/jobs/components/job-card-info/JobCardInfo": [
		68763,
		9,
		97285,
		68763
	],
	"./modules/jobs/components/job-card-info/JobCardInfo.tsx": [
		68763,
		9,
		97285,
		68763
	],
	"./modules/jobs/components/job-card-info/SupervisorsSection": [
		39190,
		9,
		39190
	],
	"./modules/jobs/components/job-card-info/SupervisorsSection.tsx": [
		39190,
		9,
		39190
	],
	"./modules/jobs/components/job-card-info/TaskList": [
		30751,
		9,
		30751
	],
	"./modules/jobs/components/job-card-info/TaskList.tsx": [
		30751,
		9,
		30751
	],
	"./modules/jobs/components/job-card-info/TaskListSection": [
		74222,
		9,
		74222
	],
	"./modules/jobs/components/job-card-info/TaskListSection.tsx": [
		74222,
		9,
		74222
	],
	"./modules/jobs/components/job-card-info/types": [
		92763,
		9,
		92763
	],
	"./modules/jobs/components/job-card-info/types.ts": [
		92763,
		9,
		92763
	],
	"./modules/jobs/components/tables/JobCardCategoryTable": [
		4925,
		9,
		4925
	],
	"./modules/jobs/components/tables/JobCardCategoryTable.tsx": [
		4925,
		9,
		4925
	],
	"./modules/jobs/components/tables/JobCardTable": [
		95477,
		9,
		97285,
		68763,
		95477
	],
	"./modules/jobs/components/tables/JobCardTable.tsx": [
		95477,
		9,
		97285,
		68763,
		95477
	],
	"./modules/jobs/routes": [
		47900,
		9,
		20691,
		65239,
		97285,
		60039,
		68763,
		98268,
		45060,
		5408,
		57875,
		47900
	],
	"./modules/jobs/routes/": [
		47900,
		9,
		20691,
		65239,
		97285,
		60039,
		68763,
		98268,
		45060,
		5408,
		57875,
		47900
	],
	"./modules/jobs/routes/index": [
		47900,
		9,
		20691,
		65239,
		97285,
		60039,
		68763,
		98268,
		45060,
		5408,
		57875,
		47900
	],
	"./modules/jobs/routes/index.tsx": [
		47900,
		9,
		20691,
		65239,
		97285,
		60039,
		68763,
		98268,
		45060,
		5408,
		57875,
		47900
	],
	"./modules/jobs/settings/JobCardCategory": [
		52154,
		9,
		52154
	],
	"./modules/jobs/settings/JobCardCategory.tsx": [
		52154,
		9,
		52154
	],
	"./modules/jobs/settings/JobCardNames": [
		24232,
		9,
		24232
	],
	"./modules/jobs/settings/JobCardNames.tsx": [
		24232,
		9,
		24232
	],
	"./modules/jobs/settings/tables/JobCardCategoryTable": [
		91610,
		9,
		91610
	],
	"./modules/jobs/settings/tables/JobCardCategoryTable.tsx": [
		91610,
		9,
		91610
	],
	"./modules/jobs/settings/tables/JobCardNamesTable": [
		19548,
		9,
		19548
	],
	"./modules/jobs/settings/tables/JobCardNamesTable.tsx": [
		19548,
		9,
		19548
	],
	"./modules/jobs/types": [
		52813,
		9,
		52813
	],
	"./modules/jobs/types/": [
		52813,
		9,
		52813
	],
	"./modules/jobs/types/index": [
		52813,
		9,
		52813
	],
	"./modules/jobs/types/index.tsx": [
		52813,
		9,
		52813
	],
	"./modules/other-job/OtherJob": [
		65834,
		9,
		65834
	],
	"./modules/other-job/OtherJob.tsx": [
		65834,
		9,
		65834
	],
	"./modules/other-job/routes": [
		70986,
		9,
		70986
	],
	"./modules/other-job/routes/": [
		70986,
		9,
		70986
	],
	"./modules/other-job/routes/index": [
		70986,
		9,
		70986
	],
	"./modules/other-job/routes/index.tsx": [
		70986,
		9,
		70986
	],
	"./modules/project/common/data/MemberAvatarGroup": [
		4251,
		9,
		4251
	],
	"./modules/project/common/data/MemberAvatarGroup.tsx": [
		4251,
		9,
		4251
	],
	"./modules/project/common/data/Members": [
		9156,
		9,
		77717
	],
	"./modules/project/common/data/Members.ts": [
		9156,
		9,
		77717
	],
	"./modules/project/common/data/ProjectsData": [
		94906,
		9,
		82128
	],
	"./modules/project/common/data/ProjectsData.ts": [
		94906,
		9,
		82128
	],
	"./modules/project/project-add/ProjectAddBody": [
		47147,
		9,
		69528
	],
	"./modules/project/project-add/ProjectAddBody.tsx": [
		47147,
		9,
		69528
	],
	"./modules/project/project-add/ProjectSettingBody": [
		4614,
		9,
		82233
	],
	"./modules/project/project-add/ProjectSettingBody.tsx": [
		4614,
		9,
		82233
	],
	"./modules/project/project-list/ProjectDetails": [
		69814,
		9,
		20691,
		69993,
		15751,
		22019,
		68255,
		7476,
		98751,
		7710,
		26158,
		54253,
		54030,
		46788,
		44319,
		47132
	],
	"./modules/project/project-list/ProjectDetails.tsx": [
		69814,
		9,
		20691,
		69993,
		15751,
		22019,
		68255,
		7476,
		98751,
		7710,
		26158,
		54253,
		54030,
		46788,
		44319,
		47132
	],
	"./modules/project/project-list/ProjectList": [
		44158,
		9,
		69993,
		82005,
		44158
	],
	"./modules/project/project-list/ProjectList.tsx": [
		44158,
		9,
		69993,
		82005,
		44158
	],
	"./modules/project/project-list/components/ProjectDetailsTab": [
		46788,
		9,
		20691,
		69993,
		15751,
		22019,
		68255,
		7476,
		98751,
		7710,
		26158,
		54253,
		54030,
		46788,
		82128
	],
	"./modules/project/project-list/components/ProjectDetailsTab.tsx": [
		46788,
		9,
		20691,
		69993,
		15751,
		22019,
		68255,
		7476,
		98751,
		7710,
		26158,
		54253,
		54030,
		46788,
		82128
	],
	"./modules/project/project-list/components/ProjectStatistic": [
		11753,
		9,
		69993,
		11753
	],
	"./modules/project/project-list/components/ProjectStatistic.tsx": [
		11753,
		9,
		69993,
		11753
	],
	"./modules/project/project-list/components/ProjectTable": [
		90543,
		9,
		82005
	],
	"./modules/project/project-list/components/ProjectTable.tsx": [
		90543,
		9,
		82005
	],
	"./modules/project/project-list/components/SummarySection": [
		44319,
		9,
		44319,
		82128
	],
	"./modules/project/project-list/components/SummarySection.tsx": [
		44319,
		9,
		44319,
		82128
	],
	"./modules/project/project-list/components/add-task/AddTask": [
		56224,
		9,
		56224
	],
	"./modules/project/project-list/components/add-task/AddTask.tsx": [
		56224,
		9,
		56224
	],
	"./modules/project/project-list/components/add-task/Doc": [
		35756,
		9,
		35756
	],
	"./modules/project/project-list/components/add-task/Doc.tsx": [
		35756,
		9,
		35756
	],
	"./modules/project/project-list/components/add-task/Reminder": [
		51018,
		9,
		51018
	],
	"./modules/project/project-list/components/add-task/Reminder.tsx": [
		51018,
		9,
		51018
	],
	"./modules/project/project-list/components/add-task/Whiteboard": [
		1917,
		9,
		1917
	],
	"./modules/project/project-list/components/add-task/Whiteboard.tsx": [
		1917,
		9,
		1917
	],
	"./modules/project/project-list/components/tabs/activity/Activity": [
		60394,
		9,
		60394
	],
	"./modules/project/project-list/components/tabs/activity/Activity.tsx": [
		60394,
		9,
		60394
	],
	"./modules/project/project-list/components/tabs/calendar/Calendar": [
		4884,
		9,
		4884
	],
	"./modules/project/project-list/components/tabs/calendar/Calendar.tsx": [
		4884,
		9,
		4884
	],
	"./modules/project/project-list/components/tabs/contract/Contract": [
		46508,
		9,
		46508
	],
	"./modules/project/project-list/components/tabs/contract/Contract.tsx": [
		46508,
		9,
		46508
	],
	"./modules/project/project-list/components/tabs/contract/ContractTable": [
		49194,
		9,
		49194
	],
	"./modules/project/project-list/components/tabs/contract/ContractTable.tsx": [
		49194,
		9,
		49194
	],
	"./modules/project/project-list/components/tabs/discussion/Discussion": [
		63364,
		9,
		63364
	],
	"./modules/project/project-list/components/tabs/discussion/Discussion.tsx": [
		63364,
		9,
		63364
	],
	"./modules/project/project-list/components/tabs/discussion/DiscussionTable": [
		2306,
		9,
		2306
	],
	"./modules/project/project-list/components/tabs/discussion/DiscussionTable.tsx": [
		2306,
		9,
		2306
	],
	"./modules/project/project-list/components/tabs/files/Files": [
		66246,
		9,
		66246
	],
	"./modules/project/project-list/components/tabs/files/Files.tsx": [
		66246,
		9,
		66246
	],
	"./modules/project/project-list/components/tabs/files/FilesTable": [
		83980,
		9,
		83980
	],
	"./modules/project/project-list/components/tabs/files/FilesTable.tsx": [
		83980,
		9,
		83980
	],
	"./modules/project/project-list/components/tabs/google/GCalendar": [
		83622,
		9,
		83622
	],
	"./modules/project/project-list/components/tabs/google/GCalendar.tsx": [
		83622,
		9,
		83622
	],
	"./modules/project/project-list/components/tabs/google/GoogleTabs": [
		26158,
		9,
		26158
	],
	"./modules/project/project-list/components/tabs/google/GoogleTabs.tsx": [
		26158,
		9,
		26158
	],
	"./modules/project/project-list/components/tabs/google/tabs/AnySite": [
		49645,
		9,
		49645
	],
	"./modules/project/project-list/components/tabs/google/tabs/AnySite.tsx": [
		49645,
		9,
		49645
	],
	"./modules/project/project-list/components/tabs/google/tabs/Docs": [
		69345,
		9,
		69345
	],
	"./modules/project/project-list/components/tabs/google/tabs/Docs.tsx": [
		69345,
		9,
		69345
	],
	"./modules/project/project-list/components/tabs/google/tabs/GoogleMaps": [
		18080,
		9,
		18080
	],
	"./modules/project/project-list/components/tabs/google/tabs/GoogleMaps.tsx": [
		18080,
		9,
		18080
	],
	"./modules/project/project-list/components/tabs/google/tabs/Sheets": [
		1240,
		9,
		1240
	],
	"./modules/project/project-list/components/tabs/google/tabs/Sheets.tsx": [
		1240,
		9,
		1240
	],
	"./modules/project/project-list/components/tabs/google/tabs/Youtube": [
		59781,
		9,
		59781
	],
	"./modules/project/project-list/components/tabs/google/tabs/Youtube.tsx": [
		59781,
		9,
		59781
	],
	"./modules/project/project-list/components/tabs/milestone/MilestoneTable": [
		15852,
		9,
		15852
	],
	"./modules/project/project-list/components/tabs/milestone/MilestoneTable.tsx": [
		15852,
		9,
		15852
	],
	"./modules/project/project-list/components/tabs/milestone/Milestones": [
		24427,
		9,
		24427
	],
	"./modules/project/project-list/components/tabs/milestone/Milestones.tsx": [
		24427,
		9,
		24427
	],
	"./modules/project/project-list/components/tabs/notes/notes": [
		86594,
		9,
		86594
	],
	"./modules/project/project-list/components/tabs/notes/notes.tsx": [
		86594,
		9,
		86594
	],
	"./modules/project/project-list/components/tabs/overview/Overview": [
		59342,
		9,
		20691,
		69993,
		22019,
		50612
	],
	"./modules/project/project-list/components/tabs/overview/Overview.tsx": [
		59342,
		9,
		20691,
		69993,
		22019,
		50612
	],
	"./modules/project/project-list/components/tabs/overview/OverviewStatistics": [
		90104,
		9,
		69993,
		67723
	],
	"./modules/project/project-list/components/tabs/overview/OverviewStatistics.tsx": [
		90104,
		9,
		69993,
		67723
	],
	"./modules/project/project-list/components/tabs/overview/chart/LoggedHoursChart": [
		10933,
		9,
		22019,
		10933
	],
	"./modules/project/project-list/components/tabs/overview/chart/LoggedHoursChart.tsx": [
		10933,
		9,
		22019,
		10933
	],
	"./modules/project/project-list/components/tabs/purchase/PurchaseSection": [
		54253,
		9,
		54253
	],
	"./modules/project/project-list/components/tabs/purchase/PurchaseSection.tsx": [
		54253,
		9,
		54253
	],
	"./modules/project/project-list/components/tabs/purchase/contract/Contract": [
		58512,
		9,
		58512
	],
	"./modules/project/project-list/components/tabs/purchase/contract/Contract.tsx": [
		58512,
		9,
		58512
	],
	"./modules/project/project-list/components/tabs/purchase/contract/ContractTable": [
		88126,
		9,
		88126
	],
	"./modules/project/project-list/components/tabs/purchase/contract/ContractTable.tsx": [
		88126,
		9,
		88126
	],
	"./modules/project/project-list/components/tabs/purchase/orders/Order": [
		57337,
		9,
		57337
	],
	"./modules/project/project-list/components/tabs/purchase/orders/Order.tsx": [
		57337,
		9,
		57337
	],
	"./modules/project/project-list/components/tabs/purchase/orders/OrderTable": [
		3477,
		9,
		3477
	],
	"./modules/project/project-list/components/tabs/purchase/orders/OrderTable.tsx": [
		3477,
		9,
		3477
	],
	"./modules/project/project-list/components/tabs/purchase/request/RequestTable": [
		8504,
		9,
		8504
	],
	"./modules/project/project-list/components/tabs/purchase/request/RequestTable.tsx": [
		8504,
		9,
		8504
	],
	"./modules/project/project-list/components/tabs/purchase/request/Requests": [
		57071,
		9,
		57071
	],
	"./modules/project/project-list/components/tabs/purchase/request/Requests.tsx": [
		57071,
		9,
		57071
	],
	"./modules/project/project-list/components/tabs/roadmap/RoadMap": [
		98413,
		9,
		68255,
		20794
	],
	"./modules/project/project-list/components/tabs/roadmap/RoadMap.tsx": [
		98413,
		9,
		68255,
		20794
	],
	"./modules/project/project-list/components/tabs/sales/Sales": [
		7710,
		9,
		69993,
		15751,
		98751,
		7710
	],
	"./modules/project/project-list/components/tabs/sales/Sales.tsx": [
		7710,
		9,
		69993,
		15751,
		98751,
		7710
	],
	"./modules/project/project-list/components/tabs/sales/credit-notes/Credit": [
		49619,
		9,
		49619
	],
	"./modules/project/project-list/components/tabs/sales/credit-notes/Credit.tsx": [
		49619,
		9,
		49619
	],
	"./modules/project/project-list/components/tabs/sales/credit-notes/CreditTable": [
		68316,
		9,
		45935
	],
	"./modules/project/project-list/components/tabs/sales/credit-notes/CreditTable.tsx": [
		68316,
		9,
		45935
	],
	"./modules/project/project-list/components/tabs/sales/estimates/EstimateStatistics": [
		85143,
		9,
		69993,
		85143
	],
	"./modules/project/project-list/components/tabs/sales/estimates/EstimateStatistics.tsx": [
		85143,
		9,
		69993,
		85143
	],
	"./modules/project/project-list/components/tabs/sales/estimates/Estimates": [
		98751,
		9,
		69993,
		98751
	],
	"./modules/project/project-list/components/tabs/sales/estimates/Estimates.tsx": [
		98751,
		9,
		69993,
		98751
	],
	"./modules/project/project-list/components/tabs/sales/estimates/EstimatesTable": [
		72203,
		9,
		72203
	],
	"./modules/project/project-list/components/tabs/sales/estimates/EstimatesTable.tsx": [
		72203,
		9,
		72203
	],
	"./modules/project/project-list/components/tabs/sales/expenses/ExpenseTable": [
		50360,
		9,
		50360
	],
	"./modules/project/project-list/components/tabs/sales/expenses/ExpenseTable.tsx": [
		50360,
		9,
		50360
	],
	"./modules/project/project-list/components/tabs/sales/expenses/Expenses": [
		21167,
		9,
		69993,
		15751,
		21167
	],
	"./modules/project/project-list/components/tabs/sales/expenses/Expenses.tsx": [
		21167,
		9,
		69993,
		15751,
		21167
	],
	"./modules/project/project-list/components/tabs/sales/expenses/ExpensesStatistic": [
		1333,
		9,
		69993,
		15751,
		1333
	],
	"./modules/project/project-list/components/tabs/sales/expenses/ExpensesStatistic.tsx": [
		1333,
		9,
		69993,
		15751,
		1333
	],
	"./modules/project/project-list/components/tabs/sales/invoices/Invoice": [
		70748,
		9,
		15751,
		70748
	],
	"./modules/project/project-list/components/tabs/sales/invoices/Invoice.tsx": [
		70748,
		9,
		15751,
		70748
	],
	"./modules/project/project-list/components/tabs/sales/invoices/InvoiceStatistics": [
		80737,
		9,
		15751,
		80737
	],
	"./modules/project/project-list/components/tabs/sales/invoices/InvoiceStatistics.tsx": [
		80737,
		9,
		15751,
		80737
	],
	"./modules/project/project-list/components/tabs/sales/invoices/InvoiceTable": [
		78106,
		9,
		78106
	],
	"./modules/project/project-list/components/tabs/sales/invoices/InvoiceTable.tsx": [
		78106,
		9,
		78106
	],
	"./modules/project/project-list/components/tabs/sales/proposal/Proposals": [
		16838,
		9,
		16838
	],
	"./modules/project/project-list/components/tabs/sales/proposal/Proposals.tsx": [
		16838,
		9,
		16838
	],
	"./modules/project/project-list/components/tabs/sales/proposal/ProposalsTable": [
		67916,
		9,
		67916
	],
	"./modules/project/project-list/components/tabs/sales/proposal/ProposalsTable.tsx": [
		67916,
		9,
		67916
	],
	"./modules/project/project-list/components/tabs/sales/subscription/Subscription": [
		7935,
		9,
		7935
	],
	"./modules/project/project-list/components/tabs/sales/subscription/Subscription.tsx": [
		7935,
		9,
		7935
	],
	"./modules/project/project-list/components/tabs/sales/subscription/SubscriptionTable": [
		95083,
		9,
		95083
	],
	"./modules/project/project-list/components/tabs/sales/subscription/SubscriptionTable.tsx": [
		95083,
		9,
		95083
	],
	"./modules/project/project-list/components/tabs/tasks/TaskInfo": [
		86729,
		9,
		86729
	],
	"./modules/project/project-list/components/tabs/tasks/TaskInfo.tsx": [
		86729,
		9,
		86729
	],
	"./modules/project/project-list/components/tabs/tasks/TaskTable": [
		3629,
		9,
		3629
	],
	"./modules/project/project-list/components/tabs/tasks/TaskTable.tsx": [
		3629,
		9,
		3629
	],
	"./modules/project/project-list/components/tabs/tasks/Tasks": [
		54030,
		9,
		54030,
		31104
	],
	"./modules/project/project-list/components/tabs/tasks/Tasks.tsx": [
		54030,
		9,
		54030,
		31104
	],
	"./modules/project/project-list/components/tabs/tasks/components/TaskAllocationChart": [
		77488,
		9,
		77488
	],
	"./modules/project/project-list/components/tabs/tasks/components/TaskAllocationChart.tsx": [
		77488,
		9,
		77488
	],
	"./modules/project/project-list/components/tabs/tasks/components/TaskStatistics": [
		66225,
		9,
		69993,
		66225
	],
	"./modules/project/project-list/components/tabs/tasks/components/TaskStatistics.tsx": [
		66225,
		9,
		69993,
		66225
	],
	"./modules/project/project-list/components/tabs/tasks/components/TaskSummaryChart": [
		13812,
		9,
		13812
	],
	"./modules/project/project-list/components/tabs/tasks/components/TaskSummaryChart.tsx": [
		13812,
		9,
		13812
	],
	"./modules/project/project-list/components/tabs/tasks/components/data/Task": [
		5549,
		9,
		5549
	],
	"./modules/project/project-list/components/tabs/tasks/components/data/Task.ts": [
		5549,
		9,
		5549
	],
	"./modules/project/project-list/components/tabs/tickets/Tickets": [
		69946,
		9,
		69946
	],
	"./modules/project/project-list/components/tabs/tickets/Tickets.tsx": [
		69946,
		9,
		69946
	],
	"./modules/project/project-list/components/tabs/tickets/TicketsTable": [
		21472,
		9,
		21472
	],
	"./modules/project/project-list/components/tabs/tickets/TicketsTable.tsx": [
		21472,
		9,
		21472
	],
	"./modules/project/project-list/components/tabs/timesheet/TimeTable": [
		19619,
		9,
		35042
	],
	"./modules/project/project-list/components/tabs/timesheet/TimeTable.tsx": [
		19619,
		9,
		35042
	],
	"./modules/project/project-list/components/tabs/timesheet/Timer": [
		84153,
		9
	],
	"./modules/project/project-list/components/tabs/timesheet/Timer.tsx": [
		84153,
		9
	],
	"./modules/project/project-list/components/tabs/timesheet/Timesheet": [
		81426,
		9,
		5064
	],
	"./modules/project/project-list/components/tabs/timesheet/Timesheet.tsx": [
		81426,
		9,
		5064
	],
	"./modules/project/routes": [
		92563,
		9,
		20691,
		69993,
		15751,
		22019,
		68255,
		7476,
		82005,
		98751,
		7710,
		26158,
		54253,
		54030,
		46788,
		44319,
		92563
	],
	"./modules/project/routes/": [
		92563,
		9,
		20691,
		69993,
		15751,
		22019,
		68255,
		7476,
		82005,
		98751,
		7710,
		26158,
		54253,
		54030,
		46788,
		44319,
		92563
	],
	"./modules/project/routes/index": [
		92563,
		9,
		20691,
		69993,
		15751,
		22019,
		68255,
		7476,
		82005,
		98751,
		7710,
		26158,
		54253,
		54030,
		46788,
		44319,
		92563
	],
	"./modules/project/routes/index.tsx": [
		92563,
		9,
		20691,
		69993,
		15751,
		22019,
		68255,
		7476,
		82005,
		98751,
		7710,
		26158,
		54253,
		54030,
		46788,
		44319,
		92563
	],
	"./modules/project/types/types": [
		29931,
		9,
		29931
	],
	"./modules/project/types/types.tsx": [
		29931,
		9,
		29931
	],
	"./modules/purchase/components/order-returns/OrderReturnAdd": [
		1915,
		9,
		86178,
		93889,
		34227,
		1915,
		72603
	],
	"./modules/purchase/components/order-returns/OrderReturnAdd.tsx": [
		1915,
		9,
		86178,
		93889,
		34227,
		1915,
		72603
	],
	"./modules/purchase/components/order-returns/OrderReturnAddTable": [
		32343,
		9,
		86178,
		93889,
		34227,
		32343
	],
	"./modules/purchase/components/order-returns/OrderReturnAddTable.tsx": [
		32343,
		9,
		86178,
		93889,
		34227,
		32343
	],
	"./modules/purchase/components/order-returns/OrderReturns": [
		26381,
		9,
		20691,
		26381
	],
	"./modules/purchase/components/order-returns/OrderReturns.tsx": [
		26381,
		9,
		20691,
		26381
	],
	"./modules/purchase/components/order-returns/OrderReturnsTable": [
		4310,
		9,
		20691,
		81929
	],
	"./modules/purchase/components/order-returns/OrderReturnsTable.tsx": [
		4310,
		9,
		20691,
		81929
	],
	"./modules/purchase/components/order-returns/SerialModel": [
		78681,
		9,
		86178,
		34227,
		78681
	],
	"./modules/purchase/components/order-returns/SerialModel.tsx": [
		78681,
		9,
		86178,
		34227,
		78681
	],
	"./modules/purchase/components/purchase-order/Preview": [
		45686,
		9,
		20691,
		27682,
		45686,
		43901
	],
	"./modules/purchase/components/purchase-order/Preview.tsx": [
		45686,
		9,
		20691,
		27682,
		45686,
		43901
	],
	"./modules/purchase/components/purchase-order/PurchaseOrder": [
		75453,
		9,
		20691,
		27682,
		45686,
		47337
	],
	"./modules/purchase/components/purchase-order/PurchaseOrder.tsx": [
		75453,
		9,
		20691,
		27682,
		45686,
		47337
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderAdd": [
		17988,
		9,
		86178,
		93889,
		34227,
		17988,
		21665
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderAdd.tsx": [
		17988,
		9,
		86178,
		93889,
		34227,
		17988,
		21665
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderAddTable": [
		25762,
		9,
		86178,
		93889,
		34227,
		25762
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderAddTable copy": [
		6039,
		9,
		86178,
		93889,
		34227,
		6039
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderAddTable copy.tsx": [
		6039,
		9,
		86178,
		93889,
		34227,
		6039
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderAddTable.tsx": [
		25762,
		9,
		86178,
		93889,
		34227,
		25762
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderExportView": [
		62148,
		9,
		62148
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderExportView.tsx": [
		62148,
		9,
		62148
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderPDF": [
		77607,
		9,
		27682,
		30923
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderPDF.tsx": [
		77607,
		9,
		27682,
		30923
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderTable": [
		88857,
		9,
		20691,
		27682,
		45686,
		90069
	],
	"./modules/purchase/components/purchase-order/PurchaseOrderTable.tsx": [
		88857,
		9,
		20691,
		27682,
		45686,
		90069
	],
	"./modules/purchase/components/purchase-order/SerialModel": [
		13209,
		9,
		86178,
		34227,
		13209
	],
	"./modules/purchase/components/purchase-order/SerialModel.tsx": [
		13209,
		9,
		86178,
		34227,
		13209
	],
	"./modules/purchase/components/purchase-request/Preview": [
		16353,
		9,
		20691,
		27682,
		33807,
		16353
	],
	"./modules/purchase/components/purchase-request/Preview.tsx": [
		16353,
		9,
		20691,
		27682,
		33807,
		16353
	],
	"./modules/purchase/components/purchase-request/PurchaseRequest": [
		87521,
		9,
		20691,
		27682,
		33807,
		573,
		87521
	],
	"./modules/purchase/components/purchase-request/PurchaseRequest.tsx": [
		87521,
		9,
		20691,
		27682,
		33807,
		573,
		87521
	],
	"./modules/purchase/components/purchase-request/PurchaseRequestAddEdit": [
		83215,
		9,
		86178,
		93889,
		34227,
		8858,
		5596,
		18710
	],
	"./modules/purchase/components/purchase-request/PurchaseRequestAddEdit.tsx": [
		83215,
		9,
		86178,
		93889,
		34227,
		8858,
		5596,
		18710
	],
	"./modules/purchase/components/purchase-request/PurchaseRequestAddEditTable": [
		8858,
		9,
		86178,
		93889,
		34227,
		8858
	],
	"./modules/purchase/components/purchase-request/PurchaseRequestAddEditTable.tsx": [
		8858,
		9,
		86178,
		93889,
		34227,
		8858
	],
	"./modules/purchase/components/purchase-request/PurchaseRequestExportView": [
		17640,
		9,
		17640
	],
	"./modules/purchase/components/purchase-request/PurchaseRequestExportView.tsx": [
		17640,
		9,
		17640
	],
	"./modules/purchase/components/purchase-request/PurchaseRequestPDF": [
		29475,
		9,
		27682,
		33807
	],
	"./modules/purchase/components/purchase-request/PurchaseRequestPDF.tsx": [
		29475,
		9,
		27682,
		33807
	],
	"./modules/purchase/components/purchase-request/PurchaseRequestTable": [
		573,
		9,
		20691,
		27682,
		33807,
		573
	],
	"./modules/purchase/components/purchase-request/PurchaseRequestTable.tsx": [
		573,
		9,
		20691,
		27682,
		33807,
		573
	],
	"./modules/purchase/components/purchase-request/SerialModel": [
		11298,
		9,
		86178,
		34227,
		11298
	],
	"./modules/purchase/components/purchase-request/SerialModel.tsx": [
		11298,
		9,
		86178,
		34227,
		11298
	],
	"./modules/purchase/components/settings/PurchaseSettings": [
		15637,
		9,
		15637
	],
	"./modules/purchase/components/settings/PurchaseSettings.tsx": [
		15637,
		9,
		15637
	],
	"./modules/purchase/components/settings/tabs/Approval": [
		99249,
		9,
		99249
	],
	"./modules/purchase/components/settings/tabs/Approval.tsx": [
		99249,
		9,
		99249
	],
	"./modules/purchase/components/settings/tabs/ApprovalTable": [
		70989,
		9,
		70989
	],
	"./modules/purchase/components/settings/tabs/ApprovalTable.tsx": [
		70989,
		9,
		70989
	],
	"./modules/purchase/components/settings/tabs/CategoryComponent": [
		1475,
		9,
		1475
	],
	"./modules/purchase/components/settings/tabs/CategoryComponent.tsx": [
		1475,
		9,
		1475
	],
	"./modules/purchase/components/settings/tabs/CategoryComponentTable": [
		71167,
		9,
		71167
	],
	"./modules/purchase/components/settings/tabs/CategoryComponentTable.tsx": [
		71167,
		9,
		71167
	],
	"./modules/purchase/components/settings/tabs/CreditComponent": [
		56818,
		9,
		56818
	],
	"./modules/purchase/components/settings/tabs/CreditComponent.tsx": [
		56818,
		9,
		56818
	],
	"./modules/purchase/components/settings/tabs/CreditPeriod": [
		18680,
		9,
		18680
	],
	"./modules/purchase/components/settings/tabs/CreditPeriod.tsx": [
		18680,
		9,
		18680
	],
	"./modules/purchase/components/settings/tabs/CreditPeriodTable": [
		81062,
		9,
		81062
	],
	"./modules/purchase/components/settings/tabs/CreditPeriodTable.tsx": [
		81062,
		9,
		81062
	],
	"./modules/purchase/components/settings/tabs/CreditTable": [
		2031,
		9,
		2031
	],
	"./modules/purchase/components/settings/tabs/CreditTable.tsx": [
		2031,
		9,
		2031
	],
	"./modules/purchase/components/settings/tabs/DescriptionComponent": [
		39931,
		9,
		39931
	],
	"./modules/purchase/components/settings/tabs/DescriptionComponent.tsx": [
		39931,
		9,
		39931
	],
	"./modules/purchase/components/settings/tabs/DescriptionTable": [
		99274,
		9,
		99274
	],
	"./modules/purchase/components/settings/tabs/DescriptionTable.tsx": [
		99274,
		9,
		99274
	],
	"./modules/purchase/components/vendors/VendorTable": [
		70751,
		9,
		70751
	],
	"./modules/purchase/components/vendors/VendorTable.tsx": [
		70751,
		9,
		70751
	],
	"./modules/purchase/components/vendors/Vendors": [
		61104,
		9,
		61104
	],
	"./modules/purchase/components/vendors/Vendors.tsx": [
		61104,
		9,
		61104
	],
	"./modules/purchase/components/vendors/vendor-add/VendorAddBody": [
		80107,
		9,
		80107
	],
	"./modules/purchase/components/vendors/vendor-add/VendorAddBody.tsx": [
		80107,
		9,
		80107
	],
	"./modules/purchase/helpers/DataFormatHelper": [
		99363,
		9,
		99363
	],
	"./modules/purchase/helpers/DataFormatHelper.tsx": [
		99363,
		9,
		99363
	],
	"./modules/purchase/helpers/POReturnHelper": [
		97971,
		9,
		97971
	],
	"./modules/purchase/helpers/POReturnHelper.tsx": [
		97971,
		9,
		97971
	],
	"./modules/purchase/helpers/PurchaseOrderHelper": [
		97387,
		9,
		97387
	],
	"./modules/purchase/helpers/PurchaseOrderHelper.tsx": [
		97387,
		9,
		97387
	],
	"./modules/purchase/helpers/PurchaseRequestHelper": [
		12760,
		9,
		12760
	],
	"./modules/purchase/helpers/PurchaseRequestHelper.tsx": [
		12760,
		9,
		12760
	],
	"./modules/purchase/hooks/usePurchaseOrderItems": [
		70287,
		9,
		70287
	],
	"./modules/purchase/hooks/usePurchaseOrderItems.tsx": [
		70287,
		9,
		70287
	],
	"./modules/purchase/hooks/usePurchaseRequestItems": [
		37454,
		9,
		37454
	],
	"./modules/purchase/hooks/usePurchaseRequestItems.tsx": [
		37454,
		9,
		37454
	],
	"./modules/purchase/hooks/usePurchaseReturnItems": [
		30281,
		9,
		30281
	],
	"./modules/purchase/hooks/usePurchaseReturnItems.tsx": [
		30281,
		9,
		30281
	],
	"./modules/purchase/lang/en": [
		21724,
		9,
		21724
	],
	"./modules/purchase/lang/en.tsx": [
		21724,
		9,
		21724
	],
	"./modules/purchase/routes": [
		26031,
		9,
		20691,
		27682,
		86178,
		93889,
		34227,
		33807,
		45686,
		8858,
		573,
		15637,
		17988,
		1915,
		5596,
		26031
	],
	"./modules/purchase/routes/": [
		26031,
		9,
		20691,
		27682,
		86178,
		93889,
		34227,
		33807,
		45686,
		8858,
		573,
		15637,
		17988,
		1915,
		5596,
		26031
	],
	"./modules/purchase/routes/index": [
		26031,
		9,
		20691,
		27682,
		86178,
		93889,
		34227,
		33807,
		45686,
		8858,
		573,
		15637,
		17988,
		1915,
		5596,
		26031
	],
	"./modules/purchase/routes/index.tsx": [
		26031,
		9,
		20691,
		27682,
		86178,
		93889,
		34227,
		33807,
		45686,
		8858,
		573,
		15637,
		17988,
		1915,
		5596,
		26031
	],
	"./modules/purchase/types/types": [
		52119,
		9,
		52119
	],
	"./modules/purchase/types/types.tsx": [
		52119,
		9,
		52119
	],
	"./modules/requisitions/components/new-requisitions/NewRequisitions": [
		37199,
		9,
		71580,
		37199
	],
	"./modules/requisitions/components/new-requisitions/NewRequisitions.tsx": [
		37199,
		9,
		71580,
		37199
	],
	"./modules/requisitions/components/new-requisitions/components/FinancialRequests": [
		29338,
		9,
		29338
	],
	"./modules/requisitions/components/new-requisitions/components/FinancialRequests.tsx": [
		29338,
		9,
		29338
	],
	"./modules/requisitions/components/new-requisitions/components/HumanResourceRequests": [
		34196,
		9,
		34196
	],
	"./modules/requisitions/components/new-requisitions/components/HumanResourceRequests.tsx": [
		34196,
		9,
		34196
	],
	"./modules/requisitions/components/new-requisitions/components/ITAndTechnicalRequests": [
		89232,
		9,
		89232
	],
	"./modules/requisitions/components/new-requisitions/components/ITAndTechnicalRequests.tsx": [
		89232,
		9,
		89232
	],
	"./modules/requisitions/components/new-requisitions/components/LogisticsAndFleetRequests": [
		1683,
		9,
		1683
	],
	"./modules/requisitions/components/new-requisitions/components/LogisticsAndFleetRequests.tsx": [
		1683,
		9,
		1683
	],
	"./modules/requisitions/components/new-requisitions/components/OperationRequests": [
		71580,
		9,
		71580
	],
	"./modules/requisitions/components/new-requisitions/components/OperationRequests.tsx": [
		71580,
		9,
		71580
	],
	"./modules/requisitions/components/reports/RequisitionsReports": [
		45199,
		9,
		45199
	],
	"./modules/requisitions/components/reports/RequisitionsReports.tsx": [
		45199,
		9,
		45199
	],
	"./modules/requisitions/components/review-requisitions/ReviewRequisitions": [
		46945,
		9,
		28737,
		42138,
		46945
	],
	"./modules/requisitions/components/review-requisitions/ReviewRequisitions.tsx": [
		46945,
		9,
		28737,
		42138,
		46945
	],
	"./modules/requisitions/components/review-requisitions/tables/ReviewRequisitionsTable": [
		42138,
		9,
		28737,
		42138
	],
	"./modules/requisitions/components/review-requisitions/tables/ReviewRequisitionsTable.tsx": [
		42138,
		9,
		28737,
		42138
	],
	"./modules/requisitions/components/settings/RequisitionsSettings": [
		20233,
		9,
		20233
	],
	"./modules/requisitions/components/settings/RequisitionsSettings.tsx": [
		20233,
		9,
		20233
	],
	"./modules/requisitions/routes": [
		61673,
		9,
		28737,
		71580,
		42138,
		61673
	],
	"./modules/requisitions/routes/": [
		61673,
		9,
		28737,
		71580,
		42138,
		61673
	],
	"./modules/requisitions/routes/index": [
		61673,
		9,
		28737,
		71580,
		42138,
		61673
	],
	"./modules/requisitions/routes/index.tsx": [
		61673,
		9,
		28737,
		71580,
		42138,
		61673
	],
	"./modules/sales/assets/images/invoice/paid.png": [
		66260,
		1,
		66260
	],
	"./modules/sales/components/credit-notes/CreditNotes": [
		33522,
		9,
		20691,
		90405,
		33522
	],
	"./modules/sales/components/credit-notes/CreditNotes.tsx": [
		33522,
		9,
		20691,
		90405,
		33522
	],
	"./modules/sales/components/credit-notes/CreditTable": [
		90405,
		9,
		20691,
		90405
	],
	"./modules/sales/components/credit-notes/CreditTable.tsx": [
		90405,
		9,
		20691,
		90405
	],
	"./modules/sales/components/credit-notes/Preview": [
		90116,
		9,
		20691,
		90116
	],
	"./modules/sales/components/credit-notes/Preview.tsx": [
		90116,
		9,
		20691,
		90116
	],
	"./modules/sales/components/credit-notes/credit-add/AddCredit": [
		81772,
		9,
		81772
	],
	"./modules/sales/components/credit-notes/credit-add/AddCredit.tsx": [
		81772,
		9,
		81772
	],
	"./modules/sales/components/credit-notes/credit-add/AddCreditTable": [
		60010,
		9,
		60010
	],
	"./modules/sales/components/credit-notes/credit-add/AddCreditTable.tsx": [
		60010,
		9,
		60010
	],
	"./modules/sales/components/credit-notes/credit-add/MainItemsTable": [
		46055,
		9,
		46055
	],
	"./modules/sales/components/credit-notes/credit-add/MainItemsTable.tsx": [
		46055,
		9,
		46055
	],
	"./modules/sales/components/credit-notes/credit-add/OptionalItemsTable.txt": [
		12500,
		1,
		12500
	],
	"./modules/sales/components/credit-notes/credit-notes-pdf/CreditNotePdf": [
		17294,
		9,
		27682,
		63450
	],
	"./modules/sales/components/credit-notes/credit-notes-pdf/CreditNotePdf.tsx": [
		17294,
		9,
		27682,
		63450
	],
	"./modules/sales/components/credit-notes/tabs/CreditedInvoice": [
		35742,
		9,
		35742
	],
	"./modules/sales/components/credit-notes/tabs/CreditedInvoice.tsx": [
		35742,
		9,
		35742
	],
	"./modules/sales/components/credit-notes/tabs/Refunds": [
		26114,
		9,
		26114
	],
	"./modules/sales/components/credit-notes/tabs/Refunds.tsx": [
		26114,
		9,
		26114
	],
	"./modules/sales/components/credit-notes/tabs/Reminders": [
		97638,
		9,
		97638
	],
	"./modules/sales/components/credit-notes/tabs/Reminders.tsx": [
		97638,
		9,
		97638
	],
	"./modules/sales/components/dashboard/SalesDashboard": [
		28085,
		9,
		28085,
		45369
	],
	"./modules/sales/components/dashboard/SalesDashboard.tsx": [
		28085,
		9,
		28085,
		45369
	],
	"./modules/sales/components/dashboard/components/CustomerPerformChart": [
		28859,
		9,
		28859
	],
	"./modules/sales/components/dashboard/components/CustomerPerformChart.tsx": [
		28859,
		9,
		28859
	],
	"./modules/sales/components/dashboard/components/InvoiceVsPaymentsChart": [
		52313,
		9,
		52313
	],
	"./modules/sales/components/dashboard/components/InvoiceVsPaymentsChart.tsx": [
		52313,
		9,
		52313
	],
	"./modules/sales/components/dashboard/components/SalesAgentChart": [
		55333,
		9,
		55333
	],
	"./modules/sales/components/dashboard/components/SalesAgentChart.tsx": [
		55333,
		9,
		55333
	],
	"./modules/sales/components/dashboard/components/SalesChannelChart": [
		67907,
		9,
		67907
	],
	"./modules/sales/components/dashboard/components/SalesChannelChart.tsx": [
		67907,
		9,
		67907
	],
	"./modules/sales/components/dashboard/components/SalesOverview": [
		13789,
		9,
		13789
	],
	"./modules/sales/components/dashboard/components/SalesOverview.tsx": [
		13789,
		9,
		13789
	],
	"./modules/sales/components/dashboard/components/TrendingProductsChart": [
		78661,
		9,
		78661
	],
	"./modules/sales/components/dashboard/components/TrendingProductsChart.tsx": [
		78661,
		9,
		78661
	],
	"./modules/sales/components/debit-notes/DebitNotes": [
		44498,
		9,
		44498
	],
	"./modules/sales/components/debit-notes/DebitNotes.tsx": [
		44498,
		9,
		44498
	],
	"./modules/sales/components/debit-notes/DebitTable": [
		1381,
		9,
		1381
	],
	"./modules/sales/components/debit-notes/DebitTable.tsx": [
		1381,
		9,
		1381
	],
	"./modules/sales/components/debit-notes/debit-add/AddDebit": [
		79157,
		9,
		79157
	],
	"./modules/sales/components/debit-notes/debit-add/AddDebit.tsx": [
		79157,
		9,
		79157
	],
	"./modules/sales/components/debit-notes/debit-add/AddDebitTable": [
		46001,
		9,
		46001
	],
	"./modules/sales/components/debit-notes/debit-add/AddDebitTable.tsx": [
		46001,
		9,
		46001
	],
	"./modules/sales/components/estimate/Estimate": [
		45995,
		9,
		20691,
		27682,
		76458,
		29993,
		44205
	],
	"./modules/sales/components/estimate/Estimate.tsx": [
		45995,
		9,
		20691,
		27682,
		76458,
		29993,
		44205
	],
	"./modules/sales/components/estimate/EstimateExportView": [
		12386,
		9,
		12386
	],
	"./modules/sales/components/estimate/EstimateExportView.tsx": [
		12386,
		9,
		12386
	],
	"./modules/sales/components/estimate/EstimatePDFWrapper": [
		57720,
		9,
		27682,
		76458,
		57720
	],
	"./modules/sales/components/estimate/EstimatePDFWrapper.tsx": [
		57720,
		9,
		27682,
		76458,
		57720
	],
	"./modules/sales/components/estimate/EstimateTable": [
		18599,
		9,
		20691,
		27682,
		76458,
		29993,
		92065
	],
	"./modules/sales/components/estimate/EstimateTable.tsx": [
		18599,
		9,
		20691,
		27682,
		76458,
		29993,
		92065
	],
	"./modules/sales/components/estimate/Preview": [
		29993,
		9,
		20691,
		27682,
		76458,
		29993,
		76263
	],
	"./modules/sales/components/estimate/Preview.tsx": [
		29993,
		9,
		20691,
		27682,
		76458,
		29993,
		76263
	],
	"./modules/sales/components/estimate/estimate-add/AddEstimate": [
		65439,
		9,
		65439
	],
	"./modules/sales/components/estimate/estimate-add/AddEstimate copy": [
		99784,
		9,
		99784
	],
	"./modules/sales/components/estimate/estimate-add/AddEstimate copy 2.txt": [
		81734,
		1,
		81734
	],
	"./modules/sales/components/estimate/estimate-add/AddEstimate copy.tsx": [
		99784,
		9,
		99784
	],
	"./modules/sales/components/estimate/estimate-add/AddEstimate.tsx": [
		65439,
		9,
		65439
	],
	"./modules/sales/components/estimate/estimate-add/AddEstimateTable": [
		18283,
		9,
		18283
	],
	"./modules/sales/components/estimate/estimate-add/AddEstimateTable.tsx": [
		18283,
		9,
		18283
	],
	"./modules/sales/components/estimate/estimate-add/MainItemsTable": [
		26997,
		9,
		26997
	],
	"./modules/sales/components/estimate/estimate-add/MainItemsTable copy.txt": [
		36812,
		1,
		36812
	],
	"./modules/sales/components/estimate/estimate-add/MainItemsTable.tsx": [
		26997,
		9,
		26997
	],
	"./modules/sales/components/estimate/estimate-add/OptionalItemsTable.txt": [
		59462,
		1,
		59462
	],
	"./modules/sales/components/estimate/estimate-pdf/Estimate_pdf": [
		12830,
		9,
		27682,
		76458
	],
	"./modules/sales/components/estimate/estimate-pdf/Estimate_pdf.tsx": [
		12830,
		9,
		27682,
		76458
	],
	"./modules/sales/components/estimate/tabs/EstimateActivity": [
		89391,
		9,
		89391
	],
	"./modules/sales/components/estimate/tabs/EstimateActivity.tsx": [
		89391,
		9,
		89391
	],
	"./modules/sales/components/estimate/tabs/EstimateNote": [
		21588,
		9,
		21588
	],
	"./modules/sales/components/estimate/tabs/EstimateNote.tsx": [
		21588,
		9,
		21588
	],
	"./modules/sales/components/estimate/tabs/EstimateReminder": [
		96698,
		9,
		96698
	],
	"./modules/sales/components/estimate/tabs/EstimateReminder.tsx": [
		96698,
		9,
		96698
	],
	"./modules/sales/components/estimate/tabs/EstimateTasks": [
		26628,
		9,
		26628
	],
	"./modules/sales/components/estimate/tabs/EstimateTasks.tsx": [
		26628,
		9,
		26628
	],
	"./modules/sales/components/gift-voucher/BarcodePdf": [
		73908,
		9,
		27682,
		59298,
		47776
	],
	"./modules/sales/components/gift-voucher/BarcodePdf.tsx": [
		73908,
		9,
		27682,
		59298,
		47776
	],
	"./modules/sales/components/gift-voucher/GiftVoucher": [
		33100,
		9,
		27682,
		59298,
		33100,
		50477
	],
	"./modules/sales/components/gift-voucher/GiftVoucher.tsx": [
		33100,
		9,
		27682,
		59298,
		33100,
		50477
	],
	"./modules/sales/components/gift-voucher/GiftVoucherPrint": [
		84403,
		9,
		27682,
		59298,
		35359
	],
	"./modules/sales/components/gift-voucher/GiftVoucherPrint.tsx": [
		84403,
		9,
		27682,
		59298,
		35359
	],
	"./modules/sales/components/gift-voucher/GiftVouchersTable": [
		84693,
		9,
		84693
	],
	"./modules/sales/components/gift-voucher/GiftVouchersTable.tsx": [
		84693,
		9,
		84693
	],
	"./modules/sales/components/gift-voucher/NewGiftVoucher": [
		54028,
		9,
		54028
	],
	"./modules/sales/components/gift-voucher/NewGiftVoucher.tsx": [
		54028,
		9,
		54028
	],
	"./modules/sales/components/invoice/Invoice": [
		16369,
		9,
		20691,
		27682,
		43932,
		1955
	],
	"./modules/sales/components/invoice/Invoice.tsx": [
		16369,
		9,
		20691,
		27682,
		43932,
		1955
	],
	"./modules/sales/components/invoice/InvoiceExportView": [
		12856,
		9,
		12856
	],
	"./modules/sales/components/invoice/InvoiceExportView.tsx": [
		12856,
		9,
		12856
	],
	"./modules/sales/components/invoice/InvoicePDFWrapper.txt": [
		1632,
		1,
		1632
	],
	"./modules/sales/components/invoice/InvoiceTable": [
		11821,
		9,
		20691,
		27682,
		43932,
		24607
	],
	"./modules/sales/components/invoice/InvoiceTable copy.txt": [
		97580,
		1,
		97580
	],
	"./modules/sales/components/invoice/InvoiceTable.tsx": [
		11821,
		9,
		20691,
		27682,
		43932,
		24607
	],
	"./modules/sales/components/invoice/PaymentView": [
		8489,
		9,
		8489
	],
	"./modules/sales/components/invoice/PaymentView.tsx": [
		8489,
		9,
		8489
	],
	"./modules/sales/components/invoice/PaymentsTable": [
		70203,
		9,
		70203
	],
	"./modules/sales/components/invoice/PaymentsTable.tsx": [
		70203,
		9,
		70203
	],
	"./modules/sales/components/invoice/Preview": [
		43932,
		9,
		20691,
		27682,
		43932,
		89971
	],
	"./modules/sales/components/invoice/Preview.tsx": [
		43932,
		9,
		20691,
		27682,
		43932,
		89971
	],
	"./modules/sales/components/invoice/invoice-add/AddEditinvoice": [
		84930,
		9,
		84930,
		47378
	],
	"./modules/sales/components/invoice/invoice-add/AddEditinvoice.tsx": [
		84930,
		9,
		84930,
		47378
	],
	"./modules/sales/components/invoice/invoice-add/Addinvoice copy.txt": [
		32593,
		1,
		32593
	],
	"./modules/sales/components/invoice/invoice-add/InvoiceTableAdd": [
		40238,
		9,
		40238
	],
	"./modules/sales/components/invoice/invoice-add/InvoiceTableAdd.tsx": [
		40238,
		9,
		40238
	],
	"./modules/sales/components/invoice/invoice-add/InvoiceTableAdd.txt": [
		17100,
		1,
		17100
	],
	"./modules/sales/components/invoice/invoice-add/MainItemsTable": [
		73727,
		9,
		73727
	],
	"./modules/sales/components/invoice/invoice-add/MainItemsTable copy 2.txt": [
		20056,
		1,
		20056
	],
	"./modules/sales/components/invoice/invoice-add/MainItemsTable copy.txt": [
		41162,
		1,
		41162
	],
	"./modules/sales/components/invoice/invoice-add/MainItemsTable.tsx": [
		73727,
		9,
		73727
	],
	"./modules/sales/components/invoice/invoice-add/OptionalItemsTable.txt": [
		49712,
		1,
		49712
	],
	"./modules/sales/components/invoice/invoice-pdf/Invoice_pdf": [
		4039,
		9,
		27682,
		35851
	],
	"./modules/sales/components/invoice/invoice-pdf/Invoice_pdf.tsx": [
		4039,
		9,
		27682,
		35851
	],
	"./modules/sales/components/invoice/styles/invoiceAddTabStyles.css": [
		88509,
		9,
		88509
	],
	"./modules/sales/components/invoice/tabs/InvoiceActivity": [
		56917,
		9,
		56917
	],
	"./modules/sales/components/invoice/tabs/InvoiceActivity.tsx": [
		56917,
		9,
		56917
	],
	"./modules/sales/components/invoice/tabs/InvoiceNotes": [
		87791,
		9,
		87791
	],
	"./modules/sales/components/invoice/tabs/InvoiceNotes.tsx": [
		87791,
		9,
		87791
	],
	"./modules/sales/components/payments/Payment": [
		33056,
		9,
		33056
	],
	"./modules/sales/components/payments/Payment.tsx": [
		33056,
		9,
		33056
	],
	"./modules/sales/components/payments/PaymentTable": [
		2606,
		9
	],
	"./modules/sales/components/payments/PaymentTable.tsx": [
		2606,
		9
	],
	"./modules/sales/components/performa-invoice/PerformaInvoice": [
		33204,
		9,
		20691,
		15751,
		33204
	],
	"./modules/sales/components/performa-invoice/PerformaInvoice.tsx": [
		33204,
		9,
		20691,
		15751,
		33204
	],
	"./modules/sales/components/performa-invoice/PeroformaTable": [
		80304,
		9,
		20691,
		80304
	],
	"./modules/sales/components/performa-invoice/PeroformaTable.tsx": [
		80304,
		9,
		20691,
		80304
	],
	"./modules/sales/components/performa-invoice/performa-invoice-add/AddPerforma": [
		55593,
		9,
		55593,
		66098
	],
	"./modules/sales/components/performa-invoice/performa-invoice-add/AddPerforma.tsx": [
		55593,
		9,
		55593,
		66098
	],
	"./modules/sales/components/performa-invoice/performa-invoice-add/AddPerformaTable": [
		66853,
		9,
		66853
	],
	"./modules/sales/components/performa-invoice/performa-invoice-add/AddPerformaTable.tsx": [
		66853,
		9,
		66853
	],
	"./modules/sales/components/performa-invoice/performa-invoice-add/MainItemsTable": [
		67593,
		9,
		67593
	],
	"./modules/sales/components/performa-invoice/performa-invoice-add/MainItemsTable.tsx": [
		67593,
		9,
		67593
	],
	"./modules/sales/components/performa-invoice/performa-invoice-add/OptionalItemsTable": [
		73274,
		9,
		73274
	],
	"./modules/sales/components/performa-invoice/performa-invoice-add/OptionalItemsTable.tsx": [
		73274,
		9,
		73274
	],
	"./modules/sales/components/performa-invoice/performa-invoice-pdf/PerformaInvoice": [
		92278,
		9,
		27682,
		21138
	],
	"./modules/sales/components/performa-invoice/performa-invoice-pdf/PerformaInvoice.tsx": [
		92278,
		9,
		27682,
		21138
	],
	"./modules/sales/components/performa-invoice/tabs/PerformActivity": [
		5672,
		9,
		5672
	],
	"./modules/sales/components/performa-invoice/tabs/PerformActivity.tsx": [
		5672,
		9,
		5672
	],
	"./modules/sales/components/performa-invoice/tabs/PerformaNotes": [
		8135,
		9,
		8135
	],
	"./modules/sales/components/performa-invoice/tabs/PerformaNotes.tsx": [
		8135,
		9,
		8135
	],
	"./modules/sales/components/proposals/Proposals": [
		64793,
		9,
		20691,
		64793
	],
	"./modules/sales/components/proposals/Proposals.tsx": [
		64793,
		9,
		20691,
		64793
	],
	"./modules/sales/components/proposals/ProposalsTable": [
		25845,
		9,
		20691,
		25845
	],
	"./modules/sales/components/proposals/ProposalsTable.tsx": [
		25845,
		9,
		20691,
		25845
	],
	"./modules/sales/components/proposals/proposal-add/AddProposal": [
		66888,
		9,
		66888,
		66098
	],
	"./modules/sales/components/proposals/proposal-add/AddProposal.tsx": [
		66888,
		9,
		66888,
		66098
	],
	"./modules/sales/components/proposals/proposal-add/AddProposalTable": [
		52822,
		9,
		52822
	],
	"./modules/sales/components/proposals/proposal-add/AddProposalTable.tsx": [
		52822,
		9,
		52822
	],
	"./modules/sales/components/proposals/proposal-add/MainItemsTable": [
		77084,
		9,
		77084
	],
	"./modules/sales/components/proposals/proposal-add/MainItemsTable.tsx": [
		77084,
		9,
		77084
	],
	"./modules/sales/components/proposals/proposal-add/OptionalItemsTable": [
		29027,
		9,
		29027
	],
	"./modules/sales/components/proposals/proposal-add/OptionalItemsTable.tsx": [
		29027,
		9,
		29027
	],
	"./modules/sales/components/proposals/proposal-pdf/ProposalPdf": [
		82316,
		9,
		27682,
		79592
	],
	"./modules/sales/components/proposals/proposal-pdf/ProposalPdf.tsx": [
		82316,
		9,
		27682,
		79592
	],
	"./modules/sales/components/proposals/tabs/Comment": [
		9472,
		9,
		9472
	],
	"./modules/sales/components/proposals/tabs/Comment.tsx": [
		9472,
		9,
		9472
	],
	"./modules/sales/components/proposals/tabs/Notes": [
		35435,
		9,
		35435
	],
	"./modules/sales/components/proposals/tabs/Notes.tsx": [
		35435,
		9,
		35435
	],
	"./modules/sales/components/proposals/tabs/Remider": [
		41541,
		9,
		41541
	],
	"./modules/sales/components/proposals/tabs/Remider.tsx": [
		41541,
		9,
		41541
	],
	"./modules/sales/components/proposals/tabs/Tasks": [
		51077,
		9,
		51077
	],
	"./modules/sales/components/proposals/tabs/Tasks.tsx": [
		51077,
		9,
		51077
	],
	"./modules/sales/components/proposals/tabs/Templates": [
		62162,
		9,
		62162
	],
	"./modules/sales/components/proposals/tabs/Templates.tsx": [
		62162,
		9,
		62162
	],
	"./modules/sales/components/reports/Report": [
		8332,
		9,
		20620,
		8332
	],
	"./modules/sales/components/reports/Report.tsx": [
		8332,
		9,
		20620,
		8332
	],
	"./modules/sales/components/reports/components/CreditNotesReportTable": [
		41463,
		9,
		41463
	],
	"./modules/sales/components/reports/components/CreditNotesReportTable.tsx": [
		41463,
		9,
		41463
	],
	"./modules/sales/components/reports/components/CustomersReportTable": [
		24960,
		9,
		24960
	],
	"./modules/sales/components/reports/components/CustomersReportTable.tsx": [
		24960,
		9,
		24960
	],
	"./modules/sales/components/reports/components/DailyReportsTable": [
		77155,
		9,
		77155
	],
	"./modules/sales/components/reports/components/DailyReportsTable.tsx": [
		77155,
		9,
		77155
	],
	"./modules/sales/components/reports/components/EstimatesReportTable": [
		51646,
		9,
		51646
	],
	"./modules/sales/components/reports/components/EstimatesReportTable.tsx": [
		51646,
		9,
		51646
	],
	"./modules/sales/components/reports/components/InvoiceReportTable": [
		99330,
		9,
		99330
	],
	"./modules/sales/components/reports/components/InvoiceReportTable.tsx": [
		99330,
		9,
		99330
	],
	"./modules/sales/components/reports/components/PaymentsReceivedTable": [
		8799,
		9,
		8799
	],
	"./modules/sales/components/reports/components/PaymentsReceivedTable.tsx": [
		8799,
		9,
		8799
	],
	"./modules/sales/components/reports/components/ProfitLossReportTable": [
		20620,
		9,
		20620
	],
	"./modules/sales/components/reports/components/ProfitLossReportTable.tsx": [
		20620,
		9,
		20620
	],
	"./modules/sales/components/reports/components/ProposalsReportTable": [
		42606,
		9,
		42606
	],
	"./modules/sales/components/reports/components/ProposalsReportTable.tsx": [
		42606,
		9,
		42606
	],
	"./modules/sales/components/reports/components/SupplierWiseProfitLossReportTable": [
		83228,
		9,
		83228
	],
	"./modules/sales/components/reports/components/SupplierWiseProfitLossReportTable.tsx": [
		83228,
		9,
		83228
	],
	"./modules/sales/helpers/CreditNote": [
		50400,
		9,
		50400
	],
	"./modules/sales/helpers/CreditNote.tsx": [
		50400,
		9,
		50400
	],
	"./modules/sales/helpers/DataFormatHelper": [
		73622,
		9,
		73622
	],
	"./modules/sales/helpers/DataFormatHelper.tsx": [
		73622,
		9,
		73622
	],
	"./modules/sales/helpers/estimate": [
		10033,
		9,
		10033
	],
	"./modules/sales/helpers/estimate.tsx": [
		10033,
		9,
		10033
	],
	"./modules/sales/helpers/invoice": [
		47378,
		9,
		47378
	],
	"./modules/sales/helpers/invoice.tsx": [
		47378,
		9,
		47378
	],
	"./modules/sales/hooks/CreditNoteHook": [
		69664,
		9,
		69664
	],
	"./modules/sales/hooks/CreditNoteHook.tsx": [
		69664,
		9,
		69664
	],
	"./modules/sales/hooks/EstimateHook": [
		61701,
		9,
		61701
	],
	"./modules/sales/hooks/EstimateHook.tsx": [
		61701,
		9,
		61701
	],
	"./modules/sales/hooks/InvoiceHook": [
		46524,
		9,
		46524
	],
	"./modules/sales/hooks/InvoiceHook.tsx": [
		46524,
		9,
		46524
	],
	"./modules/sales/lang/en": [
		65747,
		9,
		65747
	],
	"./modules/sales/lang/en.tsx": [
		65747,
		9,
		65747
	],
	"./modules/sales/routes": [
		79562,
		9,
		20691,
		27682,
		15751,
		59298,
		42280,
		76458,
		43932,
		29993,
		90405,
		20620,
		8332,
		55593,
		66888,
		81772,
		65439,
		84930,
		28085,
		33100,
		33204,
		79562
	],
	"./modules/sales/routes/": [
		79562,
		9,
		20691,
		27682,
		15751,
		59298,
		42280,
		76458,
		43932,
		29993,
		90405,
		20620,
		8332,
		55593,
		66888,
		81772,
		65439,
		84930,
		28085,
		33100,
		33204,
		79562
	],
	"./modules/sales/routes/index": [
		79562,
		9,
		20691,
		27682,
		15751,
		59298,
		42280,
		76458,
		43932,
		29993,
		90405,
		20620,
		8332,
		55593,
		66888,
		81772,
		65439,
		84930,
		28085,
		33100,
		33204,
		79562
	],
	"./modules/sales/routes/index.tsx": [
		79562,
		9,
		20691,
		27682,
		15751,
		59298,
		42280,
		76458,
		43932,
		29993,
		90405,
		20620,
		8332,
		55593,
		66888,
		81772,
		65439,
		84930,
		28085,
		33100,
		33204,
		79562
	],
	"./modules/sales/types/types": [
		5224,
		9,
		5224
	],
	"./modules/sales/types/types.tsx": [
		5224,
		9,
		5224
	],
	"./modules/serial/SerialList": [
		12875,
		9,
		12875
	],
	"./modules/serial/SerialList.tsx": [
		12875,
		9,
		12875
	],
	"./modules/serial/components/SerialDetails": [
		49096,
		9,
		20691,
		27682,
		69993,
		15751,
		93366,
		76458,
		96024,
		4470,
		49096
	],
	"./modules/serial/components/SerialDetails.tsx": [
		49096,
		9,
		20691,
		27682,
		69993,
		15751,
		93366,
		76458,
		96024,
		4470,
		49096
	],
	"./modules/serial/components/SerialTabs": [
		79888,
		9,
		79888
	],
	"./modules/serial/components/SerialTabs.tsx": [
		79888,
		9,
		79888
	],
	"./modules/serial/components/model/AddEditModel": [
		38030,
		9,
		38030
	],
	"./modules/serial/components/model/AddEditModel.tsx": [
		38030,
		9,
		38030
	],
	"./modules/serial/components/tables/SerialTable": [
		59282,
		9,
		59282
	],
	"./modules/serial/components/tables/SerialTable.tsx": [
		59282,
		9,
		59282
	],
	"./modules/serial/components/tabs/SerialOverview": [
		8560,
		9,
		20691,
		8560
	],
	"./modules/serial/components/tabs/SerialOverview.tsx": [
		8560,
		9,
		20691,
		8560
	],
	"./modules/serial/components/tabs/SerialServiceHistory": [
		92574,
		9,
		92574
	],
	"./modules/serial/components/tabs/SerialServiceHistory.tsx": [
		92574,
		9,
		92574
	],
	"./modules/serial/components/tabs/invoices/SerialInvoices": [
		4470,
		9,
		69993,
		15751,
		4470
	],
	"./modules/serial/components/tabs/invoices/SerialInvoices.tsx": [
		4470,
		9,
		69993,
		15751,
		4470
	],
	"./modules/serial/components/tabs/invoices/VehicleInvoicePdf": [
		67573,
		9,
		27682,
		99433
	],
	"./modules/serial/components/tabs/invoices/VehicleInvoicePdf.tsx": [
		67573,
		9,
		27682,
		99433
	],
	"./modules/serial/components/tabs/invoices/VehicleInvoicesTable": [
		67742,
		9,
		67742
	],
	"./modules/serial/components/tabs/invoices/VehicleInvoicesTable.tsx": [
		67742,
		9,
		67742
	],
	"./modules/serial/components/tabs/invoices/estimates/SerialEstimates": [
		97890,
		9,
		20691,
		27682,
		69993,
		15751,
		76458,
		96024,
		89107
	],
	"./modules/serial/components/tabs/invoices/estimates/SerialEstimates.tsx": [
		97890,
		9,
		20691,
		27682,
		69993,
		15751,
		76458,
		96024,
		89107
	],
	"./modules/serial/components/tabs/invoices/estimates/VehicleEstimateTable": [
		96024,
		9,
		20691,
		27682,
		76458,
		96024,
		76263
	],
	"./modules/serial/components/tabs/invoices/estimates/VehicleEstimateTable.tsx": [
		96024,
		9,
		20691,
		27682,
		76458,
		96024,
		76263
	],
	"./modules/serial/components/tabs/invoices/estimates/statistics/EstimateStatistics": [
		44771,
		9,
		69993,
		44771
	],
	"./modules/serial/components/tabs/invoices/estimates/statistics/EstimateStatistics.tsx": [
		44771,
		9,
		69993,
		44771
	],
	"./modules/serial/components/tabs/invoices/statistics/VehicleInvoiceStatistics": [
		42948,
		9,
		69993,
		15751,
		42948
	],
	"./modules/serial/components/tabs/invoices/statistics/VehicleInvoiceStatistics.tsx": [
		42948,
		9,
		69993,
		15751,
		42948
	],
	"./modules/serial/components/tabs/tasks/SerialTasks": [
		80728,
		9,
		80728
	],
	"./modules/serial/components/tabs/tasks/SerialTasks.tsx": [
		80728,
		9,
		80728
	],
	"./modules/serial/components/tabs/tasks/TaskTable": [
		91507,
		9,
		91507
	],
	"./modules/serial/components/tabs/tasks/TaskTable.tsx": [
		91507,
		9,
		91507
	],
	"./modules/serial/components/tabs/tickets/SerialTickets": [
		85740,
		9,
		85740
	],
	"./modules/serial/components/tabs/tickets/SerialTickets.tsx": [
		85740,
		9,
		85740
	],
	"./modules/serial/components/tabs/tickets/TicketsTable": [
		31006,
		9,
		31006
	],
	"./modules/serial/components/tabs/tickets/TicketsTable.tsx": [
		31006,
		9,
		31006
	],
	"./modules/serial/routes": [
		54264,
		9,
		20691,
		27682,
		69993,
		15751,
		93366,
		76458,
		96024,
		4470,
		49096,
		54264
	],
	"./modules/serial/routes/": [
		54264,
		9,
		20691,
		27682,
		69993,
		15751,
		93366,
		76458,
		96024,
		4470,
		49096,
		54264
	],
	"./modules/serial/routes/index": [
		54264,
		9,
		20691,
		27682,
		69993,
		15751,
		93366,
		76458,
		96024,
		4470,
		49096,
		54264
	],
	"./modules/serial/routes/index.tsx": [
		54264,
		9,
		20691,
		27682,
		69993,
		15751,
		93366,
		76458,
		96024,
		4470,
		49096,
		54264
	],
	"./modules/serial/types": [
		94961,
		9,
		94961
	],
	"./modules/serial/types/": [
		94961,
		9,
		94961
	],
	"./modules/serial/types/index": [
		94961,
		9,
		94961
	],
	"./modules/serial/types/index.tsx": [
		94961,
		9,
		94961
	],
	"./modules/service-maintain/Jobs": [
		43960,
		9,
		98268,
		89618
	],
	"./modules/service-maintain/Jobs.tsx": [
		43960,
		9,
		98268,
		89618
	],
	"./modules/service-maintain/ServiceItems": [
		60799,
		9,
		60799
	],
	"./modules/service-maintain/ServiceItems.tsx": [
		60799,
		9,
		60799
	],
	"./modules/service-maintain/job-card-info/CommentSection": [
		99200,
		9,
		99200
	],
	"./modules/service-maintain/job-card-info/CommentSection.tsx": [
		99200,
		9,
		99200
	],
	"./modules/service-maintain/job-card-info/ServiceHistoryModal": [
		98268,
		9,
		98268,
		89321
	],
	"./modules/service-maintain/job-card-info/ServiceHistoryModal.tsx": [
		98268,
		9,
		98268,
		89321
	],
	"./modules/service-maintain/job-card-info/SupervisorsSection": [
		84126,
		9,
		84126
	],
	"./modules/service-maintain/job-card-info/SupervisorsSection.tsx": [
		84126,
		9,
		84126
	],
	"./modules/service-maintain/job-card-info/TaskList": [
		43207,
		9,
		43207
	],
	"./modules/service-maintain/job-card-info/TaskList.tsx": [
		43207,
		9,
		43207
	],
	"./modules/service-maintain/job-card-info/TaskListSection": [
		82870,
		9,
		82870
	],
	"./modules/service-maintain/job-card-info/TaskListSection.tsx": [
		82870,
		9,
		82870
	],
	"./modules/service-maintain/job-card-info/types": [
		25747,
		9,
		25747
	],
	"./modules/service-maintain/job-card-info/types.ts": [
		25747,
		9,
		25747
	],
	"./modules/service-maintain/routes": [
		33875,
		9,
		98268,
		50179
	],
	"./modules/service-maintain/routes/": [
		33875,
		9,
		98268,
		50179
	],
	"./modules/service-maintain/routes/index": [
		33875,
		9,
		98268,
		50179
	],
	"./modules/service-maintain/routes/index.tsx": [
		33875,
		9,
		98268,
		50179
	],
	"./modules/service-maintain/service-tabs/ServiceItemsTabs": [
		45060,
		9,
		20691,
		98268,
		45060,
		49876
	],
	"./modules/service-maintain/service-tabs/ServiceItemsTabs.tsx": [
		45060,
		9,
		20691,
		98268,
		45060,
		49876
	],
	"./modules/service-maintain/service-tabs/tabs/Estimates": [
		14291,
		9,
		98268,
		51459
	],
	"./modules/service-maintain/service-tabs/tabs/Estimates.tsx": [
		14291,
		9,
		98268,
		51459
	],
	"./modules/service-maintain/service-tabs/tabs/Invoice": [
		23671,
		9,
		98268,
		96991
	],
	"./modules/service-maintain/service-tabs/tabs/Invoice.tsx": [
		23671,
		9,
		98268,
		96991
	],
	"./modules/service-maintain/service-tabs/tabs/Overview": [
		30709,
		9,
		20691,
		30709
	],
	"./modules/service-maintain/service-tabs/tabs/Overview.tsx": [
		30709,
		9,
		20691,
		30709
	],
	"./modules/service-maintain/service-tabs/tabs/ServiceHistory": [
		20675,
		9,
		98268,
		59379
	],
	"./modules/service-maintain/service-tabs/tabs/ServiceHistory.tsx": [
		20675,
		9,
		98268,
		59379
	],
	"./modules/service-maintain/tables/JobsTable": [
		63146,
		9,
		98268,
		11588
	],
	"./modules/service-maintain/tables/JobsTable.tsx": [
		63146,
		9,
		98268,
		11588
	],
	"./modules/service-maintain/tables/ServiceItemsTable": [
		66503,
		9,
		66503
	],
	"./modules/service-maintain/tables/ServiceItemsTable.tsx": [
		66503,
		9,
		66503
	],
	"./modules/setting/lang/en": [
		10899,
		9,
		10899
	],
	"./modules/setting/lang/en.tsx": [
		10899,
		9,
		10899
	],
	"./modules/setting/predifined-notes/client-note/ClientNote": [
		66992,
		9
	],
	"./modules/setting/predifined-notes/client-note/ClientNote.tsx": [
		66992,
		9
	],
	"./modules/setting/predifined-notes/client-note/ClientNoteTable": [
		90302,
		9
	],
	"./modules/setting/predifined-notes/client-note/ClientNoteTable.tsx": [
		90302,
		9
	],
	"./modules/setting/predifined-notes/terms-conditions/TermsConditions": [
		11194,
		9
	],
	"./modules/setting/predifined-notes/terms-conditions/TermsConditions.tsx": [
		11194,
		9
	],
	"./modules/setting/predifined-notes/terms-conditions/TermsConditionsTable": [
		93056,
		9
	],
	"./modules/setting/predifined-notes/terms-conditions/TermsConditionsTable.tsx": [
		93056,
		9
	],
	"./modules/setting/routes": [
		93162,
		9
	],
	"./modules/setting/routes/": [
		93162,
		9
	],
	"./modules/setting/routes/index": [
		93162,
		9
	],
	"./modules/setting/routes/index.tsx": [
		93162,
		9
	],
	"./modules/setting/user-management/department/Department": [
		95660,
		9
	],
	"./modules/setting/user-management/department/Department.tsx": [
		95660,
		9
	],
	"./modules/setting/user-management/department/DepartmentTable": [
		79914,
		9
	],
	"./modules/setting/user-management/department/DepartmentTable.tsx": [
		79914,
		9
	],
	"./modules/setting/user-management/role/AddEditRole": [
		41619,
		9
	],
	"./modules/setting/user-management/role/AddEditRole copy": [
		64348,
		9,
		64348
	],
	"./modules/setting/user-management/role/AddEditRole copy.tsx": [
		64348,
		9,
		64348
	],
	"./modules/setting/user-management/role/AddEditRole.tsx": [
		41619,
		9
	],
	"./modules/setting/user-management/role/Role": [
		94464,
		9
	],
	"./modules/setting/user-management/role/Role.tsx": [
		94464,
		9
	],
	"./modules/setting/user-management/role/RoleTable": [
		8462,
		9
	],
	"./modules/setting/user-management/role/RoleTable.tsx": [
		8462,
		9
	],
	"./modules/setting/user-management/types": [
		44397,
		9,
		44397
	],
	"./modules/setting/user-management/types/": [
		44397,
		9,
		44397
	],
	"./modules/setting/user-management/types/index": [
		44397,
		9,
		44397
	],
	"./modules/setting/user-management/types/index.tsx": [
		44397,
		9,
		44397
	],
	"./modules/setting/user-management/users/Users": [
		17598,
		9
	],
	"./modules/setting/user-management/users/Users.tsx": [
		17598,
		9
	],
	"./modules/setting/user-management/users/UsersTable": [
		53924,
		9
	],
	"./modules/setting/user-management/users/UsersTable.tsx": [
		53924,
		9
	],
	"./modules/setting/user-management/users/add-user/AddUser": [
		32410,
		9
	],
	"./modules/setting/user-management/users/add-user/AddUser.tsx": [
		32410,
		9
	],
	"./modules/ticket/AddTicket": [
		67454,
		9,
		67454
	],
	"./modules/ticket/AddTicket.tsx": [
		67454,
		9,
		67454
	],
	"./modules/ticket/Ticket": [
		53079,
		9,
		53079
	],
	"./modules/ticket/Ticket.tsx": [
		53079,
		9,
		53079
	],
	"./modules/ticket/TicketDetails": [
		80521,
		9,
		62011,
		80521
	],
	"./modules/ticket/TicketDetails.tsx": [
		80521,
		9,
		62011,
		80521
	],
	"./modules/ticket/TicketTabs": [
		62011,
		9,
		62011
	],
	"./modules/ticket/TicketTabs.tsx": [
		62011,
		9,
		62011
	],
	"./modules/ticket/TicketsTable": [
		9690,
		9,
		9690
	],
	"./modules/ticket/TicketsTable.tsx": [
		9690,
		9,
		9690
	],
	"./modules/ticket/data/TicketData": [
		60076,
		9,
		60076
	],
	"./modules/ticket/data/TicketData.ts": [
		60076,
		9,
		60076
	],
	"./modules/ticket/routes": [
		53516,
		9,
		20691,
		53516
	],
	"./modules/ticket/routes/": [
		53516,
		9,
		20691,
		53516
	],
	"./modules/ticket/routes/index": [
		53516,
		9,
		20691,
		53516
	],
	"./modules/ticket/routes/index.tsx": [
		53516,
		9,
		20691,
		53516
	],
	"./modules/ticket/tabs/AddNote": [
		58759,
		9,
		58759
	],
	"./modules/ticket/tabs/AddNote.tsx": [
		58759,
		9,
		58759
	],
	"./modules/ticket/tabs/AddReply": [
		14991,
		9,
		14991
	],
	"./modules/ticket/tabs/AddReply.tsx": [
		14991,
		9,
		14991
	],
	"./modules/ticket/tabs/OtherTicket": [
		58904,
		9,
		58904
	],
	"./modules/ticket/tabs/OtherTicket.tsx": [
		58904,
		9,
		58904
	],
	"./modules/ticket/tabs/TicketForm": [
		23862,
		9,
		20691,
		23862
	],
	"./modules/ticket/tabs/TicketForm.tsx": [
		23862,
		9,
		20691,
		23862
	],
	"./modules/ticket/tabs/TicketReminder": [
		33358,
		9,
		33358
	],
	"./modules/ticket/tabs/TicketReminder.tsx": [
		33358,
		9,
		33358
	],
	"./modules/ticket/tabs/TicketTasks": [
		46208,
		9,
		46208
	],
	"./modules/ticket/tabs/TicketTasks.tsx": [
		46208,
		9,
		46208
	],
	"./modules/ticket/tabs/components/OtherTable": [
		46851,
		9,
		46851
	],
	"./modules/ticket/tabs/components/OtherTable.tsx": [
		46851,
		9,
		46851
	],
	"./modules/ticket/tabs/components/ReminderTable": [
		7487,
		9,
		7487
	],
	"./modules/ticket/tabs/components/ReminderTable.tsx": [
		7487,
		9,
		7487
	],
	"./modules/ticket/tabs/components/TicketTaskTable": [
		49776,
		9,
		49776
	],
	"./modules/ticket/tabs/components/TicketTaskTable.tsx": [
		49776,
		9,
		49776
	],
	"./modules/timesheets/components/attendance/Attendance": [
		45138,
		9,
		45138
	],
	"./modules/timesheets/components/attendance/Attendance.tsx": [
		45138,
		9,
		45138
	],
	"./modules/timesheets/components/dashboard/TimesheetsDashboard": [
		70567,
		9,
		22019,
		70567
	],
	"./modules/timesheets/components/dashboard/TimesheetsDashboard.tsx": [
		70567,
		9,
		22019,
		70567
	],
	"./modules/timesheets/components/dashboard/components/CheckInChart": [
		97250,
		9,
		22019,
		97250
	],
	"./modules/timesheets/components/dashboard/components/CheckInChart.tsx": [
		97250,
		9,
		22019,
		97250
	],
	"./modules/timesheets/components/dashboard/components/DigitalizationStatus": [
		87035,
		9,
		87035
	],
	"./modules/timesheets/components/dashboard/components/DigitalizationStatus.tsx": [
		87035,
		9,
		87035
	],
	"./modules/timesheets/components/dashboard/components/EmployeeMovementChart": [
		9868,
		9,
		22019,
		9868
	],
	"./modules/timesheets/components/dashboard/components/EmployeeMovementChart.tsx": [
		9868,
		9,
		22019,
		9868
	],
	"./modules/timesheets/components/dashboard/components/HeadcountChart": [
		45440,
		9,
		22019,
		45440
	],
	"./modules/timesheets/components/dashboard/components/HeadcountChart.tsx": [
		45440,
		9,
		22019,
		45440
	],
	"./modules/timesheets/components/dashboard/components/LeaveBreakdown": [
		21727,
		9,
		21727
	],
	"./modules/timesheets/components/dashboard/components/LeaveBreakdown.tsx": [
		21727,
		9,
		21727
	],
	"./modules/timesheets/components/dashboard/components/LeaveChart": [
		76646,
		9,
		22019,
		76646
	],
	"./modules/timesheets/components/dashboard/components/LeaveChart.tsx": [
		76646,
		9,
		22019,
		76646
	],
	"./modules/timesheets/components/dashboard/components/MapView": [
		98184,
		9,
		98184
	],
	"./modules/timesheets/components/dashboard/components/MapView.tsx": [
		98184,
		9,
		98184
	],
	"./modules/timesheets/components/dashboard/components/OnLeave": [
		35737,
		9,
		35737
	],
	"./modules/timesheets/components/dashboard/components/OnLeave.tsx": [
		35737,
		9,
		35737
	],
	"./modules/timesheets/components/dashboard/components/OrganizationActivity": [
		33675,
		9,
		33675
	],
	"./modules/timesheets/components/dashboard/components/OrganizationActivity.tsx": [
		33675,
		9,
		33675
	],
	"./modules/timesheets/components/dashboard/components/PendingRequests": [
		19946,
		9,
		19946
	],
	"./modules/timesheets/components/dashboard/components/PendingRequests.tsx": [
		19946,
		9,
		19946
	],
	"./modules/timesheets/components/dashboard/components/TimesheetAnnouncement": [
		2192,
		9,
		2192
	],
	"./modules/timesheets/components/dashboard/components/TimesheetAnnouncement.tsx": [
		2192,
		9,
		2192
	],
	"./modules/timesheets/components/dashboard/components/TimesheetsMenu": [
		80127,
		9,
		80127
	],
	"./modules/timesheets/components/dashboard/components/TimesheetsMenu.tsx": [
		80127,
		9,
		80127
	],
	"./modules/timesheets/components/leave/Leave": [
		90258,
		9,
		90258
	],
	"./modules/timesheets/components/leave/Leave.tsx": [
		90258,
		9,
		90258
	],
	"./modules/timesheets/components/leave/LeaveDetails": [
		44138,
		9,
		20691,
		44138
	],
	"./modules/timesheets/components/leave/LeaveDetails.tsx": [
		44138,
		9,
		20691,
		44138
	],
	"./modules/timesheets/components/leave/common/data/LeaveData": [
		61731,
		9,
		61731
	],
	"./modules/timesheets/components/leave/common/data/LeaveData.ts": [
		61731,
		9,
		61731
	],
	"./modules/timesheets/components/leave/tables/LeaveApplicationTable": [
		51130,
		9,
		51130
	],
	"./modules/timesheets/components/leave/tables/LeaveApplicationTable.tsx": [
		51130,
		9,
		51130
	],
	"./modules/timesheets/components/my-info/MyInfo": [
		33607,
		9,
		33607
	],
	"./modules/timesheets/components/my-info/MyInfo.tsx": [
		33607,
		9,
		33607
	],
	"./modules/timesheets/components/my-info/components/BuzzLatestPosts": [
		62435,
		9,
		62435
	],
	"./modules/timesheets/components/my-info/components/BuzzLatestPosts.tsx": [
		62435,
		9,
		62435
	],
	"./modules/timesheets/components/my-info/components/EmployeesOnLeaveToday": [
		25552,
		9,
		25552
	],
	"./modules/timesheets/components/my-info/components/EmployeesOnLeaveToday.tsx": [
		25552,
		9,
		25552
	],
	"./modules/timesheets/components/my-info/components/MyActions": [
		84103,
		9,
		84103
	],
	"./modules/timesheets/components/my-info/components/MyActions.tsx": [
		84103,
		9,
		84103
	],
	"./modules/timesheets/components/my-info/components/QuickLaunch": [
		41828,
		9,
		41828
	],
	"./modules/timesheets/components/my-info/components/QuickLaunch.tsx": [
		41828,
		9,
		41828
	],
	"./modules/timesheets/components/my-info/components/TimeAtWork": [
		20685,
		9,
		20685
	],
	"./modules/timesheets/components/my-info/components/TimeAtWork.tsx": [
		20685,
		9,
		20685
	],
	"./modules/timesheets/components/reports/Reports": [
		78858,
		9,
		78858
	],
	"./modules/timesheets/components/reports/Reports.tsx": [
		78858,
		9,
		78858
	],
	"./modules/timesheets/components/settings/TimesheetsSettings": [
		229,
		9,
		48969,
		85167,
		229
	],
	"./modules/timesheets/components/settings/TimesheetsSettings.tsx": [
		229,
		9,
		48969,
		85167,
		229
	],
	"./modules/timesheets/components/settings/settings-tabs/ApprovalProcess": [
		65588,
		9,
		48969,
		85167,
		65588
	],
	"./modules/timesheets/components/settings/settings-tabs/ApprovalProcess.tsx": [
		65588,
		9,
		48969,
		85167,
		65588
	],
	"./modules/timesheets/components/settings/settings-tabs/Holidays": [
		87445,
		9,
		87445
	],
	"./modules/timesheets/components/settings/settings-tabs/Holidays.tsx": [
		87445,
		9,
		87445
	],
	"./modules/timesheets/components/settings/settings-tabs/NormsOfLeave": [
		47625,
		9,
		47625
	],
	"./modules/timesheets/components/settings/settings-tabs/NormsOfLeave.tsx": [
		47625,
		9,
		47625
	],
	"./modules/timesheets/components/settings/settings-tabs/TypesOfLeave": [
		68887,
		9,
		48969,
		85167,
		68887
	],
	"./modules/timesheets/components/settings/settings-tabs/TypesOfLeave.tsx": [
		68887,
		9,
		48969,
		85167,
		68887
	],
	"./modules/timesheets/components/settings/settings-tabs/tables/ApprovalProcessTable": [
		45150,
		9,
		45150
	],
	"./modules/timesheets/components/settings/settings-tabs/tables/ApprovalProcessTable.tsx": [
		45150,
		9,
		45150
	],
	"./modules/timesheets/components/settings/settings-tabs/tables/HolidaysTable": [
		82085,
		9,
		82085
	],
	"./modules/timesheets/components/settings/settings-tabs/tables/HolidaysTable.tsx": [
		82085,
		9,
		82085
	],
	"./modules/timesheets/components/settings/settings-tabs/tables/NormsOfLeaveTable": [
		83561,
		9,
		83561
	],
	"./modules/timesheets/components/settings/settings-tabs/tables/NormsOfLeaveTable.tsx": [
		83561,
		9,
		83561
	],
	"./modules/timesheets/components/settings/settings-tabs/tables/TypesOfLeaveTable": [
		90175,
		9,
		90175
	],
	"./modules/timesheets/components/settings/settings-tabs/tables/TypesOfLeaveTable.tsx": [
		90175,
		9,
		90175
	],
	"./modules/timesheets/components/shift-type/ShiftType": [
		46315,
		9,
		46315
	],
	"./modules/timesheets/components/shift-type/ShiftType.tsx": [
		46315,
		9,
		46315
	],
	"./modules/timesheets/components/shift/Shift": [
		51014,
		9,
		51014
	],
	"./modules/timesheets/components/shift/Shift.tsx": [
		51014,
		9,
		51014
	],
	"./modules/timesheets/components/work-routes/WorkRoutes": [
		75067,
		9,
		75067
	],
	"./modules/timesheets/components/work-routes/WorkRoutes.tsx": [
		75067,
		9,
		75067
	],
	"./modules/timesheets/components/work-shift-table/WorkShiftTable": [
		40334,
		9,
		40334
	],
	"./modules/timesheets/components/work-shift-table/WorkShiftTable.tsx": [
		40334,
		9,
		40334
	],
	"./modules/timesheets/components/workplace/Workplace": [
		59898,
		9,
		59898
	],
	"./modules/timesheets/components/workplace/Workplace.tsx": [
		59898,
		9,
		59898
	],
	"./modules/timesheets/routes": [
		57845,
		9,
		57845
	],
	"./modules/timesheets/routes/": [
		57845,
		9,
		57845
	],
	"./modules/timesheets/routes/index": [
		57845,
		9,
		57845
	],
	"./modules/timesheets/routes/index.tsx": [
		57845,
		9,
		57845
	],
	"./modules/vehicle/Vehicle": [
		86809,
		9,
		86809
	],
	"./modules/vehicle/Vehicle.tsx": [
		86809,
		9,
		86809
	],
	"./modules/vehicle/VehicleDetails": [
		19259,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		92606,
		51738,
		2932,
		19259
	],
	"./modules/vehicle/VehicleDetails.tsx": [
		19259,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		92606,
		51738,
		2932,
		19259
	],
	"./modules/vehicle/components copy/VehicleTabs": [
		54451,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		45515,
		57841,
		54451
	],
	"./modules/vehicle/components copy/VehicleTabs.tsx": [
		54451,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		45515,
		57841,
		54451
	],
	"./modules/vehicle/components copy/model/AddEditModel": [
		3793,
		9,
		3793
	],
	"./modules/vehicle/components copy/model/AddEditModel.tsx": [
		3793,
		9,
		3793
	],
	"./modules/vehicle/components copy/tables/VehicleTable": [
		31985,
		9,
		31985
	],
	"./modules/vehicle/components copy/tables/VehicleTable.tsx": [
		31985,
		9,
		31985
	],
	"./modules/vehicle/components copy/tabs/Overview": [
		41737,
		9,
		20691,
		41737
	],
	"./modules/vehicle/components copy/tabs/Overview.tsx": [
		41737,
		9,
		20691,
		41737
	],
	"./modules/vehicle/components copy/tabs/ServiceHistory": [
		33775,
		9,
		97285,
		68763,
		33775
	],
	"./modules/vehicle/components copy/tabs/ServiceHistory.tsx": [
		33775,
		9,
		97285,
		68763,
		33775
	],
	"./modules/vehicle/components copy/tabs/invoices/VehicleInvoicePdf": [
		33236,
		9,
		27682,
		34016
	],
	"./modules/vehicle/components copy/tabs/invoices/VehicleInvoicePdf.tsx": [
		33236,
		9,
		27682,
		34016
	],
	"./modules/vehicle/components copy/tabs/invoices/VehicleInvoices": [
		57841,
		9,
		69993,
		15751,
		57841
	],
	"./modules/vehicle/components copy/tabs/invoices/VehicleInvoices.tsx": [
		57841,
		9,
		69993,
		15751,
		57841
	],
	"./modules/vehicle/components copy/tabs/invoices/VehicleInvoicesTable": [
		21677,
		9,
		21677
	],
	"./modules/vehicle/components copy/tabs/invoices/VehicleInvoicesTable.tsx": [
		21677,
		9,
		21677
	],
	"./modules/vehicle/components copy/tabs/invoices/estimates/VehicleEstimate": [
		80703,
		9,
		20691,
		27682,
		69993,
		15751,
		76458,
		45515,
		90793
	],
	"./modules/vehicle/components copy/tabs/invoices/estimates/VehicleEstimate.tsx": [
		80703,
		9,
		20691,
		27682,
		69993,
		15751,
		76458,
		45515,
		90793
	],
	"./modules/vehicle/components copy/tabs/invoices/estimates/VehicleEstimateTable": [
		45515,
		9,
		20691,
		27682,
		76458,
		45515,
		76263
	],
	"./modules/vehicle/components copy/tabs/invoices/estimates/VehicleEstimateTable.tsx": [
		45515,
		9,
		20691,
		27682,
		76458,
		45515,
		76263
	],
	"./modules/vehicle/components copy/tabs/invoices/estimates/statistics/EstimateStatistics": [
		56650,
		9,
		69993,
		56650
	],
	"./modules/vehicle/components copy/tabs/invoices/estimates/statistics/EstimateStatistics.tsx": [
		56650,
		9,
		69993,
		56650
	],
	"./modules/vehicle/components copy/tabs/invoices/statistics/VehicleInvoiceStatistics": [
		75333,
		9,
		69993,
		15751,
		75333
	],
	"./modules/vehicle/components copy/tabs/invoices/statistics/VehicleInvoiceStatistics.tsx": [
		75333,
		9,
		69993,
		15751,
		75333
	],
	"./modules/vehicle/components/VehicleDetails": [
		85276,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		45515,
		57841,
		54451,
		85276
	],
	"./modules/vehicle/components/VehicleDetails.tsx": [
		85276,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		45515,
		57841,
		54451,
		85276
	],
	"./modules/vehicle/components/VehicleTabs": [
		2932,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		92606,
		51738,
		2932
	],
	"./modules/vehicle/components/VehicleTabs.tsx": [
		2932,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		92606,
		51738,
		2932
	],
	"./modules/vehicle/components/model/AddEditModel": [
		62915,
		9,
		85296
	],
	"./modules/vehicle/components/model/AddEditModel.tsx": [
		62915,
		9,
		85296
	],
	"./modules/vehicle/components/tables/VehicleTable": [
		76614,
		9,
		76614
	],
	"./modules/vehicle/components/tables/VehicleTable.tsx": [
		76614,
		9,
		76614
	],
	"./modules/vehicle/components/tabs/Overview": [
		63078,
		9,
		20691,
		63078
	],
	"./modules/vehicle/components/tabs/Overview.tsx": [
		63078,
		9,
		20691,
		63078
	],
	"./modules/vehicle/components/tabs/ServiceHistory": [
		36516,
		9,
		97285,
		68763,
		36516
	],
	"./modules/vehicle/components/tabs/ServiceHistory.tsx": [
		36516,
		9,
		97285,
		68763,
		36516
	],
	"./modules/vehicle/components/tabs/invoices/VehicleInvoicePdf": [
		69567,
		9,
		27682,
		81235
	],
	"./modules/vehicle/components/tabs/invoices/VehicleInvoicePdf.tsx": [
		69567,
		9,
		27682,
		81235
	],
	"./modules/vehicle/components/tabs/invoices/VehicleInvoices": [
		51738,
		9,
		69993,
		15751,
		51738
	],
	"./modules/vehicle/components/tabs/invoices/VehicleInvoices.tsx": [
		51738,
		9,
		69993,
		15751,
		51738
	],
	"./modules/vehicle/components/tabs/invoices/VehicleInvoicesTable": [
		52160,
		9,
		52160
	],
	"./modules/vehicle/components/tabs/invoices/VehicleInvoicesTable.tsx": [
		52160,
		9,
		52160
	],
	"./modules/vehicle/components/tabs/invoices/estimates/VehicleEstimate": [
		79811,
		9,
		20691,
		27682,
		69993,
		15751,
		76458,
		92606,
		3777
	],
	"./modules/vehicle/components/tabs/invoices/estimates/VehicleEstimate.tsx": [
		79811,
		9,
		20691,
		27682,
		69993,
		15751,
		76458,
		92606,
		3777
	],
	"./modules/vehicle/components/tabs/invoices/estimates/VehicleEstimateTable": [
		92606,
		9,
		20691,
		27682,
		76458,
		92606,
		76263
	],
	"./modules/vehicle/components/tabs/invoices/estimates/VehicleEstimateTable.tsx": [
		92606,
		9,
		20691,
		27682,
		76458,
		92606,
		76263
	],
	"./modules/vehicle/components/tabs/invoices/estimates/statistics/EstimateStatistics": [
		23933,
		9,
		69993,
		23933
	],
	"./modules/vehicle/components/tabs/invoices/estimates/statistics/EstimateStatistics.tsx": [
		23933,
		9,
		69993,
		23933
	],
	"./modules/vehicle/components/tabs/invoices/statistics/VehicleInvoiceStatistics": [
		98262,
		9,
		69993,
		15751,
		98262
	],
	"./modules/vehicle/components/tabs/invoices/statistics/VehicleInvoiceStatistics.tsx": [
		98262,
		9,
		69993,
		15751,
		98262
	],
	"./modules/vehicle/components/types": [
		28922,
		9,
		28922
	],
	"./modules/vehicle/components/types/": [
		28922,
		9,
		28922
	],
	"./modules/vehicle/components/types/index": [
		28922,
		9,
		28922
	],
	"./modules/vehicle/components/types/index.tsx": [
		28922,
		9,
		28922
	],
	"./modules/vehicle/routes": [
		4410,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		92606,
		51738,
		2932,
		4410
	],
	"./modules/vehicle/routes/": [
		4410,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		92606,
		51738,
		2932,
		4410
	],
	"./modules/vehicle/routes/index": [
		4410,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		92606,
		51738,
		2932,
		4410
	],
	"./modules/vehicle/routes/index.tsx": [
		4410,
		9,
		20691,
		27682,
		69993,
		15751,
		97285,
		93366,
		76458,
		68763,
		92606,
		51738,
		2932,
		4410
	],
	"./modules/vehicle/types": [
		65111,
		9,
		65111
	],
	"./modules/vehicle/types/": [
		65111,
		9,
		65111
	],
	"./modules/vehicle/types/index": [
		65111,
		9,
		65111
	],
	"./modules/vehicle/types/index.tsx": [
		65111,
		9,
		65111
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 80327;
module.exports = webpackAsyncContext;